import { debounce, throttle } from 'throttle-debounce';
import { compact, range } from 'lodash';
import { dateUtils } from '@opengeoweb/shared';
import { parseISO, isValid, add, sub, isWithinInterval } from 'date-fns';
import moment from 'moment';
import proj4 from 'proj4';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var WMEmptyLayerName = 'empty_layer';
var WMEmptyLayerTitle = 'empty layer';
var WMDateOutSideRange = 'outside range';
var WMDateTooEarlyString = 'date too early';
var WMDateTooLateString = 'date too late';
var WMSVersion = {
  version100: '1.0.0',
  version111: '1.1.1',
  version130: '1.3.0'
};
var WMProj4Defs = [['EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'], ['EPSG:4269', '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees'], ['EPSG:3575', '+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs'], ['EPSG:3785', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs'], ['EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs'], ['EPSG:3411', '+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs'], ['EPSG:3412', '+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs'], ['EPSG:28992', '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +no_defs  <>'], ['EPSG:32661', '+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs'], ['EPSG:102100', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs'], ['EPSG:3067', '+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs']];
var epsgDescriptionLookup = {
  'EPSG:3411': 'NSIDC Sea Ice Polar Stereographic North',
  'EPSG:3412': 'NSIDC Sea Ice Polar Stereographic South',
  'EPSG:3575': 'Lambert azimuthal equal-area projection Europe',
  'EPSG:3785': 'Mercator (deprecated)',
  'EPSG:3857': 'Mercator',
  'EPSG:4258': 'ETRS89',
  'EPSG:4326': 'World Lat lon WGS84',
  'CRS:84': 'World Lat lon WGS84',
  'EPSG:25831': 'ETRS89 / UTM zone 31N',
  'EPSG:25832': 'ETRS89 / UTM zone 32N',
  'EPSG:28992': 'Dutch Amersfoort / RD New',
  'EPSG:32661': 'Polar Stereographic WGS 84 / UPS North',
  'EPSG:3067': 'ETRS89 / TM35FIN(E,N) -- Finland'
};
var mapImageStoreLength = 1000;
var bgImageStoreLength = 360;
var legendImageStoreLength = 500;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* debug helper */
var enableConsoleDebugging = false;
var DebugType;
(function (DebugType) {
  DebugType[DebugType["Log"] = 0] = "Log";
  DebugType[DebugType["Warning"] = 1] = "Warning";
  DebugType[DebugType["Error"] = 2] = "Error";
})(DebugType || (DebugType = {}));
var debugLogger = function debugLogger(type, message) {
};
/**
 * Checks if variable is defined or not
 * @param variable The variable to check
 * @returns true if variable is indeed defined, otherwise false.
 */
var isDefined = function isDefined(variable) {
  if (variable === null) {
    return false;
  }
  if (typeof variable === 'undefined') {
    return false;
  }
  return true;
};
/**
 * Converts a variable to an array. If the variable is not an array it will be pushed as the first entry in a new array. If the variable is already an array, nothing will  be done.
 * @param array The variable to convert
 * @returns Always an array
 */
var toArray = function toArray(array) {
  if (array === null || typeof array === 'undefined') {
    return [];
  }
  if (array instanceof Array) {
    return array;
  }
  var newArray = [];
  newArray[0] = array;
  return newArray;
};
/**
 * Function which checks wether URL contains a ? token. If not, it is assumed that this token was not provided by the user,
 * manually add the token later.
 * @param url The URL to check
 * @return the fixed URL
 */
var WMJScheckURL = function WMJScheckURL(url) {
  if (!isDefined(url)) {
    return '?';
  }
  var trimmedUrl = url.trim();
  if (trimmedUrl.indexOf('?') === -1) {
    return "".concat(trimmedUrl, "?");
  }
  return trimmedUrl;
};
var preventdefaultEvent = function preventdefaultEvent(e) {
  var event = e || window.event;
  if (event.preventDefault) {
    // Firefox
    event.preventDefault();
  } else {
    // IE
    event.returnValue = false;
  }
};
var getMouseXCoordinate = function getMouseXCoordinate(event) {
  return event.clientX + document.documentElement.scrollLeft + document.body.scrollLeft;
};
var getMouseYCoordinate = function getMouseYCoordinate(event) {
  return event.clientY + document.documentElement.scrollTop + document.body.scrollTop;
};
var URLDecode = function URLDecode(encodedURL) {
  if (!isDefined(encodedURL)) {
    return '';
  }
  return encodedURL.replace('+', ' ').replace('%2B', '+').replace('%20', ' ').replace('%5E', '^').replace('%26', '&').replace('%3F', '?').replace('%3E', '>').replace('%3C', '<').replace('%5C', '\\').replace('%2F', '/').replace('%25', '%').replace('%3A', ':').replace('%27', "'").replace('%24', '$');
};
// Encodes plain text to URL encoding
var URLEncode = function URLEncode(plaintext) {
  if (!plaintext) {
    return plaintext;
  }
  if (plaintext === undefined) {
    return plaintext;
  }
  if (plaintext === '') {
    return plaintext;
  }
  var SAFECHARS = '0123456789' +
  // Numeric
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
  // Alphabetic
  'abcdefghijklmnopqrstuvwxyz' + "%-_.!~*'()"; // RFC2396 Mark characters
  var HEX = '0123456789ABCDEF';
  var replacedText = plaintext.replace(/%/g, '%25').replace(/\+/g, '%2B').replace(/ /g, '%20').replace(/\^/g, '%5E').replace(/&/g, '%26').replace(/\?/g, '%3F').replace(/>/g, '%3E').replace(/</g, '%3C').replace(/\\/g, '%5C');
  var encoded = '';
  for (var i = 0; i < replacedText.length; i += 1) {
    var ch = replacedText.charAt(i);
    if (ch === ' ') {
      encoded += '%20'; // x-www-urlencoded, rather than %20
    } else if (SAFECHARS.indexOf(ch) !== -1) {
      encoded += ch;
    } else {
      var charCode = ch.charCodeAt(0);
      if (charCode > 255) {
        debugLogger(DebugType.Warning);
        encoded += '+';
      } else {
        encoded += '%';
        // eslint-disable-next-line no-bitwise
        encoded += HEX.charAt(charCode >> 4 & 0xf);
        // eslint-disable-next-line no-bitwise
        encoded += HEX.charAt(charCode & 0xf);
      }
    }
  }
  return encoded;
};
/* Adds DIM_ for certain dims */
var getCorrectWMSDimName = function getCorrectWMSDimName(origDimName) {
  /* Adds DIM_ for dimensions other than height or time */
  var upperCaseDimName = origDimName.toUpperCase();
  if (upperCaseDimName === 'TIME') {
    return upperCaseDimName;
  }
  if (upperCaseDimName === 'ELEVATION') {
    return upperCaseDimName;
  }
  return "DIM_".concat(upperCaseDimName);
};
/* Returns all dimensions with its current values as URL */
var getMapDimURL = function getMapDimURL(layer, dimensionOverride) {
  var request = '';
  layer.dimensions.forEach(function (layerDimension) {
    var overrideDim = dimensionOverride && dimensionOverride.find(function (d) {
      return d.name === layerDimension.name;
    });
    var dimension = layerDimension;
    var currentValue = overrideDim && dimension.getClosestValue(overrideDim.currentValue, true) || dimension.currentValue;
    request += "&".concat(getCorrectWMSDimName(dimension.name));
    request += "=".concat(URLEncode(currentValue));
    if (currentValue === WMDateOutSideRange || currentValue === WMDateTooEarlyString || currentValue === WMDateTooLateString) {
      throw new Error(WMDateOutSideRange);
    }
  });
  return request;
};
/**
 * Parses url and then it it allows for setting / changing key value pairs in that URL (From https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter)
 * @param baseUrl
 * @param params
 * @returns
 */
var getUriWithParam = function getUriWithParam(baseUrl,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
params) {
  var Url = new URL(baseUrl);
  var urlParams = new URLSearchParams(Url.search);
  for (var key in params) {
    if (params[key] !== undefined) {
      urlParams.set(key, params[key]);
    }
  }
  Url.search = urlParams.toString();
  return Url.toString();
};
/**
 * Parses url and then it it allows for setting additional key value pairs in that URL (From https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter)
 * @param baseUrl
 * @param params
 * @returns
 */
var getUriAddParam = function getUriAddParam(baseUrl,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
params) {
  var Url = new URL(baseUrl);
  var urlParams = new URLSearchParams(Url.search);
  // Create search params all lowercase so we can compare to the params passed in
  var lowerCaseUrlParams = new URLSearchParams();
  var _iterator = _createForOfIteratorHelper(urlParams.keys()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      lowerCaseUrlParams.append(key.toLowerCase(), 'tempval');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  Object.keys(params).forEach(function (key) {
    if (params[key] !== undefined && !lowerCaseUrlParams.has(key.toLowerCase())) {
      urlParams.set(key, params[key]);
    }
  });
  Url.search = urlParams.toString();
  return Url.toString();
};
/**
 * Converts a JS date to a ISO8601 string
 * @param date
 * @returns ISO8601 string
 */
var dateToISO8601 = function dateToISO8601(date) {
  var prf = function prf(input, width) {
    // print decimal with fixed length (preceding zero's)
    var string = "".concat(input);
    var len = width - string.length;
    var j;
    var zeros = '';
    for (j = 0; j < len; j += 1) {
      zeros += "0".concat(zeros);
    }
    string = zeros + string;
    return string;
  };
  var iso = "".concat(prf(date.getUTCFullYear(), 4), "-").concat(prf(date.getUTCMonth() + 1, 2), "-").concat(prf(date.getUTCDate(), 2), "T").concat(prf(date.getUTCHours(), 2), ":").concat(prf(date.getUTCMinutes(), 2), ":").concat(prf(date.getUTCSeconds(), 2), "Z");
  return iso;
};
/**
 * Helper function to figure out the styles from the WMS layer object from the WMS GetCapabilties document
 * @param layerObjectFromWMS The layer object from the WMS GetCapabilities JSON document
 * @returns Style[] Array of style objects.
 */
var addStylesForLayer = function addStylesForLayer(layerObjectFromWMS) {
  /* Get the Style object */
  if (!layerObjectFromWMS.Style) {
    return [];
  }
  var layerStyles = toArray(layerObjectFromWMS.Style);
  /* Loop through the list of styles from the document, create a default object and try to fill in the object with the props from the WMS GetCapabilities document */
  return layerStyles.map(function (layerStyle) {
    var style = {
      title: 'default',
      name: 'default',
      legendURL: '',
      "abstract": 'No abstract available'
    };
    try {
      style.title = layerStyle.Title.value;
    } catch (e) {
      /* Do nothing */
    }
    try {
      style.name = layerStyle.Name.value;
    } catch (e) {
      /* Do nothing */
    }
    try {
      style.legendURL = layerStyle.LegendURL.OnlineResource.attr['xlink:href'];
    } catch (e) {
      /* Do nothing */
    }
    try {
      style["abstract"] = layerStyle.Abstract.value;
    } catch (e) {
      /* Do nothing */
    }
    return style;
  });
};
var addDimensionsForLayer = function addDimensionsForLayer(layerObjectFromWMS) {
  if (!layerObjectFromWMS.Dimension) {
    return [];
  }
  var layerDimensions = toArray(layerObjectFromWMS.Dimension);
  var layerDimensionsExtents = toArray(layerObjectFromWMS.Extent);
  var dimensionList = layerDimensions.map(function (layerDimension) {
    var dimensionName = layerDimension.attr && layerDimension.attr.name.toLowerCase();
    /* Find corresponding Dimension Extent if given */
    var dimExtentIndex = layerDimensionsExtents.findIndex(function (layerDimensionsExtent) {
      var extentName = layerDimensionsExtent.attr && layerDimensionsExtent.attr.name && layerDimensionsExtent.attr.name.toLowerCase();
      return dimensionName === extentName;
    });
    var dimExtent = dimExtentIndex !== -1 ? layerDimensionsExtents[dimExtentIndex] : null;
    var dimensionValues = dimExtent && dimExtent.value || layerDimension.value || '';
    var dimensionCurrentValue = dimExtent && dimExtent.attr && dimExtent.attr["default"] || layerDimension.attr["default"] || '';
    return {
      name: dimensionName,
      units: layerDimension.attr.units,
      currentValue: dimensionCurrentValue.trim(),
      unitSymbol: layerDimension.attr.unitSymbol,
      values: dimensionValues.trim()
    };
  });
  return dimensionList;
};
var addBoundingBoxForLayer = function addBoundingBoxForLayer(layerObjectFromWMS) {
  var _a, _b, _c, _d;
  if (layerObjectFromWMS.EX_GeographicBoundingBox) {
    var layerBbox = layerObjectFromWMS.EX_GeographicBoundingBox;
    return {
      east: (_a = layerBbox.eastBoundLongitude) === null || _a === void 0 ? void 0 : _a.value,
      west: (_b = layerBbox.westBoundLongitude) === null || _b === void 0 ? void 0 : _b.value,
      north: (_c = layerBbox.northBoundLatitude) === null || _c === void 0 ? void 0 : _c.value,
      south: (_d = layerBbox.southBoundLatitude) === null || _d === void 0 ? void 0 : _d.value
    };
  }
  if (layerObjectFromWMS.LatLonBoundingBox) {
    var _layerBbox = layerObjectFromWMS.LatLonBoundingBox;
    return {
      east: _layerBbox.attr.maxx,
      west: _layerBbox.attr.minx,
      north: _layerBbox.attr.maxy,
      south: _layerBbox.attr.miny
    };
  }
  return undefined;
};
/**
 * Sorts an array with objects by object key.
 *
 * @param array Array of objects
 * @param key The key of the object to use for sorting
 * @returns Sorted array.
 */
function sortArrayOfObjectsByKey(array, key) {
  var spreadArray = _toConsumableArray(array);
  return spreadArray.sort(function (a, b) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var x = a[key];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var y = b[key];
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  });
}
/**
 * A LayerTree with deeply nested children will be flattened into a 1D array. Children properties are removed and result is sorted alphabetically by the layers title.
 * @param layerTree a WMS LayerTree
 * @returns Flat array of layers as LayerProps[]
 */
var flattenLayerTree = function flattenLayerTree(layerTree) {
  var omit = function omit(prop, _a) {
    var _b = prop;
      _a[_b];
      var rest = __rest(_a, [_typeof(_b) === "symbol" ? _b : _b + ""]);
    return rest;
  };
  var recurseLayerTree = function recurseLayerTree(data) {
    return data && Array.isArray(data) ? data.reduce(function (acc, item) {
      item.name && acc.push(omit('children', item));
      item.children && acc.push.apply(acc, _toConsumableArray(recurseLayerTree(item.children)));
      return acc;
    }, []) : [];
  };
  var flatLayerObject = recurseLayerTree(layerTree.children);
  return sortArrayOfObjectsByKey(flatLayerObject, 'title');
};
/**
 * Makes a LayerProps object from the WMSLayerFromGetCapabilities and nestedLayerPath
 * @param layer WMSLayerFromGetCapabilities
 * @param path The path of the layer in the WMS GetCapabilities tree (Array of strings)
 * @param isleaf Is this a group layer or an actual layer
 * @param nestedLayerPath The path of the layer in the WMS GetCapabilities, in this case array of LayerProps
 * @returns
 */
var makeNodeLayerFromWMSGetCapabilityLayer = function makeNodeLayerFromWMSGetCapabilityLayer(layer) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isleaf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var nestedLayerPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var geographicBoundingBox = nestedLayerPath.reverse().reduce(function (p, c) {
    return p || c.geographicBoundingBox;
  }, addBoundingBoxForLayer(layer));
  var dimensions = nestedLayerPath.reverse().reduce(function (p, c) {
    if (p && Array.isArray(p) && p.length > 0) {
      return p;
    }
    return c.dimensions || [];
  }, addDimensionsForLayer(layer));
  var styles = nestedLayerPath.reverse().reduce(function (p, c) {
    if (c.styles && Array.isArray(c.styles) && c.styles.length) {
      return c.styles.concat(p);
    }
    return p;
  }, addStylesForLayer(layer));
  var queryable = layer.attr ? parseInt(layer.attr.queryable, 10) === 1 : false;
  var crs = layer.BoundingBox && Array.isArray(layer.BoundingBox) && layer.BoundingBox.length ? compact(layer.BoundingBox.map(function (wmsBBOX) {
    if (wmsBBOX.attr) {
      var crsName = wmsBBOX.attr.CRS || wmsBBOX.attr.SRS;
      return {
        name: crsName,
        bbox: {
          left: parseFloat(wmsBBOX.attr.minx),
          right: parseFloat(wmsBBOX.attr.maxx),
          bottom: parseFloat(wmsBBOX.attr.miny),
          top: parseFloat(wmsBBOX.attr.maxy)
        }
      };
    }
    return undefined;
  })) : [];
  var layerName = layer.Name ? layer.Name.value : null;
  var layerTitle = layer.Title ? layer.Title.value : layerName;
  return {
    name: layerName,
    title: layerTitle || 'Layer',
    leaf: isleaf,
    path: path,
    keywords: toArray(layer.KeywordList && layer.KeywordList.Keyword).map(function (keywords) {
      return keywords.value;
    }),
    "abstract": layer.Abstract ? layer.Abstract.value : undefined,
    styles: styles,
    dimensions: dimensions,
    geographicBoundingBox: geographicBoundingBox,
    queryable: queryable,
    crs: crs
  };
};
/**
 * Builds a standardized LayerTree object based on WMSLayerFromGetCapabilities object.
 * @param wmsLayer The WMSLayerFromGetCapabilities object
 * @param nestedPath - Optional, only to be used by buildLayerTreeFromNestedWMSLayer
 * @param nestedLayerPath - Optional, only to be used by buildLayerTreeFromNestedWMSLayer
 * @returns A LayerTree object.
 */
var buildLayerTreeFromNestedWMSLayer = function buildLayerTreeFromNestedWMSLayer(wmsLayer) {
  var nestedPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var nestedLayerPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var isleaf = wmsLayer.Name && !wmsLayer.Layer;
  var layerProps = makeNodeLayerFromWMSGetCapabilityLayer(wmsLayer, nestedPath, isleaf, nestedLayerPath);
  var pathName = wmsLayer.Title && wmsLayer.Title.value || '';
  var layerTree = Object.assign(Object.assign({}, layerProps), {
    children: []
  });
  if (wmsLayer.Layer) {
    var childLayers = wmsLayer.Layer['length'] ? wmsLayer.Layer : [wmsLayer.Layer];
    layerTree.children = sortArrayOfObjectsByKey(childLayers.map(function (layerChild) {
      return buildLayerTreeFromNestedWMSLayer(layerChild, [].concat(_toConsumableArray(nestedPath), [pathName]), [].concat(_toConsumableArray(nestedLayerPath), [layerProps]));
    }), 'title');
  }
  return layerTree;
};

/**
 * Returns the current time in ms
 * @returns the current time in ms
 */
var getCurrentImageTime = function getCurrentImageTime() {
  return new Date().getTime();
};
/**
 * WMImage provides an API to the HTML image element. It is used for caching and easier access to images.
 */
var WMImage = /*#__PURE__*/function () {
  /**
   *
   * @param src Optionally set the source URL to load
   * @param callback Optionally set the callback function to trigger once image has loaded
   * @param options Additional options to the image. You can set { randomizer: true } to force unique url's and prevent caching.
   */
  function WMImage(src, callback, options) {
    var _this = this;
    _classCallCheck(this, WMImage);
    this.randomize = false;
    this._srcLoaded = undefined;
    this._isLoaded = undefined;
    this._isLoading = undefined;
    this._hasError = undefined;
    this._imageTimeStampAtError = getCurrentImageTime();
    this._numFailedAttempts = 0;
    this.srcToLoad = src;
    this.loadEventCallback = callback;
    this.el = new Image();
    this.headers = [];
    if (isDefined(options) && isDefined(options.randomizer)) {
      this.randomize = options.randomizer;
    }
    this.init = this.init.bind(this);
    this.isLoaded = this.isLoaded.bind(this);
    this.isLoading = this.isLoading.bind(this);
    this.setSource = this.setSource.bind(this);
    this.clear = this.clear.bind(this);
    this.getSrc = this.getSrc.bind(this);
    this.hasError = this.hasError.bind(this);
    this._load = this._load.bind(this);
    this.load = this.load.bind(this);
    this.forceReload = this.forceReload.bind(this);
    this.getLastErrorMSecondsAgo = this.getLastErrorMSecondsAgo.bind(this);
    this.getNumFailedAttempts = this.getNumFailedAttempts.bind(this);
    this._loadEvent = this._loadEvent.bind(this);
    this.getWidth = this.getWidth.bind(this);
    this.getHeight = this.getHeight.bind(this);
    this.getElement = this.getElement.bind(this);
    this._getImageWithHeaders = this._getImageWithHeaders.bind(this);
    this.init();
    this.el.addEventListener('load', function () {
      _this._loadEvent(false);
    });
    this.el.addEventListener('error', function () {
      _this._imageTimeStampAtError = getCurrentImageTime();
      _this._numFailedAttempts += 1;
      _this._loadEvent(true);
    });
    this.el.onselectstart = function () {
      return false;
    };
    this.el.ondrag = function () {
      return false;
    };
  }
  _createClass(WMImage, [{
    key: "init",
    value: function init() {
      this._srcLoaded = 'undefined image';
      this._isLoaded = false;
      this._isLoading = false;
      this._hasError = false;
      this._numFailedAttempts = 0;
      this._imageTimeStampAtError = getCurrentImageTime();
    }
    /**
     * Returns true if the image has been loaded
     */
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      if (this._isLoading) {
        return false;
      }
      return this._isLoaded;
    }
  }, {
    key: "isLoadedWithoutErrors",
    value: function isLoadedWithoutErrors() {
      return this.isLoaded() && !this.hasError();
    }
  }, {
    key: "hasNotStartedLoading",
    value: function hasNotStartedLoading() {
      return !this._isLoaded && !this._isLoading;
    }
    /**
     * Returns true if the image is still loading
     */
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this._isLoading;
    }
    /**
     * Get the amount of milliseconds since the image experienced an image load.
     * @returns milliseconds since the image had an error
     */
  }, {
    key: "getLastErrorMSecondsAgo",
    value: function getLastErrorMSecondsAgo() {
      return getCurrentImageTime() - this._imageTimeStampAtError;
    }
    /**
     * @returns The number of failed attempts for this image
     */
  }, {
    key: "getNumFailedAttempts",
    value: function getNumFailedAttempts() {
      return this._numFailedAttempts;
    }
    /**
     * Set source of image, but it will not load the image yet.
     * @param src URL of the image to load
     * @param options WMImageOptions to give to the image
     */
  }, {
    key: "setSource",
    value: function setSource(src, options) {
      if (this._isLoading) {
        debugLogger(DebugType.Error);
        return;
      }
      this.srcToLoad = src;
      if (options && options.headers && options.headers.length > 0) {
        this.headers = options.headers;
      }
      if (this._srcLoaded === this.srcToLoad) {
        this._isLoaded = true;
        return;
      }
      this._numFailedAttempts = 0;
      this._imageTimeStampAtError = getCurrentImageTime();
      this._isLoaded = false;
    }
    /**
     * Re-intialize the image
     */
  }, {
    key: "clear",
    value: function clear() {
      this.init();
    }
    /**
     * Get the URL of the image
     */
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.srcToLoad;
    }
    /**
     * Check if the image has an error
     */
  }, {
    key: "hasError",
    value: function hasError() {
      return this._hasError;
    }
    /**
     * Start loading the image
     */
  }, {
    key: "load",
    value: function load() {
      this._load();
    }
  }, {
    key: "forceReload",
    value: function forceReload() {
      this._isLoaded = false;
      this._srcLoaded = undefined;
      this._load();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "_getImageWithHeaders",
    value: function _getImageWithHeaders(url, headers) {
      var _this2 = this;
      var fetchHeaders = new Headers();
      if (headers && headers.length > 0) {
        for (var j = 0; j < headers.length; j += 1) {
          fetchHeaders.append(headers[j].name, headers[j].value);
        }
      }
      var options = {
        method: 'GET',
        headers: fetchHeaders,
        mode: 'cors',
        cache: 'default'
      };
      var request = new Request(url);
      var arrayBufferToBase64 = function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = [].slice.call(new Uint8Array(buffer));
        bytes.forEach(function (b) {
          binary += String.fromCharCode(b);
        });
        return window.btoa(binary);
      };
      fetch(request, options).then(function (response) {
        response.arrayBuffer().then(function (buffer) {
          var base64Flag = 'data:image/png;base64,';
          var imageStr = arrayBufferToBase64(buffer);
          _this2.getElement().src = base64Flag + imageStr;
        });
      })["catch"](function () {
        debugLogger(DebugType.Error, "Unable to fetch image ".concat(url, " with headers [").concat(JSON.stringify(headers), "]"));
        if (url.startsWith('http://')) {
          debugLogger(DebugType.Error);
        }
        _this2._loadEvent(true);
      });
    }
  }, {
    key: "_load",
    value: function _load() {
      var _a;
      this._hasError = false;
      if (this._isLoaded === true) {
        this._loadEvent(false);
        return;
      }
      this._isLoading = true;
      if (!this.srcToLoad) {
        this._loadEvent(true);
        return;
      }
      /* Allow relative URL's */
      if (this.srcToLoad.startsWith('/') && !this.srcToLoad.startsWith('//')) {
        var splittedHREF = window.location.href.split('/').filter(function (e) {
          return e.length > 0;
        });
        var hostName = "".concat(splittedHREF[0], "//").concat(splittedHREF[1], "/");
        this.srcToLoad = hostName + this.srcToLoad;
      }
      /*
       * If the image has already loaded this source succesfully (without error), simply trigger the loadevent.
       */
      if (this.srcToLoad === this._srcLoaded && !this._hasError) {
        this._loadEvent(false);
        return;
      }
      if ((_a = this.headers) === null || _a === void 0 ? void 0 : _a.length) {
        /* Get an image which needs headers */
        this._getImageWithHeaders(this.srcToLoad, this.headers);
      } else if (this.randomize) {
        /* Do a standard img.src url request */
        var newSrc = this.srcToLoad;
        if (this.srcToLoad.indexOf('?') === -1) {
          newSrc += '?';
        }
        newSrc += "random=".concat(Math.random());
        this.getElement().src = newSrc;
      } else {
        // setting src loads the image and the 'load' callback is called when its finished loading
        this.getElement().src = this.srcToLoad;
      }
    }
  }, {
    key: "_loadEvent",
    value: function _loadEvent(hasError) {
      var _a;
      this._hasError = hasError;
      this._isLoading = false;
      this._isLoaded = true;
      this._srcLoaded = this.srcToLoad;
      (_a = this.loadEventCallback) === null || _a === void 0 ? void 0 : _a.call(this, this);
    }
    /**
     * Get the width of the current image
     */
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.el.width;
    }
    /**
     * Get the height of the current image
     */
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.el.height;
    }
    /**
     * Get the HTMLImageElement behind the WMImage
     */
  }, {
    key: "getElement",
    value: function getElement() {
      return this.el;
    }
  }]);
  return WMImage;
}();

var WMImageEventType;
(function (WMImageEventType) {
  WMImageEventType[WMImageEventType["Loaded"] = 0] = "Loaded";
  WMImageEventType[WMImageEventType["Deleted"] = 1] = "Deleted";
})(WMImageEventType || (WMImageEventType = {}));
var WMImageStore = /*#__PURE__*/function () {
  /**
   * Constructs a new WMImageStore with given amount of image cache.
   * @param {*} maxNumberOfImages
   * @param {*} options
   */
  function WMImageStore(maxNumberOfImages, options) {
    _classCallCheck(this, WMImageStore);
    this.imagesbysrc = new Map();
    this.imageLife = 0;
    this._imageLifeCounter = 0;
    this._loadEventCallbackList = []; // Array of callbacks, as multiple instances can register listeners
    this._maxNumberOfImages = maxNumberOfImages;
    this._options = options;
    this.emptyImage = new WMImage(null, null, null);
    this.imageLoadEventCallback = this.imageLoadEventCallback.bind(this);
    this.getImageForSrc = this.getImageForSrc.bind(this);
    this.clear = this.clear.bind(this);
    this.addImageEventCallback = this.addImageEventCallback.bind(this);
    this.removeAllEventCallbacks = this.removeAllEventCallbacks.bind(this);
    this.getNumImagesLoading = this.getNumImagesLoading.bind(this);
    this.getImage = this.getImage.bind(this);
    this.load = this.load.bind(this);
  }
  _createClass(WMImageStore, [{
    key: "load",
    value: function load(imageUrl) {
      return this.getImage(imageUrl).load();
    }
  }, {
    key: "imageLoadEventCallback",
    value: function imageLoadEventCallback(_img, imageEventType) {
      for (var j = 0; j < this._loadEventCallbackList.length; j += 1) {
        this._loadEventCallbackList[j].callback(_img, this._loadEventCallbackList[j].id, imageEventType);
      }
    }
    /**
     * Check if we have similar images with the same source in the pipeline
     */
  }, {
    key: "getImageForSrc",
    value: function getImageForSrc(src) {
      return this.imagesbysrc.get(src);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.imagesbysrc.forEach(function (wmImage) {
        wmImage.clear();
      });
      this.imagesbysrc.clear();
    }
  }, {
    key: "addImageEventCallback",
    value: function addImageEventCallback(callback, id) {
      if (!id) {
        debugLogger(DebugType.Error);
        return;
      }
      if (!callback) {
        debugLogger(DebugType.Error);
        return;
      }
      this._loadEventCallbackList.push({
        id: id,
        callback: callback
      });
    }
  }, {
    key: "removeAllEventCallbacks",
    value: function removeAllEventCallbacks() {
      this._loadEventCallbackList.length = 0;
    }
  }, {
    key: "removeEventCallback",
    value: function removeEventCallback(id) {
      for (var j = this._loadEventCallbackList.length - 1; j >= 0; j -= 1) {
        if (this._loadEventCallbackList[j].id === id) {
          this._loadEventCallbackList.splice(j, 1);
        }
      }
    }
  }, {
    key: "getNumImagesLoading",
    value: function getNumImagesLoading() {
      var numLoading = 0;
      this.imagesbysrc.forEach(function (value) {
        if (value._isLoading) {
          numLoading += 1;
        }
      });
      return numLoading;
    }
    /**
     * Get an WMImage object for given URL
     * @param {*} src The url for the image
     * @returns WMImage object
     */
  }, {
    key: "getImage",
    value: function getImage(src, loadOptions) {
      var _this = this;
      if (!src) {
        return null;
      }
      /** Check if we have an image in the pipeline * */
      var image = this.getImageForSrc(src);
      if (image !== undefined) {
        this._imageLifeCounter += 1;
        image.imageLife = this._imageLifeCounter;
        return image;
      }
      // Create  image
      if (this.imagesbysrc.size < this._maxNumberOfImages) {
        image = new WMImage(src, function (img) {
          _this.imageLoadEventCallback(img, WMImageEventType.Loaded);
        });
        image.setSource(src, loadOptions);
        this.imagesbysrc.set(src, image);
        this._imageLifeCounter += 1;
        image.imageLife = this._imageLifeCounter;
        return image;
      }
      /* We have to reuse an image */
      var imageId = '';
      var minImageLife = this._imageLifeCounter;
      this.imagesbysrc.forEach(function (img, url) {
        if (img && img.isLoading() === false || img && img.hasError() === true) {
          if (minImageLife >= img.imageLife) {
            minImageLife = img.imageLife;
            imageId = url;
          }
        }
      });
      if (imageId === '') {
        return this.emptyImage;
      }
      image = this.imagesbysrc.get(imageId);
      if (image) {
        this.imagesbysrc["delete"](imageId);
        this.imageLoadEventCallback(image, WMImageEventType.Deleted);
        image.clear();
        image.setSource(src, loadOptions);
        this.imagesbysrc.set(src, image);
        this._imageLifeCounter += 1;
        image.imageLife = this._imageLifeCounter;
        return image;
      }
      return null;
    }
  }]);
  return WMImageStore;
}();
var getMapImageStore = new WMImageStore(mapImageStoreLength, {
  id: 'getMapImageStore'
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var WMBBOX = /*#__PURE__*/function () {
  function WMBBOX(left, bottom, right, top) {
    _classCallCheck(this, WMBBOX);
    this.left = -180; // 0
    this.bottom = -90; // 1`
    this.right = 180; // 2
    this.top = 90; // 3
    this.clone = this.clone.bind(this);
    this.copy = this.copy.bind(this);
    this.setBBOX = this.setBBOX.bind(this);
    this.equals = this.equals.bind(this);
    this.toString = this.toString.bind(this);
    this.setBBOX(left, bottom, right, top);
  }
  /**
   * Clone an existing BBOX
   */
  _createClass(WMBBOX, [{
    key: "clone",
    value: function clone() {
      return new WMBBOX(this.left, this.bottom, this.right, this.top);
    }
  }, {
    key: "copy",
    value: function copy(bbox) {
      this.left = bbox.left;
      this.bottom = bbox.bottom;
      this.right = bbox.right;
      this.top = bbox.top;
    }
    /**
     * setBBOX method
     * Creates a WebMapJS bounding box based on 4 numeric values
     * Creates a WebMapJS bounding box based on 1 string with commaseparated numeric values
     * Creates a WebMapJS bounding box based on an exisiting WebMapJS bounding box.
     * When no parameters are given, a global latlon bbox is generated.
     */
  }, {
    key: "setBBOX",
    value: function setBBOX(left, bottom, right, top) {
      /* Check if we recieve more than one parameter by checking the second bottom parameter. */
      if (bottom !== undefined) {
        this.left = left; // -180; // 0
        this.bottom = bottom; // -90; // 1`
        this.right = right; // 180; // 2
        this.top = top; // 90; // 3
      }
      /* Check if we recieve more than one parameter by checking the second bottom parameter. */
      if (bottom === undefined) {
        /* Otherwise it can be a bbox object or a string in the form "left,bottom,right,top" */
        if (_typeof(left) === 'object') {
          /* A bbox object is given, so it is not a string */
          var a = left;
          this.left = a.left;
          this.bottom = a.bottom;
          this.right = a.right;
          this.top = a.top;
        } else {
          /* A string like "-180,-90,180,90" is given */
          try {
            var _a = left.split(',');
            if (_a.length !== 4) {
              return;
            }
            this.left = parseFloat(_a[0]);
            this.bottom = parseFloat(_a[1]);
            this.right = parseFloat(_a[2]);
            this.top = parseFloat(_a[3]);
          } catch (e) {
            return;
          }
        }
      }
      /* Apply defaults to invalid values */
      if (this.left == null) {
        this.left = -180;
      }
      if (this.right == null) {
        this.right = 180;
      }
      if (this.bottom == null) {
        this.bottom = -90;
      }
      if (this.top == null) {
        this.top = 90;
      }
    }
    /*
     * Compares two boundingboxes and returns true if they are equal
     */
  }, {
    key: "equals",
    value: function equals(left, bottom, right, top) {
      return left === this.left && bottom === this.bottom && right === this.right && top === this.top;
    }
    /**
     * Returns the current BBOX as a string, useful for generating WMS requests.
     */
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.left, ",").concat(this.bottom, ",").concat(this.right, ",").concat(this.top);
    }
  }]);
  return WMBBOX;
}();

/**
 * WMProjection Class
 * Keep all projection information, by a bbox and an srs value.
 */
var WMProjection = /*#__PURE__*/_createClass(function WMProjection() {
  _classCallCheck(this, WMProjection);
  this.bbox = new WMBBOX();
  this.srs = 'EPSG:4326';
});

var CallBackFunction = /*#__PURE__*/_createClass(function CallBackFunction() {
  _classCallCheck(this, CallBackFunction);
  this.name = undefined;
  this.functionpointer = undefined;
  this.finished = 0;
  this.keepOnCall = false;
});
var WMListener = /*#__PURE__*/function () {
  function WMListener() {
    _classCallCheck(this, WMListener);
    this._callBacks = [];
    this._suspendedEvents = [];
    this.addToCallback = this.addToCallback.bind(this);
    this.removeEvents = this.removeEvents.bind(this);
    this.suspendEvent = this.suspendEvent.bind(this);
    this.resumeEvent = this.resumeEvent.bind(this);
    this.suspendEvents = this.suspendEvents.bind(this);
    this.resumeEvents = this.resumeEvents.bind(this);
    this.triggerEvent = this.triggerEvent.bind(this);
    this.destroy = this.destroy.bind(this);
    this._allEventsSuspended = false;
  }
  /* Add multiple functions which will be called after the event with the same name is triggered */
  _createClass(WMListener, [{
    key: "addToCallback",
    value: function addToCallback(name, functionpointer) {
      var keepOnCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var cbp = -1; /* callbackpointer */
      for (var j = 0; j < this._callBacks.length; j += 1) {
        // A callback list index pointer. if finished==1, then this index may be replaced by a new one.
        if (this._callBacks[j].finished === 1) {
          cbp = j;
          break;
        }
        // If the current callback already exist, we will simply keep it
        if (this._callBacks[j].name === name && this._callBacks[j].functionpointer === functionpointer) {
          this._callBacks[j].keepOnCall = keepOnCall;
          return false;
        }
      }
      if (cbp === -1) {
        cbp = this._callBacks.length;
        this._callBacks.push(new CallBackFunction());
      }
      this._callBacks[cbp].name = name;
      this._callBacks[cbp].functionpointer = functionpointer;
      this._callBacks[cbp].finished = 0;
      this._callBacks[cbp].keepOnCall = keepOnCall;
      return true;
    }
  }, {
    key: "removeEvents",
    value: function removeEvents(name, f) {
      for (var j = 0; j < this._callBacks.length; j += 1) {
        if (this._callBacks[j].finished === 0) {
          if (this._callBacks[j].name === name) {
            if (!f) {
              this._callBacks[j].finished = 1;
            } else if (this._callBacks[j].functionpointer === f) {
              this._callBacks[j].finished = 1;
            }
          }
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._callBacks.length = 0;
    }
  }, {
    key: "suspendEvent",
    value: function suspendEvent(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._suspendedEvents[name] = true;
    }
  }, {
    key: "resumeEvent",
    value: function resumeEvent(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._suspendedEvents[name] = false;
    }
  }, {
    key: "suspendEvents",
    value: function suspendEvents() {
      this._allEventsSuspended = true;
    }
  }, {
    key: "resumeEvents",
    value: function resumeEvents() {
      this._allEventsSuspended = false;
    }
    // Trigger an event with a name
  }, {
    key: "triggerEvent",
    value: function triggerEvent(name, param) {
      if (this._allEventsSuspended === true ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._suspendedEvents[name] === true) {
        return [];
      }
      var returnList = [];
      for (var j = 0; j < this._callBacks.length; j += 1) {
        if (this._callBacks[j].finished === 0) {
          if (this._callBacks[j].name === name) {
            if (this._callBacks[j].keepOnCall === false) {
              this._callBacks[j].finished = 1;
            }
            try {
              returnList.push(this._callBacks[j].functionpointer(param, this));
            } catch (e) {
              debugLogger(DebugType.Error);
            }
          }
        }
      }
      return returnList;
    }
  }]);
  return WMListener;
}();

/* Global variable, shared across multiple WMCanvasBuffers */
var sharedImagesList = {};
var ANIMATIONFRAMEREQUEST_DONE = -1;
/**
 * Function to find image url's which are similar to other images, without taking width, height and bbox into account
 * @param imageSource The source / url of the image to check
 * @returns A signature for this image, which is the same for images with different bbox and or width/height
 */
var makeQueryStringWithoutGeoInfo = function makeQueryStringWithoutGeoInfo(imageSource) {
  if (imageSource.indexOf('GFI%3ATIME_ELEVATION') !== -1) {
    return getUriWithParam(imageSource, {
      BBOX: '',
      WIDTH: '',
      HEIGHT: '',
      time: '',
      elevation: ''
    });
  }
  return getUriWithParam(imageSource, {
    BBOX: '',
    WIDTH: '',
    HEIGHT: ''
  });
};
/**
 * Add an image to the sharedimages list
 * @param newLayer A canvaslayer object to add.
 */
var addAlternativeImage = function addAlternativeImage(newLayer) {
  var _a;
  /* Get a signature for images which belong to each other */
  var sigImageUrl = makeQueryStringWithoutGeoInfo(newLayer.imageSource);
  /* Make an entry for these images in the sharedImagesList */
  (_a = sharedImagesList[sigImageUrl]) !== null && _a !== void 0 ? _a : sharedImagesList[sigImageUrl] = [];
  /* Get the images for this signature */
  var imagesForUrl = sharedImagesList[sigImageUrl];
  /* Check if the image is not already in the sharedImagesList */
  var imageIsAlreadyIndex = imagesForUrl.find(function (i) {
    return i.imageSource === newLayer.imageSource;
  });
  /* It is not in the list, so add it */
  if (!imageIsAlreadyIndex) {
    /* Ensure that the oldest images are removed, keep a maximum of 10 images per signature url */
    while (sharedImagesList[sigImageUrl].length >= 10) {
      sharedImagesList[sigImageUrl].pop();
    }
    /* Add it to the beginning of the array for efficieny in searching at a later stage */
    sharedImagesList[sigImageUrl].unshift(newLayer);
  }
};
/**
 * Removes the image from the alternative imageslist (in case imagestore cache gets cleaned), this used when the imagestore triggers a delete event for an image
 * @param imageUrl The url for the image to remove
 */
var removeAlternativeImage = function removeAlternativeImage(imageUrl) {
  var sigImageUrl = makeQueryStringWithoutGeoInfo(imageUrl);
  var imagesForUrl = sharedImagesList[sigImageUrl];
  if (imagesForUrl && imagesForUrl.length > 0) {
    imagesForUrl.forEach(function (altImage, index) {
      if (altImage.imageSource === imageUrl) {
        imagesForUrl.splice(index, 1);
      }
    });
  }
  if (!imagesForUrl || imagesForUrl.length === 0) {
    delete sharedImagesList[sigImageUrl];
  }
};
/**
 * Sort the imageslist by imagedate, newewst image first.
 * @param imagesList
 * @returns
 */
var sortByImageDate = function sortByImageDate(imagesList) {
  var sorted = imagesList.sort(function (a, b) {
    return a.imageAge < b.imageAge ? 1 : -1;
  });
  return sorted.map(function (i) {
    return i;
  });
};
/**
 * Function to find the an alternative available image for an image url that is not yet loaded
 * @param imageUrl The image source / url to find an alternative for
 * @param imageStore The imagestore where the other images are located
 * @param bbox The boundingbox to search this image for
 * @returns A canvasLayer, containing the new image source with its geo properties
 */
var getAlternativeImage = function getAlternativeImage(imageUrl, imageStore,
// eslint-disable-next-line no-unused-vars
_bbox) {
  var sigImageUrl = makeQueryStringWithoutGeoInfo(imageUrl);
  var imagesForUrl = sharedImagesList[sigImageUrl];
  if (imagesForUrl === null || imagesForUrl === void 0 ? void 0 : imagesForUrl.length) {
    var sortedImagesForUrl = sortByImageDate(imagesForUrl);
    return sortedImagesForUrl.find(function (altImage) {
      var cachedImage = imageStore.getImageForSrc(altImage.imageSource);
      return cachedImage === null || cachedImage === void 0 ? void 0 : cachedImage.isLoadedWithoutErrors();
    });
  }
  return undefined;
};
var WMCanvasBuffer = /*#__PURE__*/function () {
  function WMCanvasBuffer(webmapJSCallback, _imageStore, w, h, internalCallbacks) {
    var _this = this;
    _classCallCheck(this, WMCanvasBuffer);
    this.canvas = document.createElement('canvas');
    this.canvas.width = w;
    this.canvas.height = h;
    this._ctx = this.canvas.getContext('2d');
    this._ctx.canvas.width = w;
    this._ctx.canvas.height = h;
    this._imageStore = _imageStore;
    this.ready = true;
    this.layers = [];
    this._defaultImage = new WMImage('webmapjs/img/stoploading.png', function () {
      _this._statDivBufferImageLoaded();
    });
    this._currentbbox = undefined;
    this._currentnewbbox = undefined;
    this._width = w;
    this._height = h;
    this._webmapJSCallback = webmapJSCallback;
    this._internalCallbacks = internalCallbacks;
    /* Bind */
    this.getCanvasContext = this.getCanvasContext.bind(this);
    this.imageLoadComplete = this.imageLoadComplete.bind(this);
    this._statDivBufferImageLoaded = this._statDivBufferImageLoaded.bind(this);
    this.display = this.display.bind(this);
    this.finishedLoading = this.finishedLoading.bind(this);
    this.resize = this.resize.bind(this);
    this.setSrc = this.setSrc.bind(this);
    this._getPixelCoordFromGeoCoord = this._getPixelCoordFromGeoCoord.bind(this);
    this.setBBOX = this.setBBOX.bind(this);
    this.getBuffer = this.getBuffer.bind(this);
    this._drawImage = this._drawImage.bind(this);
    this._imageStore.addImageEventCallback(function (image, id, imageEventType) {
      if (imageEventType === WMImageEventType.Loaded) {
        _this.imageLoadComplete(image);
      }
      if (imageEventType === WMImageEventType.Deleted) {
        removeAlternativeImage(image.getSrc());
      }
    }, 'WMCanvasBuffer');
    this._errorList = [];
    this.animationFrameRequest = ANIMATIONFRAMEREQUEST_DONE;
  }
  _createClass(WMCanvasBuffer, [{
    key: "getCanvasContext",
    value: function getCanvasContext() {
      return this._ctx;
    }
    /**
     * Triggered by the WMImageStore when an image completes loading
     * @param image
     */
  }, {
    key: "imageLoadComplete",
    value: function imageLoadComplete(image) {
      this._statDivBufferImageLoaded();
      this._webmapJSCallback.triggerEvent('onimageload', undefined);
      this._webmapJSCallback.triggerEvent('onimagebufferimageload', image);
      this.display();
    }
    /**
     * Checks if all images are loaded, if so it will call finishedLoading
     * @returns
     */
  }, {
    key: "_statDivBufferImageLoaded",
    value: function _statDivBufferImageLoaded() {
      for (var j = 0; j < this.layers.length; j += 1) {
        var image = this._imageStore.getImageForSrc(this.layers[j].imageSource);
        if (!image || image.isLoaded() === false) {
          return;
        }
      }
      this.finishedLoading();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.layers.length = 0;
    }
  }, {
    key: "_drawImage",
    value: function _drawImage(canvasLayer) {
      var imageBBox = canvasLayer.bbox,
        opacity = canvasLayer.opacity,
        imageSource = canvasLayer.imageSource;
      var image = this._imageStore.getImageForSrc(imageSource);
      if (!image || image.hasError()) {
        return;
      }
      this._ctx.globalAlpha = opacity;
      var imageElement = image.getElement();
      var mapBBox = this._currentnewbbox;
      var coord1 = this._getPixelCoordFromGeoCoord({
        x: imageBBox.left,
        y: imageBBox.top
      }, mapBBox);
      var coord2 = this._getPixelCoordFromGeoCoord({
        x: imageBBox.right,
        y: imageBBox.bottom
      }, mapBBox);
      var imageX = coord1.x;
      var imageY = coord1.y;
      var imageW = coord2.x - coord1.x;
      var imageH = coord2.y - coord1.y;
      try {
        this._ctx.drawImage(imageElement, imageX, imageY, imageW, imageH);
        if (enableConsoleDebugging) ;
      } catch (e) {
        debugLogger(DebugType.Error);
      }
    }
  }, {
    key: "display",
    value: function display() {
      var _this2 = this;
      // Check if the response from window.requestAnimationFrame is set. If this is the case, debounce the next display.
      if (this.animationFrameRequest !== ANIMATIONFRAMEREQUEST_DONE) {
        clearTimeout(this.timerHandle);
        this.timerHandle = setTimeout(function () {
          _this2._display();
        }, 100);
        return;
      }
      // Display the next frame based on window.requestAnimationFrame, e.g. when the screen is ready to display.
      this.animationFrameRequest = window.requestAnimationFrame(function () {
        _this2._display();
      });
    }
  }, {
    key: "_display",
    value: function _display() {
      var _this3 = this;
      var _a, _b, _c, _d, _e, _f;
      // Frame is displayed, so reset animationFrameRequest back to default.
      this.animationFrameRequest = ANIMATIONFRAMEREQUEST_DONE;
      this._ctx.globalAlpha = 1;
      this._ctx.fillStyle = 'white';
      this._ctx.beginPath();
      this._ctx.fillRect(0, 0, this._width, this._height);
      this._ctx.fill();
      this._webmapJSCallback.triggerEvent('beforecanvasstartdraw', this._ctx);
      if (this._internalCallbacks && this._internalCallbacks.beforecanvasstartdraw) {
        this._internalCallbacks.beforecanvasstartdraw(this._ctx);
      }
      /* Reset errors */
      this._errorList.length = 0;
      this.layers.forEach(function (layer) {
        var imageToDisplay = _this3._imageStore.getImageForSrc(layer.imageSource);
        if (imageToDisplay === null || imageToDisplay === void 0 ? void 0 : imageToDisplay.isLoadedWithoutErrors()) {
          // Draw this image, it is loaded and OK
          _this3._drawImage(layer);
          return;
        }
        /**
         * Check if this image has an error.
         * If the error has occured some time ago, and the amount of retries is low, just retry to load the image.
         */
        if ((imageToDisplay === null || imageToDisplay === void 0 ? void 0 : imageToDisplay.hasError()) && imageToDisplay.isLoading() === false && imageToDisplay.getLastErrorMSecondsAgo() > 5000 && imageToDisplay.getNumFailedAttempts() < 10) {
          imageToDisplay.forceReload();
        }
        /* Find closest alternative and display instead image */
        var im = getAlternativeImage(layer.imageSource, _this3._imageStore, _this3._currentnewbbox);
        if (im) {
          _this3._drawImage(im);
        }
      });
      this._ctx.globalAlpha = 1;
      /* Display errors */
      if (this._errorList.length > 0) {
        this._webmapJSCallback.triggerEvent('canvasonerror', this._errorList);
        (_b = (_a = this._internalCallbacks) === null || _a === void 0 ? void 0 : _a.canvasonerror) === null || _b === void 0 ? void 0 : _b.call(_a, this._errorList);
      }
      this._webmapJSCallback.triggerEvent('beforecanvasdisplay', this._ctx);
      (_d = (_c = this._internalCallbacks) === null || _c === void 0 ? void 0 : _c.beforecanvasdisplay) === null || _d === void 0 ? void 0 : _d.call(_c, this._ctx);
      this.canvas.style.display = 'inline-block';
      this._webmapJSCallback.triggerEvent('aftercanvasdisplay', this._ctx);
      (_f = (_e = this._internalCallbacks) === null || _e === void 0 ? void 0 : _e.aftercanvasdisplay) === null || _f === void 0 ? void 0 : _f.call(_e, this._ctx);
    }
  }, {
    key: "finishedLoading",
    value: function finishedLoading() {
      if (this.ready) {
        return;
      }
      this.ready = true;
      for (var j = 0; j < this.layers.length; j += 1) {
        var image = this._imageStore.getImageForSrc(this.layers[j].imageSource);
        if (image && image.hasError()) {
          debugLogger(DebugType.Error, "image error: ".concat(image.getSrc()));
        }
      }
      try {
        if (isDefined(this.onLoadReadyFunction)) {
          this.onLoadReadyFunction(this);
        }
      } catch (e) {
        debugLogger(DebugType.Error);
      }
    }
  }, {
    key: "resize",
    value: function resize(w, h) {
      var width = parseInt(w, 10);
      var height = parseInt(h, 10);
      if (this._width === width && this._height === height) {
        return;
      }
      this._width = width;
      this._height = height;
      this.canvas.width = width;
      this.canvas.height = height;
      this._ctx.canvas.height = height;
      this._ctx.canvas.width = width;
    }
    /**
     * Set's a layer inside the canvasbuffer with given index and imagesource.
     * The image is directly loaded, but if loading is not complete when drawing, an alternative image is search in the alternative images list
     * @param layerIndex The layer index, similar to z-Index, 0 drawn on the bottom, higher numbers on top
     * @param imageSource The url of the image, usually a GetMap url
     * @param linkedInfo A linkedinfo object to track properties for the image and layer, like errors
     * @param opacity Opacity of this layer
     * @param bbox The boundingbox for this layer
     * @returns Void
     */
  }, {
    key: "setSrc",
    value: function setSrc(layerIndex, imageSource, linkedInfo, opacity, bbox) {
      var _a, _b;
      if (!isDefined(imageSource)) {
        debugLogger(DebugType.Warning);
        return;
      }
      /* HTTP Headers for the image, necessary in case of certain authentication forms */
      var headers = (_b = (_a = linkedInfo === null || linkedInfo === void 0 ? void 0 : linkedInfo.layer) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : [];
      /* Make a new CanvasLayer */
      var newLayer = {
        imageSource: imageSource,
        imageAge: getCurrentImageTime(),
        opacity: opacity,
        bbox: {
          left: bbox.left,
          right: bbox.right,
          top: bbox.top,
          bottom: bbox.bottom
        }
      };
      /* Build same layers array as map layers array */
      while (layerIndex >= this.layers.length) {
        this.layers.push(newLayer);
      }
      this.layers[layerIndex] = newLayer;
      /* Track this layer in the alternative images list */
      addAlternativeImage(newLayer);
      /* Get the image with this imagesource from the imagestore and load it */
      var image = this._imageStore.getImage(imageSource, {
        headers: headers
      });
      if (!image.isLoaded() && !image.isLoading()) {
        image.load();
      }
    }
  }, {
    key: "_getPixelCoordFromGeoCoord",
    value: function _getPixelCoordFromGeoCoord(coordinates, b) {
      var x = this._width * (coordinates.x - b.left) / (b.right - b.left);
      var y = this._height * (coordinates.y - b.top) / (b.bottom - b.top);
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "setBBOX",
    value: function setBBOX(newbbox, loadedbbox) {
      this._currentbbox = loadedbbox;
      this._currentnewbbox = newbbox;
      this.display();
    }
  }, {
    key: "getBuffer",
    value: function getBuffer() {
      return this.canvas;
    }
  }]);
  return WMCanvasBuffer;
}();

var MAX_IMAGES_TO_PREFETCH_DEFAULT = 8;
function prefetchImagesForAnimation(wmMap) {
  var maxImagesToPrefetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_IMAGES_TO_PREFETCH_DEFAULT;
  var animationSteps = wmMap.animationList;
  var countAnimationSteps = animationSteps.length;
  var animationStepsInOrder = range(0, countAnimationSteps).map(function (offset) {
    // start prefecthing images for the next animation step first
    // when reaching end of animation, start from the beginning
    var indexOfNextAnimationStep = (wmMap.currentAnimationStep + offset) % countAnimationSteps;
    return animationSteps[indexOfNextAnimationStep];
  });
  prefetchLayerImagesInOrderWithUrls(animationStepsInOrder, maxImagesToPrefetch);
}
function prefetchLayerImagesInOrderWithUrls(animationStepsInOrder, maxImagesToPrefetch) {
  var _iterator = _createForOfIteratorHelper(animationStepsInOrder),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var animationStep = _step.value;
      // dont prefetch if already prefetching too many images
      var countImagesLoading = getMapImageStore.getNumImagesLoading();
      if (countImagesLoading > maxImagesToPrefetch - 1) {
        break;
      }
      prefetchLayerImagesForTime(animationStep.requests || []);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function prefetchLayerImagesInOrder(wmMap, timesToPrefetchInOrder, maxImagesToPrefetch) {
  var _iterator2 = _createForOfIteratorHelper(timesToPrefetchInOrder),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var timeToPrefetch = _step2.value;
      // dont prefetch if already prefetching too many images
      var countImagesLoading = getMapImageStore.getNumImagesLoading();
      if (countImagesLoading > maxImagesToPrefetch - 1) {
        break;
      }
      var layersImageUrls = getLayersImageUrlsForTime(wmMap, timeToPrefetch);
      prefetchLayerImagesForTime(layersImageUrls);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function getLayersImageUrlsForTime(wmMap, timeToPrefetch) {
  var layersImageUrls = wmMap.getWMSRequests([{
    name: 'time',
    currentValue: timeToPrefetch
  }]);
  return layersImageUrls;
}
function prefetchLayerImagesForTime(requests) {
  requests.forEach(function (request) {
    var image = getMapImageStore.getImage(request.url, {
      headers: request.headers
    });
    if (image.hasNotStartedLoading()) {
      image.load();
    }
  });
}
function prefetchImagesForNonAnimation(wmMap) {
  var maxImagesToPrefetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_IMAGES_TO_PREFETCH_DEFAULT;
  var timestepInMinutes = wmMap.timestepInMinutes;
  var timeDimension = wmMap.getDimension('time');
  if (!timeDimension || !timestepInMinutes) {
    return;
  }
  var currentValue = timeDimension.currentValue;
  var currentTimeIsoString = timeDimension.getClosestValue(currentValue);
  var currentTime = parseISO(currentTimeIsoString);
  if (!isValid(currentTime)) {
    return;
  }
  var maxTimesToPrefetchIfOneLayer = maxImagesToPrefetch / 2;
  var timesToPrefetchInOrder = range(0, maxTimesToPrefetchIfOneLayer).flatMap(function (offset) {
    var duration = {
      minutes: timestepInMinutes * offset
    };
    var nextTime = add(currentTime, duration).toISOString();
    var previousTime = sub(currentTime, duration).toISOString();
    return [nextTime, previousTime];
  });
  prefetchLayerImagesInOrder(wmMap, timesToPrefetchInOrder, maxImagesToPrefetch);
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Set the length of the timer, in milli seconds, after time has elapsed function is called
 * @param secstime Time in milli seconds
 * @param functionhandler Function to call after time is elapsed
 */
var WMTimer = /*#__PURE__*/function () {
  function WMTimer() {
    _classCallCheck(this, WMTimer);
    this.timer = null;
  }
  _createClass(WMTimer, [{
    key: "init",
    value: function init(delayInMiliseconds, callback) {
      this.stop();
      this.timer = setTimeout(callback, delayInMiliseconds);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }]);
  return WMTimer;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var _WMJSAnimate_instances, _WMJSAnimate_animate;
var WMJSAnimate = /*#__PURE__*/function () {
  function WMJSAnimate(_map) {
    _classCallCheck(this, WMJSAnimate);
    _WMJSAnimate_instances.add(this);
    this._imageStore = getMapImageStore;
    this.isNextTimeCloseToWallClockTime = false;
    _map.animationDelay = 100;
    this._callBack = _map.getListener();
    this._divAnimationInfo = document.createElement('div');
    _map.currentAnimationStep = 0;
    _map.animationList = undefined;
    _map.isAnimating = false;
    _map.setAnimationDelay = function (delay) {
      if (delay < 1) {
        delay = 1;
      }
      _map.animationDelay = delay;
    };
    this.isNextTimeCloseToWallClockTime = false;
    this._divAnimationInfo.style.zIndex = '10000';
    this._divAnimationInfo.style.background = 'none';
    this._divAnimationInfo.style.position = 'absolute';
    this._divAnimationInfo.style.border = 'none';
    this._divAnimationInfo.style.margin = '0px';
    this._divAnimationInfo.style.padding = '0px';
    this._divAnimationInfo.style.lineHeight = '14px';
    this._divAnimationInfo.style.fontFamily = '"Courier New", "Lucida Console", Monospace';
    this._divAnimationInfo.style.fontSize = '10px';
    _map.getBaseElement().append(this._divAnimationInfo);
    this._map = _map;
    /* Bind */
    this.loopAnimation = this.loopAnimation.bind(this);
    this.stopAnimating = this.stopAnimating.bind(this);
    _map.stopAnimating = this.stopAnimating;
    this.animationTimer = new WMTimer();
  }
  _createClass(WMJSAnimate, [{
    key: "isCurrentAnimationTimeCloseToWallClockTime",
    value: function isCurrentAnimationTimeCloseToWallClockTime() {
      if (this.isNextTimeCloseToWallClockTime) {
        this.isNextTimeCloseToWallClockTime = false;
        return true;
      }
      var currentAnimationStep = this._map.animationList[this._map.currentAnimationStep];
      var nextAnimationStep = this._map.animationList[this._map.currentAnimationStep + 1 >= this._map.animationList.length ? 0 : this._map.currentAnimationStep + 1];
      var wallClockTime = new Date();
      var currentAnimationTime = new Date(currentAnimationStep.value);
      var nextAnimationTime = new Date(nextAnimationStep.value);
      if (dateUtils.isBetween(wallClockTime, currentAnimationTime, nextAnimationTime)) {
        var timeDiff1 = dateUtils.differenceInMinutes(currentAnimationTime, wallClockTime);
        var timeDiff2 = dateUtils.differenceInMinutes(nextAnimationTime, wallClockTime);
        if (Math.abs(timeDiff1) < Math.abs(timeDiff2)) {
          // Wall clock time is closer to current animation step time than to the next animation step time
          this.isNextTimeCloseToWallClockTime = false;
          return true;
        }
        // Wall clock time is closer to next animation step time than to the current animation step time
        this.isNextTimeCloseToWallClockTime = true;
      }
      return false;
    }
  }, {
    key: "loopAnimation",
    value: function loopAnimation() {
      var _this = this;
      if (this._map.isAnimating === false) {
        return;
      }
      var animationDelay = this._map.animationDelay;
      var animationSteps = this._map.animationList;
      if (this._map.currentAnimationStep === 0) {
        animationDelay *= 3;
      } else if (this._map.currentAnimationStep === animationSteps.length - 1) {
        animationDelay *= 5;
      } else if (this.isCurrentAnimationTimeCloseToWallClockTime()) {
        animationDelay *= 5;
      }
      // set up timer for next animation step
      this.animationTimer.init(animationDelay, this.loopAnimation);
      prefetchImagesForAnimation(this._map);
      if (this._map.mouseHoverAnimationBox !== false) {
        return;
      }
      __classPrivateFieldGet(this, _WMJSAnimate_instances, "m", _WMJSAnimate_animate).call(this);
      var nextAnimationStepIndex = this._map.currentAnimationStep + 1;
      if (nextAnimationStepIndex >= animationSteps.length) {
        nextAnimationStepIndex = 0;
      }
      // get urls for images in next animation step
      var layersImageUrls = getLayersImageUrlsForTime(this._map, animationSteps[nextAnimationStepIndex].value);
      // if images for next animation step is ready or haven't started loading
      // change map animation step to next step
      var numberOfImagesReadyForNextAnimationStep = 0;
      layersImageUrls.forEach(function (request) {
        var url = request.url;
        var image = getMapImageStore.getImageForSrc(url);
        /* Get a loaded image which has no error */
        if (image === null || image === void 0 ? void 0 : image.isLoadedWithoutErrors()) {
          numberOfImagesReadyForNextAnimationStep += 1;
          return;
        }
        /* Check if a similar image is available instead, then we can continue with the smoother animation */
        var alternativeImage = getAlternativeImage(url, getMapImageStore, _this._map.getDrawBBOX());
        if (alternativeImage) {
          numberOfImagesReadyForNextAnimationStep += 1;
          return;
        }
        var imageHasntStartedLoading = !(image === null || image === void 0 ? void 0 : image.isLoading());
        if (imageHasntStartedLoading) {
          /* No alternatives and current image is not loading, so lets continue the animation */
          numberOfImagesReadyForNextAnimationStep += 1;
        }
      });
      if (numberOfImagesReadyForNextAnimationStep >= layersImageUrls.length) {
        this._map.currentAnimationStep = nextAnimationStepIndex;
      }
    }
  }, {
    key: "stopAnimating",
    value: function stopAnimating() {
      if (this._map.isAnimating === false) {
        return;
      }
      this._map._animationList = undefined;
      this._divAnimationInfo.style.display = 'none';
      this._map.isAnimating = false;
      this.animateBusy = false;
      this._map.rebuildMapDimensions();
      this._callBack.triggerEvent('onstopanimation', this._map);
    }
  }]);
  return WMJSAnimate;
}();
_WMJSAnimate_instances = new WeakSet(), _WMJSAnimate_animate = function _WMJSAnimate_animate() {
  if (this._map.isAnimating === false) {
    return;
  }
  if (this.animateBusy === true) {
    return;
  }
  var animationStep = this._map.animationList[this._map.currentAnimationStep];
  if (!animationStep) {
    debugLogger(DebugType.Error, "No animation step for ".concat(this._map.currentAnimationStep));
    return;
  }
  this._map.setDimension(animationStep.name, animationStep.value, false);
  this._callBack.triggerEvent('ondimchange');
  this._callBack.triggerEvent('onnextanimationstep', this._map);
  this._map.addLayersToCanvasAndDisplayThem();
  this.animateBusy = false;
};

var WMTileRenderer = /*#__PURE__*/function () {
  function WMTileRenderer() {
    _classCallCheck(this, WMTileRenderer);
  }
  _createClass(WMTileRenderer, [{
    key: "render",
    value: function render(currentBBOX, newBBOX, srs, width, height, ctx, bgMapImageStore,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    tileOptions, layerName) {
      var renderedURLs = {};
      var imagesToRender = [];
      if (!layerName) {
        debugLogger(DebugType.Error);
        return undefined;
      }
      /* Temporal mappings from bgmaps.cgi service names to names defined here */
      if (layerName === 'streetmap') {
        layerName = 'OSM';
      }
      if (layerName === 'pdok') {
        layerName = 'OSM';
      }
      if (layerName === 'naturalearth2') {
        layerName = 'NaturalEarth2';
      }
      var tileLayer = tileOptions[layerName];
      if (!tileLayer) {
        debugLogger(DebugType.Error);
        return undefined;
      }
      var tileSettings = tileLayer[srs];
      /* If current map projection is missing in the tilesets, try to find an alternative */
      if (!tileSettings) {
        for (var tileOption in tileOptions) {
          // eslint-disable-next-line no-prototype-builtins
          if (tileOptions.hasOwnProperty(tileOption)) {
            for (var epsgCode in tileOptions[tileOption]) {
              // eslint-disable-next-line no-prototype-builtins
              if (tileOptions[tileOption].hasOwnProperty(epsgCode)) {
                if (epsgCode === srs) {
                  tileSettings = tileOptions[tileOption][epsgCode];
                }
              }
            }
          }
        }
      }
      var pi = Math.PI;
      /* Default settings for OSM Mercator */
      var tileSize = 256;
      var initialResolution = 2 * pi * 6378137 / tileSize;
      var originShiftX = -2 * pi * 6378137 / 2.0;
      var originShiftY = 2 * pi * 6378137 / 2.0;
      if (tileSettings.tileSize) {
        tileSize = tileSettings.tileSize;
      }
      if (tileSettings.resolution) {
        initialResolution = tileSettings.resolution;
      }
      if (tileSettings.origX) {
        originShiftX = tileSettings.origX;
      }
      if (tileSettings.origY) {
        originShiftY = tileSettings.origY;
      }
      var screenWidth = width;
      var bboxw = currentBBOX.right - currentBBOX.left;
      var originShiftX2 = initialResolution * tileSize + originShiftX;
      var originShiftY2 = originShiftY - initialResolution * tileSize;
      var tileSetWidth = originShiftX2 - originShiftX;
      var tileSetHeight = originShiftY - originShiftY2;
      var levelF = Math.log(Math.abs(originShiftX2 - originShiftX) / (bboxw / screenWidth * tileSize)) / Math.log(2);
      var level = Math.trunc(levelF + 0.5);
      var getAttribution = function getAttribution(textileLayer) {
        if (!textileLayer || !srs || !tileLayer[srs] || !tileLayer[srs].copyRight) {
          return null;
        }
        return tileLayer[srs].copyRight;
      };
      var drawBGTiles = function drawBGTiles(level) {
        var _tileSettings = tileSettings,
          home = _tileSettings.home;
        var _tileSettings2 = tileSettings,
          tileServerType = _tileSettings2.tileServerType; // 'osm' or 'argisonline'
        var tileServerFormat = tileSettings.tileServerFormat || 'png';
        var tmsEnabled = tileSettings.tms || false; // 'osm' or 'argisonline'
        if (level < tileSettings.minLevel) {
          level = tileSettings.minLevel;
        }
        if (level > tileSettings.maxLevel) {
          level = tileSettings.maxLevel;
        }
        var numTilesAtLevel = Math.pow(2, level);
        var numTilesAtLevelX = tileSetWidth / (initialResolution / numTilesAtLevel * tileSize);
        var numTilesAtLevelY = tileSetHeight / (initialResolution / numTilesAtLevel * tileSize);
        var tilenleft = Math.trunc(Math.round((currentBBOX.left - originShiftX) / tileSetWidth * numTilesAtLevelX / 1 + 0.5));
        var tilenright = Math.trunc(Math.round((currentBBOX.right - originShiftX) / tileSetWidth * numTilesAtLevelX / 1 + 0.5));
        var tilentop = Math.trunc(Math.round(numTilesAtLevelY - (currentBBOX.bottom - originShiftY2) / tileSetHeight * numTilesAtLevelY + 0.5));
        var tilenbottom = Math.trunc(Math.round(numTilesAtLevelY - (currentBBOX.top - originShiftY2) / tileSetHeight * numTilesAtLevelY + 0.5));
        var tileXYZToMercator = function tileXYZToMercator(level, x, y) {
          var tileRes = initialResolution / Math.pow(2, level);
          var p = {
            x: x * tileRes + originShiftX,
            y: originShiftY - y * tileRes
          };
          return p;
        };
        var getTileBounds = function getTileBounds(level, x, y) {
          var p1 = tileXYZToMercator(level, x * tileSize, y * tileSize);
          var p2 = tileXYZToMercator(level, (x + 1) * tileSize, (y + 1) * tileSize);
          return {
            left: p1.x,
            bottom: p1.y,
            right: p2.x,
            top: p2.y
          };
        };
        var getPixelCoordFromGeoCoord = function getPixelCoordFromGeoCoord(coordinates, b, w, h) {
          var x = w * (coordinates.x - b.left) / (b.right - b.left);
          var y = h * (coordinates.y - b.top) / (b.bottom - b.top);
          return {
            x: x,
            y: y
          };
        };
        var drawTile = function drawTile(ctx, level, x, y) {
          var loadImage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
          var bounds = getTileBounds(level, x, y);
          var bl = getPixelCoordFromGeoCoord({
            x: bounds.left,
            y: bounds.bottom
          }, newBBOX, width, height);
          var tr = getPixelCoordFromGeoCoord({
            x: bounds.right,
            y: bounds.top
          }, newBBOX, width, height);
          var imageURL = '';
          if (tileServerType === 'osm') {
            if (tmsEnabled) {
              imageURL = "".concat(home + level, "/").concat(x, "/").concat(numTilesAtLevelY - 1 - y, ".").concat(tileServerFormat);
            } else {
              imageURL = "".concat(home + level, "/").concat(x, "/").concat(y, ".").concat(tileServerFormat);
            }
          } else if (tileServerType === 'arcgisonline' || tileServerType === 'wmst') {
            imageURL = "".concat(home + level, "/").concat(y, "/").concat(x);
          } else if (tileServerType === 'skyvector') {
            imageURL = "".concat(home + 2 * (11 - Math.round(level)), "/").concat(x, "/").concat(y, ".").concat(tileServerFormat);
          }
          if (renderedURLs[imageURL]) {
            return;
          }
          renderedURLs[imageURL] = true;
          var image = bgMapImageStore.getImage(imageURL);
          if (loadImage === false) {
            /* Here we display lower resolution images, if not available switch to an even higher resolution */
            if (image.isLoaded() && !image.hasError()) {
              try {
                ctx.drawImage(image.getElement(), Math.trunc(bl.x), Math.trunc(bl.y), Math.trunc(tr.x - bl.x) + 1, Math.trunc(tr.y - bl.y) + 1);
              } catch (e) {
                // do nothing
              }
            } else if (level > 1) {
              /* If desired image is not yet loaded, try to load a higher resolution variant instead */
              drawTile(ctx, level - 1, Math.trunc(x / 2), Math.trunc(y / 2), false);
            }
          } else {
            /* Not all images need to load, as we can switch to lower resolutions for the time being */
            if (loadImage) {
              if (image.isLoaded() === false && image.hasError() === false && image.isLoading() === false) {
                image.load();
              }
            }
            /* Here we display the images we like to have at the desired resolution */
            if (image.isLoaded() && !image.hasError()) {
              imagesToRender.push({
                image: image,
                i: image.getElement(),
                x: Math.trunc(bl.x),
                y: Math.trunc(bl.y),
                w: Math.trunc(tr.x - bl.x) + 1,
                h: Math.trunc(tr.y - bl.y) + 1,
                level: level
              });
            } else if (level > 1) {
              /* If desired image is not yet loaded, try to load a higher resolution variant instead */
              drawTile(ctx, level - 1, Math.trunc(x / 2), Math.trunc(y / 2), false);
            }
          }
        };
        if (srs === 'EPSG:4326' || srs === 'EPSG:4258') {
          numTilesAtLevelX *= 2;
        }
        if (tilenbottom < 1) {
          tilenbottom = 1;
        }
        if (tilenbottom > numTilesAtLevelY) {
          tilenbottom = numTilesAtLevelY;
        }
        if (tilenleft < 1) {
          tilenleft = 1;
        }
        if (tilenleft > numTilesAtLevelX) {
          tilenleft = numTilesAtLevelX;
        }
        if (tilentop < 1) {
          tilentop = 1;
        }
        if (tilentop > numTilesAtLevelY) {
          tilentop = numTilesAtLevelY;
        }
        if (tilenright < 1) {
          tilenright = 1;
        }
        if (tilenright > numTilesAtLevelX) {
          tilenright = numTilesAtLevelX;
        }
        if (tilentop - tilenbottom > 20) {
          debugLogger(DebugType.Error);
          return;
        }
        if (tilenright - tilenleft > 20) {
          debugLogger(DebugType.Error);
          return;
        }
        for (var ty = tilenbottom - 1; ty < tilentop; ty += 1) {
          for (var tx = tilenleft - 1; tx < tilenright; tx += 1) {
            drawTile(ctx, level, tx, ty);
          }
        }
      };
      drawBGTiles(level);
      imagesToRender.sort(function (imageA, imageB) {
        if (imageA.level < imageB.level) {
          return -1;
        }
        if (imageA.level > imageB.level) {
          return 1;
        }
        return 0;
      });
      for (var i = 0; i < imagesToRender.length; i += 1) {
        var image = imagesToRender[i];
        if (image.image.isLoaded() && !image.image.hasError()) {
          try {
            ctx.drawImage(image.i, image.x, image.y, image.w, image.h);
          } catch (e) {
            // do nothing
          }
        }
      }
      var attributionText = getAttribution(tileLayer);
      return {
        attributionText: attributionText
      };
    }
  }]);
  return WMTileRenderer;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var legendImageStore = new WMImageStore(legendImageStoreLength, {
  id: 'legendImageStore'
});
var getLegendGraphicURLForLayer = function getLegendGraphicURLForLayer(layer) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
  if (layer) {
    var legendURL = layer.legendGraphic;
    if (!legendURL) {
      return undefined;
    }
    try {
      if (layer.legendIsDimensionDependent === true) {
        legendURL += "".concat(getMapDimURL(layer), "&");
      }
      if (layer.sldURL) {
        legendURL += "&SLD=".concat(URLEncode(layer.sldURL));
      }
      legendURL += '&transparent=true&';
      // append width and height parameters when not present
      if (!legendURL.includes('&width=') && !legendURL.includes('&height=')) {
        legendURL += "&width=".concat(width, "&height=").concat(height, "&");
      }
    } catch (e) {
      return undefined;
    }
    // Handle WMS extensions
    legendURL += layer.wmsextensions.url;
    return legendURL;
  }
  return undefined;
};
var getLegendImageStore = function getLegendImageStore() {
  return legendImageStore;
};
var drawLegend = function drawLegend(canvasContext, width, height, layers) {
  /* Draw legends */
  var ctx = canvasContext;
  var legendPosX = 0;
  for (var j = 0; j < layers.length; j += 1) {
    if (layers[j].enabled !== false) {
      var legendUrl = getLegendGraphicURLForLayer(layers[j]);
      if (isDefined(legendUrl)) {
        var image = legendImageStore.getImage(legendUrl, {
          headers: layers[j].headers
        });
        if (image.hasError() === false) {
          if (image.isLoaded() === false && image.isLoading() === false) {
            image.load();
          } else {
            var el = image.getElement();
            var legendW = Math.trunc(el.width) + 4;
            var legendH = Math.trunc(el.height) + 4;
            legendPosX += legendW + 4;
            var legendX = width - legendPosX + 2;
            var legendY = height - legendH - 2 - 13;
            ctx.beginPath();
            ctx.fillStyle = '#FFFFFF';
            ctx.lineWidth = 0.3;
            ctx.globalAlpha = 0.5;
            ctx.strokeStyle = '#000000';
            ctx.rect(legendX + 0.5, legendY + 0.5, legendW, legendH);
            ctx.fill();
            ctx.stroke();
            ctx.globalAlpha = 1.0;
            try {
              ctx.drawImage(el, legendX, legendY);
            } catch (e) {
              debugLogger(DebugType.Error);
            }
          }
        }
      }
    }
  }
};

/** ************************************************ */
/* Object to store a time duration / time interval */
/** ************************************************ */
var DateInterval = /*#__PURE__*/function () {
  function DateInterval(year, month, day, hour, minute, second) {
    _classCallCheck(this, DateInterval);
    this.year = parseInt(year, 10);
    this.month = parseInt(month, 10);
    this.day = parseInt(day, 10);
    this.hour = parseInt(hour, 10);
    this.minute = parseInt(minute, 10);
    this.second = parseInt(second, 10);
    this.isRegularInterval = false;
    if (this.month === 0 && this.year === 0) {
      this.isRegularInterval = true;
    }
    this.getTime = this.getTime.bind(this);
    this.toISO8601 = this.toISO8601.bind(this);
  }
  _createClass(DateInterval, [{
    key: "getTime",
    value: function getTime() {
      var timeres = 0;
      /* Months and years are unequally distributed in time
         So get time is not possible */
      if (this.month !== 0) {
        throw new Error('month !== 0');
      }
      if (this.year !== 0) {
        throw new Error('year !== 0');
      }
      timeres += this.day * 60 * 60 * 24;
      timeres += this.hour * 60 * 60;
      timeres += this.minute * 60;
      timeres += this.second;
      timeres *= 1000;
      return timeres;
    }
  }, {
    key: "toISO8601",
    value: function toISO8601() {
      var isoTime = 'P';
      if (this.year !== 0) {
        isoTime += "".concat(this.year, "Y");
      }
      if (this.month !== 0) {
        isoTime += "".concat(this.month, "M");
      }
      if (this.day !== 0) {
        isoTime += "".concat(this.day, "D");
      }
      if (this.hour !== 0 && this.minute !== 0 && this.second !== 0) {
        isoTime += 'T';
      }
      if (this.hour !== 0) {
        isoTime += "".concat(this.hour, "H");
      }
      if (this.minute !== 0) {
        isoTime += "".concat(this.minute, "M");
      }
      if (this.second !== 0) {
        isoTime += "".concat(this.second, "S");
      }
      return isoTime;
    }
  }]);
  return DateInterval;
}();
var isValidISOTime = function isValidISOTime(isotime) {
  var minimalFormat = 'ccyy-mm-ddThh:mmZ';
  if (!isotime || isotime.length < minimalFormat.length) {
    return false;
  }
  var _isotime$split = isotime.split('T'),
    _isotime$split2 = _slicedToArray(_isotime$split, 2),
    date = _isotime$split2[0],
    time = _isotime$split2[1];
  if (date === undefined || time === undefined) {
    return false;
  }
  return true;
};
var parseTimeValue = function parseTimeValue(value) {
  return parseInt(value === undefined || value === null || !value.length ? '00' : value, 10);
};
var getTimeValues = function getTimeValues(isotime) {
  return isotime.split(/\D+/).map(parseTimeValue);
};
/** ************************************************* */
/* Parses ISO8601 times to a Javascript Date Object */
/** ************************************************* */
var parseISO8601DateToDate = function parseISO8601DateToDate(unvalidatedIsotime) {
  /*
  The following functions are added to the standard Date object:
    - add(dateInterval) adds a DateInterval time to this time
    - substract(dateInterval) substracts a DateInterval time to this time
    - toISO8601() returns the date object as iso8601 string
    - clone() creates a copy of this object
  */
  /** Timeformats according to:
   * https://portal.ogc.org/files/?artifact_id=14416 / 06-042_OpenGIS_Web_Map_Service_WMS_Implementation_Specification.pdf,
   * chapter D2.1 are supported
   */
  var makeISO8601StringFromFlexibleWMSDateString = function makeISO8601StringFromFlexibleWMSDateString(isoString) {
    // Datestring starting with a - token are not supported.
    if (!isoString || isoString.startsWith('-')) {
      return isoString;
    }
    var trimmed = isoString.trim();
    if (trimmed.length === 4) {
      return "".concat(trimmed, "-01-01T00:00:00Z"); // YYYY
    }
    if (trimmed.length === 7) {
      return "".concat(trimmed, "-01T00:00:00Z"); // YYYY-MM
    }
    if (trimmed.length === 10) {
      return "".concat(trimmed, "T00:00:00Z"); // YYYY-MM-DD
    }
    if (trimmed.length === 14) {
      return "".concat(trimmed.slice(0, -1), ":00:00Z"); // YYYY-MM-DDTHHZ
    }
    return trimmed;
  };
  var isotime = makeISO8601StringFromFlexibleWMSDateString(unvalidatedIsotime);
  if (!isValidISOTime(isotime)) {
    debugLogger(DebugType.Warning);
    return undefined;
  }
  var _getTimeValues = getTimeValues(isotime),
    _getTimeValues2 = _slicedToArray(_getTimeValues, 6),
    year = _getTimeValues2[0],
    month = _getTimeValues2[1],
    day = _getTimeValues2[2],
    hours = _getTimeValues2[3],
    minutes = _getTimeValues2[4],
    seconds = _getTimeValues2[5];
  var date = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
  date.add = function (dateInterval) {
    if (!dateInterval) {
      return;
    }
    if (dateInterval.isRegularInterval === false) {
      if (dateInterval.year !== 0) {
        date.setUTCFullYear(date.getUTCFullYear() + dateInterval.year);
      }
      if (dateInterval.month !== 0) {
        date.setUTCMonth(date.getUTCMonth() + dateInterval.month);
      }
      if (dateInterval.day !== 0) {
        date.setUTCDate(date.getUTCDate() + dateInterval.day);
      }
      if (dateInterval.hour !== 0) {
        date.setUTCHours(date.getUTCHours() + dateInterval.hour);
      }
      if (dateInterval.minute !== 0) {
        date.setUTCMinutes(date.getUTCMinutes() + dateInterval.minute);
      }
      if (dateInterval.second !== 0) {
        date.setUTCSeconds(date.getUTCSeconds() + dateInterval.second);
      }
    } else {
      date.setTime(date.getTime() + dateInterval.getTime());
    }
  };
  date.substract = function (dateInterval) {
    if (!dateInterval) {
      return;
    }
    if (dateInterval.isRegularInterval === false) {
      if (dateInterval.year !== 0) {
        date.setUTCFullYear(date.getUTCFullYear() - dateInterval.year);
      }
      if (dateInterval.month !== 0) {
        date.setUTCMonth(date.getUTCMonth() - dateInterval.month);
      }
      if (dateInterval.day !== 0) {
        date.setUTCDate(date.getUTCDate() - dateInterval.day);
      }
      if (dateInterval.hour !== 0) {
        date.setUTCHours(date.getUTCHours() - dateInterval.hour);
      }
      if (dateInterval.minute !== 0) {
        date.setUTCMinutes(date.getUTCMinutes() - dateInterval.minute);
      }
      if (dateInterval.second !== 0) {
        date.setUTCSeconds(date.getUTCSeconds() - dateInterval.second);
      }
    } else {
      date.setTime(date.getTime() - dateInterval.getTime());
    }
  };
  date.addMultipleTimes = function (dateInterval, numberOfSteps) {
    if (!dateInterval) {
      return;
    }
    if (dateInterval.isRegularInterval === false) {
      if (dateInterval.year !== 0) {
        date.setUTCFullYear(date.getUTCFullYear() + dateInterval.year * numberOfSteps);
      }
      if (dateInterval.month !== 0) {
        date.setUTCMonth(date.getUTCMonth() + dateInterval.month * numberOfSteps);
      }
      if (dateInterval.day !== 0) {
        date.setUTCDate(date.getUTCDate() + dateInterval.day * numberOfSteps);
      }
      if (dateInterval.hour !== 0) {
        date.setUTCHours(date.getUTCHours() + dateInterval.hour * numberOfSteps);
      }
      if (dateInterval.minute !== 0) {
        date.setUTCMinutes(date.getUTCMinutes() + dateInterval.minute * numberOfSteps);
      }
      if (dateInterval.second !== 0) {
        date.setUTCSeconds(date.getUTCSeconds() + dateInterval.second * numberOfSteps);
      }
    } else {
      date.setTime(date.getTime() + dateInterval.getTime() * numberOfSteps);
    }
  };
  date.substractMultipleTimes = function (dateInterval, numberOfSteps) {
    if (!dateInterval) {
      return;
    }
    if (dateInterval.isRegularInterval === false) {
      if (dateInterval.year !== 0) {
        date.setUTCFullYear(date.getUTCFullYear() - dateInterval.year * numberOfSteps);
      }
      if (dateInterval.month !== 0) {
        date.setUTCMonth(date.getUTCMonth() - dateInterval.month * numberOfSteps);
      }
      if (dateInterval.day !== 0) {
        date.setUTCDate(date.getUTCDate() - dateInterval.day * numberOfSteps);
      }
      if (dateInterval.hour !== 0) {
        date.setUTCHours(date.getUTCHours() - dateInterval.hour * numberOfSteps);
      }
      if (dateInterval.minute !== 0) {
        date.setUTCMinutes(date.getUTCMinutes() - dateInterval.minute * numberOfSteps);
      }
      if (dateInterval.second !== 0) {
        date.setUTCSeconds(date.getUTCSeconds() - dateInterval.second * numberOfSteps);
      }
    } else {
      date.setTime(date.getTime() - dateInterval.getTime() * numberOfSteps);
    }
  };
  date.toISO8601 = function () {
    function prf(input, width) {
      // print decimal with fixed length (preceding zero's)
      var string = "".concat(input);
      var len = width - string.length;
      var j;
      var zeros = '';
      for (j = 0; j < len; j += 1) {
        zeros += "0".concat(zeros);
      }
      string = zeros + string;
      return string;
    }
    var iso = "".concat(prf(date.getUTCFullYear(), 4), "-").concat(prf(date.getUTCMonth() + 1, 2), "-").concat(prf(date.getUTCDate(), 2), "T").concat(prf(date.getUTCHours(), 2), ":").concat(prf(date.getUTCMinutes(), 2), ":").concat(prf(date.getUTCSeconds(), 2), "Z");
    return iso;
  };
  date.clone = function () {
    return parseISO8601DateToDate(date.toISO8601());
  };
  return date;
};
/** ****************************************************** */
/* Parses ISO8601 time duration to a DateInterval Object */
/** ****************************************************** */
var parseISO8601IntervalToDateInterval = function parseISO8601IntervalToDateInterval(_isotime) {
  if (!_isotime) {
    return undefined;
  }
  var isotime = _isotime.trim();
  if (isotime.charAt(0) !== 'P') {
    return undefined;
  }
  var splittedOnT = isotime.split('T');
  var years = '0';
  var months = '0';
  var days = '0';
  var hours = '0';
  var minutes = '0';
  var seconds = '0';
  var YYYYMMDDPart = splittedOnT[0].split('P')[1];
  // Parse the left part
  if (YYYYMMDDPart) {
    var yearIndex = YYYYMMDDPart.indexOf('Y');
    var monthIndex = YYYYMMDDPart.indexOf('M');
    var dayIndex = YYYYMMDDPart.indexOf('D');
    if (yearIndex !== -1) {
      years = YYYYMMDDPart.substring(0, yearIndex);
    }
    if (monthIndex !== -1) {
      months = YYYYMMDDPart.substring(yearIndex + 1, monthIndex);
    }
    if (dayIndex !== -1) {
      var start = yearIndex;
      if (monthIndex !== -1) {
        start = monthIndex;
      }
      days = YYYYMMDDPart.substring(start + 1, dayIndex);
    }
  }
  // parse the right part
  if (splittedOnT.length > 0) {
    if (isDefined(splittedOnT[1])) {
      var HHMMSSPart = splittedOnT[1];
      if (HHMMSSPart) {
        var hourIndex = HHMMSSPart.indexOf('H');
        var minuteIndex = HHMMSSPart.indexOf('M');
        var secondIndex = HHMMSSPart.indexOf('S');
        if (hourIndex !== -1) {
          hours = HHMMSSPart.substring(0, hourIndex);
        }
        if (minuteIndex !== -1) {
          minutes = HHMMSSPart.substring(hourIndex + 1, minuteIndex);
        }
        if (secondIndex !== -1) {
          var _start = hourIndex;
          if (minuteIndex !== -1) {
            _start = minuteIndex;
          }
          seconds = HHMMSSPart.substring(_start + 1, secondIndex);
        }
      }
    }
  }
  // Assemble the dateInterval object
  var dateInterval = new DateInterval(years, months, days, hours, minutes, seconds);
  return dateInterval;
};
/** ******************************************************* */
/* Calculates the number of time steps with this interval */
/** ******************************************************* */
function getNumberOfTimeSteps(starttime, stoptime, interval) {
  if (!starttime || !stoptime || !interval) {
    return undefined;
  }
  var steps = 0;
  if (interval.month !== 0 || interval.year !== 0) {
    // In case of unequally distributed time steps, where the number of days leties within a month:
    var testtime = starttime.clone();
    var timestopms = stoptime.getTime();
    while (testtime.getTime() < timestopms) {
      testtime.add(interval);
      steps += 1;
    }
    steps += 1;
    return steps;
  }
  // In case of equally distributed time steps
  steps = parseInt(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (stoptime.getTime() - starttime.getTime()) / interval.getTime() + 0.5, 10) + 1;
  return steps;
}
// Takes "1999-01-01T00:00:00Z/2009-12-01T00:00:00Z/PT60S" as input
var ParseISOTimeRangeDuration = /*#__PURE__*/function () {
  function ParseISOTimeRangeDuration(isoTimeRangeDuration) {
    _classCallCheck(this, ParseISOTimeRangeDuration);
    this.initialized = false;
    var times = isoTimeRangeDuration.split('/');
    // Add safety checks for undefined elements
    if (times[2] === undefined) {
      times[2] = 'PT1M';
    }
    if (times[1] === undefined) {
      // eslint-disable-next-line prefer-destructuring
      times[1] = times[0];
      times[2] = 'PT1M';
    }
    // Convert the dates
    this.startTime = parseISO8601DateToDate(times[0]);
    this.stopTime = parseISO8601DateToDate(times[1]);
    if (!this.startTime || !this.stopTime) {
      debugLogger(DebugType.Warning);
      return;
    }
    /* Try to get the time interval. If not available default to 1 minute */
    var timeIntervalString = times[2] || 'PT1M';
    this.timeInterval = parseISO8601IntervalToDateInterval(timeIntervalString);
    if (!this.timeInterval) {
      debugLogger(DebugType.Warning);
      return;
    }
    // Calculate the number if steps
    this.timeSteps = getNumberOfTimeSteps(this.startTime, this.stopTime, this.timeInterval);
    this.getTimeSteps = this.getTimeSteps.bind(this);
    this.getDateAtTimeStep = this.getDateAtTimeStep.bind(this);
    this.getTimeStepFromISODate = this.getTimeStepFromISODate.bind(this);
    this.getTimeStepFromDate = this.getTimeStepFromDate.bind(this);
    this.getTimeStepFromDateWithinRange = this.getTimeStepFromDateWithinRange.bind(this);
    this.getTimeStepFromDateClipped = this.getTimeStepFromDateClipped.bind(this);
    /* Indicate that this object is properly constructed */
    this.initialized = true;
  }
  _createClass(ParseISOTimeRangeDuration, [{
    key: "getTimeSteps",
    value: function getTimeSteps() {
      return this.timeSteps;
    }
  }, {
    key: "getDateAtTimeStep",
    value: function getDateAtTimeStep(currentStep) {
      if (this.initialized === false) {
        return null;
      }
      if (!this.timeInterval) {
        debugLogger(DebugType.Warning);
        return null;
      }
      if (this.timeInterval.isRegularInterval === false) {
        var _temptime = this.startTime.clone();
        _temptime.addMultipleTimes(this.timeInterval, currentStep);
        return _temptime;
      }
      var temptime = this.startTime.clone();
      var dateIntervalTime = this.timeInterval.getTime();
      dateIntervalTime *= currentStep;
      temptime.setTime(temptime.getTime() + dateIntervalTime);
      return temptime;
    }
  }, {
    key: "getTimeStepFromISODate",
    value: function getTimeStepFromISODate(currentISODate, throwIfOutsideRange) {
      var currentDate = null;
      try {
        currentDate = parseISO8601DateToDate(currentISODate);
      } catch (e) {
        throw new Error("The date ".concat(currentISODate, " is not a valid date"));
      }
      return this.getTimeStepFromDate(currentDate, throwIfOutsideRange);
    }
    /* Calculates the time step at the given date  */
  }, {
    key: "getTimeStepFromDate",
    value: function getTimeStepFromDate(wantedDate) {
      var throwIfOutsideRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var wantedTime = wantedDate.getTime();
      if (wantedTime < this.startTime.getTime()) {
        if (throwIfOutsideRange === true) {
          throw new Error('0');
        }
        return 0;
      }
      var myStopTime = this.stopTime.clone();
      myStopTime.add(this.timeInterval);
      if (wantedTime >= myStopTime.getTime()) {
        if (throwIfOutsideRange === true) {
          throw new Error("".concat(this.timeSteps - 1));
        }
        return this.timeSteps - 1;
      }
      if (wantedTime > this.stopTime.getTime()) {
        return this.timeSteps - 1;
      }
      var timeStep = 0;
      if (this.timeInterval.isRegularInterval === false) {
        var next = this.startTime.clone();
        for (var currentTimeStepIndex = 0; currentTimeStepIndex < this.timeSteps; currentTimeStepIndex += 1) {
          var currentTime = next.getTime();
          next.add(this.timeInterval);
          var nextTime = next.getTime();
          if (isWithinInterval(wantedTime, {
            start: currentTime,
            end: nextTime
          })) {
            var timeInTheMiddle = (currentTime + nextTime) / 2;
            if (wantedTime > timeInTheMiddle) {
              return currentTimeStepIndex + 1;
            }
            return currentTimeStepIndex;
          }
        }
        throw new Error("Date ".concat(wantedDate.toISO8601(), " not found!"));
      } else {
        timeStep = (wantedDate.getTime() - this.startTime.getTime()) / this.timeInterval.getTime();
        // round 4.5 down to 4 by using this hack
        timeStep = -Math.round(-timeStep);
        return timeStep;
      }
    }
    /* Returns the timestep at the currentDate, if currentdate is outside the range,
    a exception is thrown.  */
  }, {
    key: "getTimeStepFromDateWithinRange",
    value: function getTimeStepFromDateWithinRange(currentDate) {
      return this.getTimeStepFromDate(currentDate, true);
    }
    /* Returns the timestep at the currentDate, if currentdate is outside the range,
    a minimum or maximum step which lies within the time range is returned.  */
  }, {
    key: "getTimeStepFromDateClipped",
    value: function getTimeStepFromDateClipped(currentDate) {
      return this.getTimeStepFromDate(currentDate, false);
    }
  }]);
  return ParseISOTimeRangeDuration;
}();
/* Example:
function init(){
  let isodate="1999-01-01T00:00:00Z/2009-12-01T00:00:00Z/PT60S";
  //Split on '/'
  let times=isodate.split('/');
  //Some safety checks
  if(times[1]==undefined){times[1]=times[0];times[2]='PT1M';}
  //Convert the dates
  starttime=parseISO8601DateToDate(times[0]);
  stoptime=parseISO8601DateToDate(times[1]);
  interval=parseISO8601IntervalToDateInterval(times[2]);
  //Calculate the number if steps
  steps=getNumberOfTimeSteps(starttime,stoptime,interval);
}
*/

/**
 * Re-formats moment's isoString to the string that is expected by WMJSDimension (for time).
 * @param dateIn The input date to re-format, usually in the format `YYYY-MM-DDThh:mm:ss.uuuZ`
 * @returns The formated input date in the format `YYYY-MM-DDThh:mm:ssZ`
 */
var handleMomentISOString = function handleMomentISOString(dateIn) {
  /* Try to fix the timestrings generated by moment js made with moment.toISOString() */
  if (!dateIn) {
    return null;
  }
  if (dateIn.length > 20) {
    var fixedDate = dateIn.substring(0, 19);
    return "".concat(fixedDate, "Z");
  }
  if (dateIn.length === 17) {
    var _fixedDate = dateIn.substring(0, 16);
    return "".concat(_fixedDate, ":00Z");
  }
  return dateIn;
};
/**
 * WMJSDimension Class
 * Keep all information for a single dimension, like time.
 * Author : MaartenPlieger (plieger at knmi.nl)
 * Copyright KNMI
 */
var WMJSDimension = /*#__PURE__*/function () {
  function WMJSDimension(config) {
    _classCallCheck(this, WMJSDimension);
    this.name = undefined; // Name of the dimension, e.g. 'time'
    this.units = undefined; // Units of the dimension, e.g. 'ISO8601'
    this.unitSymbol = undefined; // Unit symbol, eg: hPa
    this.linked = true;
    this.synced = false;
    this._initialized = false;
    this._timeRangeDurationDate = null; // Used for timerange (start/stop/res)
    this._allDates = []; // Used for individual timevalues
    this._type = null;
    this._allValues = [];
    this.setTimeValuesForReferenceTime = this.setTimeValuesForReferenceTime.bind(this);
    this.generateAllValues = this.generateAllValues.bind(this);
    this.reInitializeValues = this.reInitializeValues.bind(this);
    this.initialize = this.initialize.bind(this);
    this.getValue = this.getValue.bind(this);
    this.setValue = this.setValue.bind(this);
    this.getValues = this.getValues.bind(this);
    this.processCompressedRefTimeValues = this.processCompressedRefTimeValues.bind(this);
    this.createTimeStepsArray = this.createTimeStepsArray.bind(this);
    this.setClosestValue = this.setClosestValue.bind(this);
    this.addTimeRangeDurationToValue = this.addTimeRangeDurationToValue.bind(this);
    this.setTimeRangeDuration = this.setTimeRangeDuration.bind(this);
    this.getClosestValue = this.getClosestValue.bind(this);
    this.getValueForIndex = this.getValueForIndex.bind(this);
    this.get = this.get.bind(this);
    this.getFirstValue = this.getFirstValue.bind(this);
    this.getLastValue = this.getLastValue.bind(this);
    this.getDimInterval = this.getDimInterval.bind(this);
    this.getIndexForValue = this.getIndexForValue.bind(this);
    this.size = this.size.bind(this);
    this.clone = this.clone.bind(this);
    if (isDefined(config)) {
      if (isDefined(config.name)) {
        this.name = config.name.toLowerCase();
      }
      if (isDefined(config.units)) {
        this.units = config.units;
      }
      if (isDefined(config.unitSymbol)) {
        this.unitSymbol = config.unitSymbol;
      }
      if (isDefined(config.values)) {
        this.values = config.values;
      }
      if (isDefined(config.currentValue)) {
        this.currentValue = config.currentValue;
      }
      if (isDefined(config.defaultValue)) {
        this.defaultValue = config.defaultValue;
      }
      if (isDefined(config.linked)) {
        this.linked = config.linked;
      }
      if (isDefined(config.synced)) {
        this.synced = config.synced;
      }
    }
  }
  _createClass(WMJSDimension, [{
    key: "generateAllValues",
    value: function generateAllValues() {
      var vals = [];
      if (this.size() > 5000) {
        throw new Error('Error: Dimension too large to query all possible values at once');
      }
      for (var i = 0; i < this.size(); i += 1) {
        vals.push(this.getValueForIndex(i));
      }
      return vals;
    }
  }, {
    key: "setTimeValuesForReferenceTime",
    value: function setTimeValuesForReferenceTime(referenceTimeValueToSet, referenceTimeDim) {
      if (!this._initialized) {
        this.initialize();
      }
      if (!referenceTimeValueToSet) {
        this.reInitializeValues(this.values);
        this.setClosestValue(null);
        debugLogger(DebugType.Warning);
        return;
      }
      /*
       * Calculate the model run length,
       * this can be done by looking at the difference between
       * the last dim_reference_time and last dim_time
       */
      /* 1. Get the last value in the list of the referencetime */
      var lastRefTime = new Date(referenceTimeDim.getLastValue());
      /* 2. Get the original last value of the time dimension, we cannot use this.getLastValue(), as we are changing this. */
      var orgLastDimTime = new Date(this.values.split('/')[1]);
      /* 3. Now calculate the run length */
      var runLengthAsHour = dateUtils.differenceInHours(orgLastDimTime, lastRefTime);
      var newStartValueTime = new Date(referenceTimeValueToSet);
      var newEndValueTime = dateUtils.add(new Date(newStartValueTime.getTime()), {
        hours: runLengthAsHour
      });
      if (this._type === 'timestartstopres') {
        /* Compose a new dataString interval and re-initialize the time dimension */
        var dateStringItems = this.values.split('/').map(function (value) {
          return value.trim();
        });
        var dateStringInterval = dateStringItems[2];
        var newValue = "".concat(newStartValueTime.toISOString(), "/").concat(newEndValueTime.toISOString(), "/").concat(dateStringInterval);
        this.defaultValue = newEndValueTime.toISOString();
        this.reInitializeValues(newValue, true);
      } else if (this._type === 'timevalues') {
        /* Filter all dates from the array which are lower than given start value */
        /* TODO: Maarten Plieger 2020-06-10: Make this also work for WMS times advertised as a comma separated list */
        var _newValue2 = parseISO8601DateToDate(newStartValueTime.toISOString());
        var newArray = this._allDates.filter(function (x) {
          return x >= _newValue2;
        });
        var newValues = '';
        for (var j = 0; j < newArray.length; j += 1) {
          if (j > 0) {
            newValues += ',';
          }
          newValues += newArray[j].toISO8601();
        }
        this.reInitializeValues(newValues, true);
        this.setClosestValue();
      }
    }
  }, {
    key: "reInitializeValues",
    value: function reInitializeValues(values) {
      var forceReferenceTimeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._initialized = false;
      this.initialize(values, forceReferenceTimeValue);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;
      var forceothervalues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var forceReferenceTimeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this._initialized === true) {
        return;
      }
      var ogcdimvalues = this.values;
      if (forceothervalues) {
        ogcdimvalues = forceothervalues;
      }
      if (!isDefined(ogcdimvalues)) {
        return;
      }
      this._allValues = [];
      this._initialized = true;
      if (this.units === 'ISO8601') {
        if (ogcdimvalues.indexOf('/') > 0 && ogcdimvalues.indexOf(',') === -1) {
          this._type = 'timestartstopres';
          this._timeRangeDurationDate = new ParseISOTimeRangeDuration(ogcdimvalues);
          this.processCompressedRefTimeValues(ogcdimvalues);
        } else {
          this._type = 'timevalues';
          if (ogcdimvalues.indexOf('/') > 0 && ogcdimvalues.indexOf(',') === -1 && this.name === 'reference_time') {
            this.processCompressedRefTimeValues(ogcdimvalues);
          }
        }
      } else {
        this._type = 'anyvalue';
        this.linked = false;
      }
      if (this._type !== 'timestartstopres') {
        var values = ogcdimvalues.split(',');
        values.forEach(function (value) {
          var valuesRangedNoTrim = value.split('/');
          if (valuesRangedNoTrim.length === 3) {
            var valuesRanged = valuesRangedNoTrim.map(function (value) {
              return value.trim();
            });
            /* Can be either time like '2021-03-17T06:00:00Z/2021-03-21T00:00:00Z/PT6H' or something else, like '0/24/2' */
            if (valuesRanged[2].charAt(0) === 'P') {
              var partTimeRanges = new ParseISOTimeRangeDuration(value);
              for (var i = 0; i < partTimeRanges.getTimeSteps(); i += 1) {
                var dataAtTimeStep = partTimeRanges.getDateAtTimeStep(i);
                try {
                  _this._allValues.push(dataAtTimeStep.toISO8601());
                } catch (e) {
                  _this._allValues.push(dataAtTimeStep.toString());
                }
              }
              _this.processCompressedRefTimeValues(ogcdimvalues);
            } else {
              var start = parseFloat(valuesRanged[0]);
              var stop = parseFloat(valuesRanged[1]);
              var res = parseFloat(valuesRanged[2]);
              stop += res;
              if (start > stop) {
                stop = start;
              }
              if (res <= 0) {
                res = 1;
              }
              for (var j2 = start; j2 < stop; j2 += res) {
                _this._allValues.push(String(j2));
              }
            }
          } else {
            _this._allValues.push(String(value));
          }
        });
        if (this._type === 'timevalues') {
          this._allDates.length = 0;
          this._allValues.forEach(function (value) {
            _this._allDates.push(parseISO8601DateToDate(value));
          });
        }
      }
      /* If no default value is given, take the last / most recent one */
      if (!isDefined(this.defaultValue) || this.defaultValue === '') {
        this.defaultValue = this.getLastValue();
      }
      /* Check if the string 'current' is given, and find the closest value inside the dimension */
      if (this.defaultValue === 'current') {
        this.defaultValue = this.getClosestValue(moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'), true);
      }
      /* If no currentvalue is set, set the default */
      if (!this.currentValue || this.currentValue.length === 0) {
        this.currentValue = this.defaultValue;
      }
      /* Check for out of range values and adjust accordingly to a valid range */
      var index = this.getIndexForValue(this.currentValue);
      if (index === -2) {
        this.currentValue = this.getLastValue(); // Date is past the latest (-2), so set it to the last value
      }
      if (index === -1) {
        this.currentValue = this.getFirstValue(); // Date is past the first (-1), so set it to the first value
      }
      /* In case of reference time, the time dimension range is changed, check if the current time still fits in that range */
      if (forceReferenceTimeValue) {
        if (this.getIndexForValue(this.currentValue, true) < 0) {
          this.currentValue = this.getClosestValue(this.currentValue);
        }
      }
      this.dimMinValue = this.getFirstValue();
      this.dimMaxValue = this.getLastValue();
      if (this._timeRangeDurationDate) {
        this.dimTimeInterval = this._timeRangeDurationDate.timeInterval;
      } else {
        this.dimTimeInterval = null;
      }
    }
    /**
     * Returns the current value of this dimensions.
     * If a ISO8601 period is set, the getValue will return a timeRange using addTimeRangeDurationToValue instead of a single value
     */
  }, {
    key: "getValue",
    value: function getValue() {
      if (!this._initialized) {
        this.initialize();
      }
      var value = this.defaultValue;
      if (isDefined(this.currentValue)) {
        value = this.currentValue;
      }
      value = this.addTimeRangeDurationToValue(value);
      return value;
    }
  }, {
    key: "processCompressedRefTimeValues",
    value: function processCompressedRefTimeValues(ogcdimvalues) {
      var _this2 = this;
      if (this.name === 'reference_time') {
        // Split the format start/stop/res
        var splitValues = ogcdimvalues.split(',');
        var timeRanges = splitValues.filter(function (value) {
          return value.includes('/') && value.includes('P');
        });
        var allValues = [];
        // Get all the ranges between start and stop time
        timeRanges.forEach(function (timeRange) {
          var partTimeRanges = new ParseISOTimeRangeDuration(timeRange);
          var newValues = _this2.createTimeStepsArray(partTimeRanges);
          allValues = allValues.concat(newValues);
        });
        // Some ogcdimvalues deliver the interval for arbitrary timesteps which may stop the array
        // In that case, get the last date to set as dimMaxValue
        var lastTimeRangeString = splitValues[splitValues.length - 1];
        if (lastTimeRangeString.includes('/') && lastTimeRangeString.includes('P')) {
          var _lastTimeRangeString$ = lastTimeRangeString.split('/'),
            _lastTimeRangeString$2 = _slicedToArray(_lastTimeRangeString$, 2),
            endDateString = _lastTimeRangeString$2[1];
          this.dimMaxValue = endDateString;
        }
        this.values = allValues.join(',');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "createTimeStepsArray",
    value: function createTimeStepsArray(partTimeRanges) {
      return Array.from({
        length: partTimeRanges.getTimeSteps()
      }, function (_, i) {
        var dataAtTimeStep = partTimeRanges.getDateAtTimeStep(i);
        if (dataAtTimeStep && !isNaN(dataAtTimeStep.getTime())) {
          var isoDateString = dataAtTimeStep.toISO8601();
          return isoDateString;
        }
        return null;
      }).filter(function (dateString) {
        return dateString !== null;
      });
    }
    /**
     * Set current value of this dimension
     * @param value The new value for this dimension (string)
     * @param forceValue When set to false,check if the given value is outside range, and do nothing if this is the case
     */
  }, {
    key: "setValue",
    value: function setValue(value) {
      var forceValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this._initialized) {
        this.initialize();
      }
      if (forceValue === false) {
        if (value === WMDateOutSideRange || value === WMDateTooEarlyString || value === WMDateTooLateString) {
          return;
        }
      }
      this.currentValue = value;
    }
    /**
     * Returns values of the dimension, according to values defined in WMS specification, e.g. 2011-01-01T00:00:00Z/2012-01-01T00:00:00Z/P1M or list of values.
     * @returns
     */
  }, {
    key: "getValues",
    value: function getValues() {
      this.initialize();
      return this.values;
    }
  }, {
    key: "setClosestValue",
    value: function setClosestValue() {
      var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var evenWhenOutsideRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var newClosestValue = newValue || this.getValue();
      this.currentValue = this.getClosestValue(newClosestValue, evenWhenOutsideRange);
    }
  }, {
    key: "addTimeRangeDurationToValue",
    value: function addTimeRangeDurationToValue(value) {
      if (value === WMDateOutSideRange || value === WMDateTooEarlyString || value === WMDateTooLateString) {
        return value;
      }
      if (this.timeRangeDuration && this.timeRangeDuration.length > 0) {
        var interval = parseISO8601IntervalToDateInterval(this.timeRangeDuration);
        var value2date = parseISO8601DateToDate(value);
        value2date.add(interval);
        var value2 = value2date.toISO8601();
        return "".concat(value, "/").concat(value2);
      }
      return value;
    }
    // If a ISO8601 period is given, the getValue will return a timeRange instead of a single value
  }, {
    key: "setTimeRangeDuration",
    value: function setTimeRangeDuration(duration) {
      this.timeRangeDuration = duration;
      if (duration && duration.length > 0) {
        this.reInitializeValues(this.values);
        var startDate = parseISO8601DateToDate(this.dimMinValue);
        var stopDate = this.dimMaxValue;
        var interval = parseISO8601IntervalToDateInterval(this.timeRangeDuration);
        if (interval.minute !== 0) {
          startDate.setUTCSeconds(0);
        }
        if (interval.hour !== 0) {
          startDate.setUTCSeconds(0);
          startDate.setUTCMinutes(0);
        }
        if (interval.day !== 0) {
          startDate.setUTCSeconds(0);
          startDate.setUTCMinutes(0);
          startDate.setUTCHours(0);
        }
        if (interval.month !== 0) {
          startDate.setUTCSeconds(0);
          startDate.setUTCMinutes(0);
          startDate.setUTCHours(0);
          startDate.setUTCDate(1);
        }
        this.reInitializeValues("".concat(startDate.toISO8601(), "/").concat(stopDate, "/").concat(this.timeRangeDuration));
      } else {
        this.reInitializeValues(this.values);
      }
    }
  }, {
    key: "getClosestValue",
    value: function getClosestValue(_newValue) {
      var evenWhenOutsideRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.initialize();
      if (!this._initialized) {
        return _newValue;
      }
      var newValue = _newValue && _newValue.indexOf('/') !== -1 ? _newValue.split('/')[0] : _newValue;
      if (newValue === 'current' || newValue === 'default' || newValue === '') {
        return this.defaultValue;
      }
      if (newValue === 'middle') {
        var middleIndex = Math.ceil(this.size() / 2) - 1;
        if (middleIndex < 0) {
          middleIndex = 0;
        }
        return this.getValueForIndex(middleIndex);
      }
      if (newValue === 'latest') {
        return this.getLastValue();
      }
      if (newValue === 'earliest') {
        return this.getFirstValue();
      }
      var index = -1;
      var value = WMDateOutSideRange;
      try {
        index = this.getIndexForValue(newValue);
        value = this.getValueForIndex(index);
      } catch (e) {
        if (typeof e.message === 'number') {
          if (e.message === '0') {
            value = WMDateTooEarlyString;
          } else {
            value = WMDateTooLateString;
          }
        }
      }
      if (evenWhenOutsideRange && value === WMDateTooLateString) {
        value = this.getLastValue();
      } else if (evenWhenOutsideRange && value === WMDateTooEarlyString) {
        value = this.getValueForIndex(0);
      }
      return value;
    }
    /**
     * Get dimension value for specified index
     */
  }, {
    key: "getValueForIndex",
    value: function getValueForIndex(index) {
      this.initialize();
      if (!this._initialized) {
        return this.currentValue;
      }
      if (index < 0) {
        if (index === -1) {
          return WMDateTooEarlyString;
        }
        if (index === -2) {
          return WMDateTooLateString;
        }
        return -1;
      }
      if (this._type === 'timestartstopres') {
        try {
          return this._timeRangeDurationDate.getDateAtTimeStep(index).toISO8601();
        } catch (e) {
          // nothing
        }
        return this._timeRangeDurationDate.getDateAtTimeStep(index);
      }
      if (this._type === 'timevalues' || this._type === 'anyvalue') {
        return this._allValues[index];
      }
      return null;
    }
    /**
     * Hint about the timestep size / time resolution of this dimension.
     * @returns The dimTimeInterval
     */
  }, {
    key: "getDimInterval",
    value: function getDimInterval() {
      this.initialize();
      if (!this.dimTimeInterval) {
        return undefined;
      }
      var _this$dimTimeInterval = this.dimTimeInterval,
        year = _this$dimTimeInterval.year,
        month = _this$dimTimeInterval.month,
        day = _this$dimTimeInterval.day,
        hour = _this$dimTimeInterval.hour,
        minute = _this$dimTimeInterval.minute,
        second = _this$dimTimeInterval.second,
        isRegularInterval = _this$dimTimeInterval.isRegularInterval;
      return {
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        isRegularInterval: isRegularInterval
      };
    }
    /**
     * Shorthand functionf or getValueForIndex
     */
  }, {
    key: "get",
    value: function get(index) {
      return this.getValueForIndex(index);
    }
    /**
     * Returns the first dimension value
     */
  }, {
    key: "getFirstValue",
    value: function getFirstValue() {
      return this.get(0);
    }
    /**
     * Returns the last dimension value
     */
  }, {
    key: "getLastValue",
    value: function getLastValue() {
      return this.get(this.size() - 1);
    }
    /**
     * Get index value for specified value. Returns the index in the store for the given time value, either a date or a iso8601 string can be passes as input.
     * @param value Either a JS Date object or an ISO8601 String
     * @return The index of the value.  If outSideOfRangeFlag is false, a valid index will
     * always be returned. If outSideOfRangeFlag is true:
     * -1 if the value is not in the store, and is lower than available values,
     * -2 if the value is not in the store, and is higher than available values
     */
  }, {
    key: "getIndexForValue",
    value: function getIndexForValue(value) {
      var _this3 = this;
      var outSideOfRangeFlag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.initialize();
      if (typeof value === 'string') {
        if (value === 'current' && this.defaultValue !== 'current') {
          return this.getIndexForValue(this.defaultValue);
        }
      }
      if (this._type === 'timestartstopres') {
        try {
          if (typeof value === 'string') {
            return this._timeRangeDurationDate.getTimeStepFromISODate(value, outSideOfRangeFlag);
          }
          return this._timeRangeDurationDate.getTimeStepFromDate(value, outSideOfRangeFlag);
        } catch (e) {
          if (parseInt(e.message, 10) === 0) {
            return -1;
          }
          return -2;
        }
      }
      if (this._type === 'timevalues') {
        try {
          var wantedTime = parseISO8601DateToDate(value).getTime();
          var minDistance = null;
          var foundIndex = 0;
          var startTime = null;
          var stopTime = null;
          this._allValues.forEach(function (_, valueIndex) {
            var currentTime = _this3._allDates[valueIndex].getTime();
            if (currentTime < startTime || startTime === null) {
              startTime = currentTime;
            }
            if (currentTime > stopTime || stopTime === null) {
              stopTime = currentTime;
            }
            var distance = Math.abs(currentTime - wantedTime);
            if (valueIndex === 0) {
              minDistance = distance;
            }
            if (minDistance > distance) {
              minDistance = distance;
              foundIndex = valueIndex;
            }
          });
          if (outSideOfRangeFlag) {
            if (startTime > wantedTime) {
              return -1;
            }
            if (stopTime < wantedTime) {
              return -2;
            }
          }
          return foundIndex;
        } catch (e) {
          debugLogger(DebugType.Error);
          return -1;
        }
      }
      if (this._type === 'anyvalue') {
        for (var j = 0; j < this._allValues.length; j += 1) {
          if (this._allValues[j] === value) {
            return j;
          }
        }
      }
      return -1;
    }
    /**
     * Get number of values
     */
  }, {
    key: "size",
    value: function size() {
      this.initialize();
      if (this._type === 'timestartstopres') {
        return this._timeRangeDurationDate.getTimeSteps();
      }
      if (this._type === 'timevalues' || this._type === 'anyvalue') {
        return this._allValues.length;
      }
      return null;
    }
    /**
     * Clone this dimension
     */
  }, {
    key: "clone",
    value: function clone() {
      var dim = new WMJSDimension();
      dim.name = this.name;
      dim.units = this.units;
      dim.unitSymbol = this.unitSymbol;
      dim.values = this.values;
      dim.initialize();
      dim.currentValue = this.currentValue;
      dim.defaultValue = this.defaultValue;
      dim.linked = this.linked;
      dim.synced = this.synced;
      return dim;
    }
  }]);
  return WMJSDimension;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var WMDrawMarker = function WMDrawMarker(context, coordx, coordy) {
  var fillColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#FFF';
  var ctx = context;
  var coord = {
    x: parseInt(coordx.toString(), 10),
    y: parseInt(coordy.toString(), 10)
  };
  ctx.fillStyle = fillColor;
  ctx.globalAlpha = 1.0;
  ctx.beginPath();
  var topRadius = 7;
  var topHeight = 2 * topRadius;
  ctx.arc(coord.x, coord.y - topHeight, topRadius, Math.PI, Math.PI * 2);
  ctx.bezierCurveTo(coord.x + topRadius, coord.y - topHeight, coord.x + topRadius / 1.6, coord.y - topRadius, coord.x, coord.y);
  ctx.bezierCurveTo(coord.x, coord.y, coord.x - topRadius / 1.6, coord.y - topRadius, coord.x - topRadius, coord.y - topHeight);
  ctx.stroke();
  ctx.fill();
  /* Fill center circle */
  ctx.fillStyle = '#FFF';
  ctx.beginPath();
  ctx.arc(coord.x, coord.y - topHeight, topRadius / 2.5, Math.PI * 2, 0);
  ctx.fill();
};

var MapPin = /*#__PURE__*/function () {
  function MapPin(_map) {
    var _this = this;
    _classCallCheck(this, MapPin);
    this._map = null;
    this.x = null;
    this.y = null;
    this.exactX = null;
    this.exactY = null;
    this.geoPosX = null;
    this.geoPosY = null;
    this.displayMapPin = true;
    this.disableMapPin = false;
    this.redrawMap = function () {
      _this._map.draw();
    };
    this.repositionMapPin = function (_bbox) {
      if (!_bbox) {
        return;
      }
      var newpos = _this._map.getPixelCoordFromGeoCoord({
        x: _this.geoPosX,
        y: _this.geoPosY
      }, _bbox);
      _this.setMapPin(newpos.x, newpos.y, _bbox);
    };
    this.setMapPin = function (_x, _y, _bbox) {
      var x = _x;
      var y = _y;
      if (!x || !y) {
        return;
      }
      if (_this.disableMapPin && !_bbox) {
        return; // we still want to update the pin position when the bbox changes.
      }
      _this.x = parseInt(x, 10);
      _this.y = parseInt(y, 10);
      _this.exactX = parseFloat(x);
      _this.exactY = parseFloat(y);
      var geopos = _this._map.getGeoCoordFromPixelCoord({
        x: _this.exactX,
        y: _this.exactY
      }, _bbox);
      _this.geoPosX = geopos.x;
      _this.geoPosY = geopos.y;
      _this.redrawMap();
    };
    this.positionMapPinByLatLon = function (coord) {
      debugLogger(DebugType.Log, "positionMapPinByLatLon at ".concat(coord.x, ",").concat(coord.y));
      var newpos = _this._map.getPixelCoordFromLatLong(coord);
      _this.setMapPin(newpos.x, newpos.y);
    };
    this.setMapPinDisabled = function () {
      _this.disableMapPin = true;
      _this.redrawMap();
    };
    this.setMapPinEnabled = function () {
      _this.disableMapPin = false;
      _this.redrawMap();
    };
    this.showMapPin = function () {
      _this.displayMapPin = true;
      _this.redrawMap();
    };
    this.hideMapPin = function () {
      _this.displayMapPin = false;
      _this.redrawMap();
    };
    this.getXY = function () {
      return {
        x: _this.x,
        y: _this.y
      };
    };
    this._map = _map;
  }
  _createClass(MapPin, [{
    key: "drawMarker",
    value: function drawMarker(ctx) {
      if (isDefined(this.x) && isDefined(this.y)) {
        WMDrawMarker(ctx, this.x, this.y, this.disableMapPin ? '#808080' : '#051039');
      }
    }
  }]);
  return MapPin;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2024 - Finnish Meteorological Institute (FMI)
 * */
var getBBOXandProjString = function getBBOXandProjString(map, layer) {
  var request = '';
  var _map$getProjection = map.getProjection(),
    srs = _map$getProjection.srs;
  var bbox = map.getDrawBBOX();
  if (layer.version === WMSVersion.version100 || layer.version === WMSVersion.version111) {
    request += "SRS=".concat(URLEncode(srs), "&");
    request += "BBOX=".concat(bbox.left, ",").concat(bbox.bottom, ",").concat(bbox.right, ",").concat(bbox.top, "&");
  }
  if (layer.version === WMSVersion.version130) {
    request += "CRS=".concat(URLEncode(srs), "&");
    if (srs === 'EPSG:4326' && layer.wms130bboxcompatibilitymode === false) {
      request += "BBOX=".concat(bbox.bottom, ",").concat(bbox.left, ",").concat(bbox.top, ",").concat(bbox.right, "&");
    } else {
      request += "BBOX=".concat(bbox.left, ",").concat(bbox.bottom, ",").concat(bbox.right, ",").concat(bbox.top, "&");
    }
  }
  return request;
};
// Build a valid WMS request for a certain layer
var buildWMSGetMapRequest = function buildWMSGetMapRequest(map, layer, dimensionOverride) {
  var _a;
  if (!isDefined(layer.name) || layer.name.length < 1) {
    return undefined;
  }
  var _map$getProjection2 = map.getProjection(),
    srs = _map$getProjection2.srs;
  var mapBbox = map.getDrawBBOX();
  var _map$getSize = map.getSize(),
    width = _map$getSize.width,
    height = _map$getSize.height;
  // eslint-disable-next-line no-param-reassign
  (_a = layer.format) !== null && _a !== void 0 ? _a : layer.format = 'image/png';
  // GetFeatureInfo timeseries in the mapview
  if (srs === 'GFI:TIME_ELEVATION') {
    var x = 707;
    var y = 557;
    var bbox = '29109.947643979103,6500000,1190890.052356021,7200000';
    var _srs = 'GFI:TIME_ELEVATION';
    var _request = layer.getmapURL;
    _request += "&SERVICE=WMS&REQUEST=GetFeatureInfo&VERSION=".concat(layer.version);
    _request += "&LAYERS=".concat(URLEncode(layer.name));
    var baseLayers = layer.name.split(',');
    _request += "&QUERY_LAYERS=".concat(URLEncode(baseLayers[baseLayers.length - 1]));
    _request += "&BBOX=".concat(bbox);
    if (layer.version === WMSVersion.version100 || layer.version === WMSVersion.version111) {
      _request += "&SRS=".concat(URLEncode(_srs), "&");
    }
    if (layer.version === WMSVersion.version130) {
      _request += "&CRS=".concat(URLEncode(_srs), "&");
    }
    _request += "WIDTH=".concat(width);
    _request += "&HEIGHT=".concat(height);
    if (layer.version === WMSVersion.version100 || layer.version === WMSVersion.version111) {
      _request += "&X=".concat(x);
      _request += "&Y=".concat(y);
    }
    if (layer.version === WMSVersion.version130) {
      _request += "&I=".concat(x);
      _request += "&J=".concat(y);
    }
    if (layer.sldURL) {
      _request += "&SLD=".concat(URLEncode(layer.sldURL));
    }
    _request += '&FORMAT=image/gif';
    _request += '&INFO_FORMAT=image/png';
    _request += '&STYLES=';
    _request += '&TRANSPARENT=TRUE';
    var startDate = dateToISO8601(new Date(mapBbox.left));
    var stopDate = dateToISO8601(new Date(mapBbox.right));
    _request += "&time=".concat(startDate, "/").concat(stopDate);
    _request += "&elevation=".concat(mapBbox.bottom, "/").concat(mapBbox.top);
    return {
      url: _request,
      headers: layer.headers
    };
  }
  var request = WMJScheckURL(layer.getmapURL);
  request += '&SERVICE=WMS&';
  request += "VERSION=".concat(layer.version, "&");
  request += 'REQUEST=GetMap&';
  request += "LAYERS=".concat(URLEncode(layer.name), "&");
  request += "WIDTH=".concat(width, "&");
  request += "HEIGHT=".concat(height, "&");
  request += getBBOXandProjString(map, layer);
  if (layer.sldURL) {
    request += "SLD=".concat(URLEncode(layer.sldURL), "&");
  }
  request += "STYLES=".concat(URLEncode(layer.currentStyle), "&");
  request += "FORMAT=".concat(layer.format, "&");
  if (layer.transparent === true) {
    request += 'TRANSPARENT=TRUE&';
  } else {
    request += 'TRANSPARENT=FALSE&';
  }
  // Handle dimensions
  try {
    request += getMapDimURL(layer, dimensionOverride);
  } catch (e) {
    return undefined;
  }
  // Handle WMS extensions
  request += layer.wmsextensions.url;
  return {
    url: request,
    headers: layer.headers
  };
};
var isProjectionSupported = function isProjectionSupported(srs) {
  var proj4Defintions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WMProj4Defs;
  return proj4Defintions.find(function (proj4Def) {
    return proj4Def[0] === srs;
  }) !== undefined;
};

var SCALE_DELAY = 10;
var ZOOMED_CALLBACK_DELAY = 500;
var THROTTLE_OPTIONS = {
  noTrailing: true
};
var THROTTLE_WAIT_TIME = 300;
var WMFlyToBBox = /*#__PURE__*/_createClass(function WMFlyToBBox(wmMap) {
  var _this = this;
  _classCallCheck(this, WMFlyToBBox);
  this.flyZoomToBBOXTimerStart = 1;
  this.flyZoomToBBOXTimerSteps = 5;
  this.flyZoomToBBOXScaler = 0;
  this.flyZoomToBBOXCurrent = new WMBBOX();
  this.flyZoomToBBOXFly = new WMBBOX();
  this.flyZoomToBBOXNew = new WMBBOX();
  this.flyZoomToBBOXContinueNew = new WMBBOX();
  this.flyZoomToBBOXTimerFuncBusy = 0;
  this.flyZoomToBBOXTimerFuncBusyAndContinue = 0;
  this.flyZoomToBBOXTimerFuncReadyDebounced = function () {
    _this.wmMap.setBBOX(_this.flyZoomToBBOXFly);
    _this.wmMap.display();
    _this.wmMap.draw('flyZoomToBBOXTimerFunc');
  };
  this.flyZoomToBBOXTimerFunc = function () {
    _this.flyZoomToBBOXScaler = _this.flyZoomToBBOXTimerLoop / _this.flyZoomToBBOXTimerSteps;
    var z1 = 1 - _this.flyZoomToBBOXScaler;
    _this.flyZoomToBBOXFly.left = _this.flyZoomToBBOXCurrent.left * z1 + _this.flyZoomToBBOXNew.left * _this.flyZoomToBBOXScaler;
    _this.flyZoomToBBOXFly.bottom = _this.flyZoomToBBOXCurrent.bottom * z1 + _this.flyZoomToBBOXNew.bottom * _this.flyZoomToBBOXScaler;
    _this.flyZoomToBBOXFly.right = _this.flyZoomToBBOXCurrent.right * z1 + _this.flyZoomToBBOXNew.right * _this.flyZoomToBBOXScaler;
    _this.flyZoomToBBOXFly.top = _this.flyZoomToBBOXCurrent.top * z1 + _this.flyZoomToBBOXNew.top * _this.flyZoomToBBOXScaler;
    _this.wmMap._updateBoundingBox(_this.flyZoomToBBOXFly, false);
    _this.flyZoomToBBOXTimerLoop += 1;
    if (_this.flyZoomToBBOXTimerLoop > _this.flyZoomToBBOXTimerSteps) {
      _this.flyZoomToBBOXTimerLoop = _this.flyZoomToBBOXTimerStart;
      _this.wmMap.updateBBOX.setBBOX(_this.flyZoomToBBOXFly);
      _this.wmMap.drawnBBOX.setBBOX(_this.flyZoomToBBOXFly);
      _this.flyZoomToBBOXTimerFuncReadyDebounced();
      if (_this.flyZoomToBBOXTimerFuncBusyAndContinue === 0) {
        _this.flyZoomToBBOXTimerFuncBusyAndContinue = 0;
        _this.flyZoomToBBOXTimerFuncBusy = 0;
        _this.wmMap.draw('flyZoomToBBOXTimerFunc');
      } else {
        _this.flyZoomToBBOXTimerFuncBusyAndContinue = 0;
        _this.flyZoomToBBOXTimerFuncBusy = 0;
        _this.flyZoomToBBOXStartZoom(_this.wmMap.updateBBOX, _this.flyZoomToBBOXContinueNew);
      }
      return;
    }
    _this.flyZoomToBBOXDebounced();
  };
  this.resetBBoxTimer = function () {
    _this.flyZoomToBBOXDebounced.cancel();
    _this.flyZoomToBBOXDebounced = debounce(SCALE_DELAY, _this.flyZoomToBBOXTimerFunc);
  };
  this.flyZoomToBBOXStop = function () {
    _this.wmMap.setBBOX(_this.flyZoomToBBOXFly);
    _this.flyZoomToBBOXTimerFuncBusyAndContinue = 0;
    _this.flyZoomToBBOXTimerFuncBusy = 0;
    _this.resetBBoxTimer();
  };
  this.flyZoomToBBOXStartZoom = function (currentbox, newbox) {
    if (_this.flyZoomToBBOXTimerFuncBusy === 1) {
      _this.flyZoomToBBOXContinueNew.copy(newbox);
      _this.flyZoomToBBOXTimerFuncBusyAndContinue = 1;
      return;
    }
    _this.flyZoomToBBOXCurrent.copy(currentbox);
    _this.flyZoomToBBOXNew.copy(newbox);
    _this.flyZoomToBBOXTimerLoop = _this.flyZoomToBBOXTimerStart;
    _this.flyZoomToBBOXTimerFuncBusyAndContinue = 0;
    if (_this.flyZoomToBBOXTimerFuncBusy === 0) {
      _this.flyZoomToBBOXTimerFuncBusy = 1;
      _this.flyZoomToBBOXTimerFunc();
    }
  };
  this.startZoomThrottled = throttle(THROTTLE_WAIT_TIME, function (currentbox, newbox) {
    _this.flyZoomToBBOXStartZoom(currentbox, newbox);
  }, THROTTLE_OPTIONS);
  this.flyZoomToBBOXStartZoomThrottled = function (currentbox, newbox) {
    _this.startZoomThrottled(currentbox, newbox);
  };
  this.wmMap = wmMap;
  this.flyZoomToBBOXTimerFuncReadyDebounced = debounce(ZOOMED_CALLBACK_DELAY, this.flyZoomToBBOXTimerFuncReadyDebounced);
  this.flyZoomToBBOXDebounced = debounce(SCALE_DELAY, this.flyZoomToBBOXTimerFunc);
});

var version = '3.0.1';
/**
 * Set base URL of several sources used wihtin webmapjs
 */
/* Global vars */
var WebMapJSMapNo = 0;
var bgMapImageStore = new WMImageStore(bgImageStoreLength, {
  id: 'bgMapImageStore'
});
var detectLeftButton = function detectLeftButton(evt) {
  if (evt.buttons) {
    return evt.buttons === 1;
  }
  return evt.button === 0;
};
var detectRightButton = function detectRightButton(evt) {
  if (evt.buttons) {
    return evt.buttons === 2;
  }
  return evt.button === 2;
};
var getErrorsToDisplay = function getErrorsToDisplay(canvasErrors, getLayerByServiceAndName) {
  return canvasErrors.reduce(function (list, error) {
    if (error.linkedInfo && error.linkedInfo.layer) {
      var layer = getLayerByServiceAndName(error.linkedInfo.layer.service, error.linkedInfo.layer.name);
      // Only show if layer is present and enabled
      if (layer && layer.enabled) {
        var message = error.linkedInfo.message ? ", ".concat(error.linkedInfo.message) : '';
        return list.concat("Layer with title ".concat(error.linkedInfo.layer.title, " failed to load").concat(message));
      }
    } else {
      return list.concat('Layer failed to load.');
    }
    return list;
  }, []);
};
var clearImageCache = function clearImageCache() {
  getMapImageStore.clear();
  getLegendImageStore().clear();
};
/**
/**
  * WMJSMap class
  */
var WMJSMap = /*#__PURE__*/function () {
  function WMJSMap(_element) {
    var _this = this;
    _classCallCheck(this, WMJSMap);
    this.internalMapId = '';
    // eslint-disable-next-line class-methods-use-this
    this.onContextMenu = function () {
      return false;
    };
    this.setMouseCoordinates = function (x, y) {
      _this.mouseX = x;
      _this.mouseY = y;
    };
    this.WebMapJSMapVersion = version;
    this.mainElement = _element;
    this.baseDiv = undefined;
    this.srs = undefined;
    this.resizeBBOX = new WMBBOX();
    this.defaultBBOX = new WMBBOX();
    this.width = 2;
    this.height = 2;
    this.layers = [];
    this.mapdimensions = []; // Array of Dimension;
    this.initialAnimationStep = 0;
    this.baseLayers = [];
    this.numBaseLayers = 0;
    this._map = this;
    this.renderer = 'WMCanvasBuffer';
    this.layersBusy = 0;
    this.mapBusy = false;
    this.hasGeneratedId = false;
    this.divZoomBox = document.createElement('div');
    this.divBoundingBox = document.createElement('div');
    this.divDimInfo = document.createElement('div');
    this._displayLegendInMap = true;
    this.bbox = new WMBBOX(); // Boundingbox that will be used for map loading
    this.updateBBOX = new WMBBOX(); // Boundingbox to move map without loading anything
    this.drawnBBOX = new WMBBOX(); // Boundingbox that is used when map is drawn
    this.divBuffer = undefined;
    this.isDestroyed = false;
    this.mapHeader = {
      height: 0,
      fill: {
        color: '#EEE',
        opacity: 0.4
      },
      hover: {
        color: '#017daf',
        opacity: 0.9
      },
      selected: {
        color: '#017daf',
        opacity: 1.0
      },
      hoverSelected: {
        color: '#017daf',
        opacity: 1.0
      },
      cursorSet: false,
      prevCursor: 'default',
      hovering: false
    };
    this.currentCursor = 'default';
    this.mapIsActivated = false;
    this.isMapHeaderEnabled = false;
    this.showScaleBarInMap = true;
    this.showCursorCoordinates = true;
    this.mouseHoverAnimationBox = false;
    this.callBack = new WMListener();
    this.initialized = false;
    this.suspendDrawing = false;
    this.activeLayer = undefined;
    /* Undo: */
    this.MaxUndos = 3;
    this.NrOfUndos = 0;
    this.UndoPointer = 0;
    this.DoUndo = 0;
    this.DoRedo = 0;
    this.WMProjectionUndo = new Array(this.MaxUndos);
    this.WMProjectionTempUndo = new Array(this.MaxUndos);
    for (var j = 0; j < this.MaxUndos; j += 1) {
      this.WMProjectionUndo[j] = new WMProjection();
      this.WMProjectionTempUndo[j] = new WMProjection();
    }
    /* Contains the event values for when the mouse was pressed down (used for checking the shiftKey); */
    this.gfiDialogList = [];
    this.setTimeOffsetValue = '';
    this.setMessageValue = '';
    this.canvasErrors = [];
    this.resizeWidth = -1;
    this.resizeHeight = -1;
    this.wmAnimate = undefined;
    this.mouseWheelBusy = 0;
    this.wMFlyToBBox = new WMFlyToBBox(this);
    this.mouseWheelEventBBOXCurrent = new WMBBOX();
    this.mouseWheelEventBBOXNew = new WMBBOX();
    this.mouseX = 0;
    this.mouseY = 0;
    this.mouseDownX = -10000;
    this.mouseDownY = -10000;
    this.mouseUpX = 10000;
    this.mouseUpY = 10000;
    this.mouseDragging = 0;
    this.controlsBusy = false;
    this.mouseDownPressed = 0;
    this.mapMode = 'pan'; /* pan,zoom,zoomout,info */
    this.numGetFeatureInfoRequests = 0;
    this.oldMapMode = undefined;
    this.InValidMouseAction = 0;
    this.resizingBBOXCursor = '';
    this.resizingBBOXEnabled = '';
    this.mouseGeoCoordXY = undefined;
    this.mouseUpdateCoordinates = {
      x: -1,
      y: -1
    };
    this.mapPanning = 0;
    this.mapPanStartGeoCoords = undefined;
    this.mapZooming = 0;
    this.proj4 = {}; /* proj4 remembers current projection */
    this.proj4.srs = 'empty';
    this.proj4.projection = undefined;
    this.longlat = 'EPSG:4326';
    if (proj4) {
      proj4.defs(WMProj4Defs);
    }
    this.previousMouseButtonState = 'up';
    /* Binds */
    this.setWMTileRendererTileSettings = this.setWMTileRendererTileSettings.bind(this);
    this.makeComponentId = this.makeComponentId.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.setTimeOffset = this.setTimeOffset.bind(this);
    this.init = this.init.bind(this);
    this.rebuildMapDimensions = this.rebuildMapDimensions.bind(this);
    this.getLayerByServiceAndName = this.getLayerByServiceAndName.bind(this);
    this.getLayers = this.getLayers.bind(this);
    this.hasLayer = this.hasLayer.bind(this);
    this.setLayer = this.setLayer.bind(this);
    this.setActive = this.setActive.bind(this);
    this.setActiveLayer = this.setActiveLayer.bind(this);
    this.calculateNumBaseLayers = this.calculateNumBaseLayers.bind(this);
    this.enableLayer = this.enableLayer.bind(this);
    this.disableLayer = this.disableLayer.bind(this);
    this.toggleLayer = this.toggleLayer.bind(this);
    this.displayLayer = this.displayLayer.bind(this);
    this._getLayerIndex = this._getLayerIndex.bind(this);
    this.removeAllLayers = this.removeAllLayers.bind(this);
    this.deleteLayer = this.deleteLayer.bind(this);
    this.moveLayerDown = this.moveLayerDown.bind(this);
    this.reorderLayers = this.reorderLayers.bind(this);
    this.swapLayers = this.swapLayers.bind(this);
    this.moveLayerUp = this.moveLayerUp.bind(this);
    this.addLayer = this.addLayer.bind(this);
    this.getActiveLayer = this.getActiveLayer.bind(this);
    this.setProjection = this.setProjection.bind(this);
    this.getBBOX = this.getBBOX.bind(this);
    this.getMapPin = this.getMapPin.bind(this);
    this.getProjection = this.getProjection.bind(this);
    this.getSize = this.getSize.bind(this);
    this.getWidth = this.getWidth.bind(this);
    this.getHeight = this.getHeight.bind(this);
    this.repositionLegendGraphic = this.repositionLegendGraphic.bind(this);
    this.setSize = this.setSize.bind(this);
    this._setSize = this._setSize.bind(this);
    this.abort = this.abort.bind(this);
    this._makeInfoHTML = this._makeInfoHTML.bind(this);
    this.showScaleBar = this.showScaleBar.bind(this);
    this.hideScaleBar = this.hideScaleBar.bind(this);
    this.showMouseCursorProperties = this.showMouseCursorProperties.bind(this);
    this.hideMouseCursorProperties = this.hideMouseCursorProperties.bind(this);
    this.display = this.display.bind(this);
    this.draw = this.draw.bind(this);
    this._draw = this._draw.bind(this);
    this._drawAndLoad = this._drawAndLoad.bind(this);
    this._drawReady = this._drawReady.bind(this);
    this._onLayersReadyCallbackFunction = this._onLayersReadyCallbackFunction.bind(this);
    this._onMapReadyCallbackFunction = this._onMapReadyCallbackFunction.bind(this);
    this._onResumeSuspendCallbackFunction = this._onResumeSuspendCallbackFunction.bind(this);
    this._animFrameRedraw = this._animFrameRedraw.bind(this);
    this.getWMSRequests = this.getWMSRequests.bind(this);
    this.addLayersToCanvasAndDisplayThem = this.addLayersToCanvasAndDisplayThem.bind(this);
    this._updateBoundingBox = this._updateBoundingBox.bind(this);
    this.redrawBuffer = this.redrawBuffer.bind(this);
    this.addBaseLayers = this.addBaseLayers.bind(this);
    this.setBaseLayers = this.setBaseLayers.bind(this);
    this.getBaseLayers = this.getBaseLayers.bind(this);
    this.getNumLayers = this.getNumLayers.bind(this);
    this.getBaseElement = this.getBaseElement.bind(this);
    this.mouseWheelEvent = this.mouseWheelEvent.bind(this);
    this.destroy = this.destroy.bind(this);
    this.detachEvents = this.detachEvents.bind(this);
    this.attachEvents = this.attachEvents.bind(this);
    this._buildLayerDims = this._buildLayerDims.bind(this);
    this.getMapMode = this.getMapMode.bind(this);
    this.getWMSGetFeatureInfoRequestURL = this.getWMSGetFeatureInfoRequestURL.bind(this);
    this.setMapModeGetInfo = this.setMapModeGetInfo.bind(this);
    this.setMapModeZoomBoxIn = this.setMapModeZoomBoxIn.bind(this);
    this.setMapModeZoomOut = this.setMapModeZoomOut.bind(this);
    this.setMapModePan = this.setMapModePan.bind(this);
    this.setMapModePoint = this.setMapModePoint.bind(this);
    this.setMapModeNone = this.setMapModeNone.bind(this);
    this.getMouseCoordinatesForDocument = this.getMouseCoordinatesForDocument.bind(this);
    this.getMouseCoordinatesForElement = this.getMouseCoordinatesForElement.bind(this);
    this.mouseDown = this.mouseDown.bind(this);
    this._checkInvalidMouseAction = this._checkInvalidMouseAction.bind(this);
    this.updateMouseCursorCoordinates = this.updateMouseCursorCoordinates.bind(this);
    this.mouseDownEvent = this.mouseDownEvent.bind(this);
    this.mouseMoveEvent = this.mouseMoveEvent.bind(this);
    this.mouseUpEvent = this.mouseUpEvent.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this._mouseDragStart = this._mouseDragStart.bind(this);
    this.mouseDrag = this.mouseDrag.bind(this);
    this.mouseDragEnd = this.mouseDragEnd.bind(this);
    this._mapPanStart = this._mapPanStart.bind(this);
    this._mapPan = this._mapPan.bind(this);
    this._mapPanEnd = this._mapPanEnd.bind(this);
    this.mapPanPercentage = this.mapPanPercentage.bind(this);
    this._mapPanPercentageEnd = debounce(500, this._mapPanPercentageEnd);
    this._mapZoomStart = this._mapZoomStart.bind(this);
    this._mapZoom = this._mapZoom.bind(this);
    this._mapZoomEnd = this._mapZoomEnd.bind(this);
    this.setCursor = this.setCursor.bind(this);
    this.getId = this.getId.bind(this);
    this.zoomTo = this.zoomTo.bind(this);
    this.pixelCoordinatesToXY = this.pixelCoordinatesToXY.bind(this);
    this.getGeoCoordFromPixelCoord = this.getGeoCoordFromPixelCoord.bind(this);
    this.getProj4 = this.getProj4.bind(this);
    this.getPixelCoordFromLatLong = this.getPixelCoordFromLatLong.bind(this);
    this.calculateBoundingBoxAndZoom = this.calculateBoundingBoxAndZoom.bind(this);
    this.getLatLongFromPixelCoord = this.getLatLongFromPixelCoord.bind(this);
    this.getPixelCoordFromGeoCoord = this.getPixelCoordFromGeoCoord.bind(this);
    this.addListener = this.addListener.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.getListener = this.getListener.bind(this);
    this.suspendEvent = this.suspendEvent.bind(this);
    this.resumeEvent = this.resumeEvent.bind(this);
    this.getDimensionList = this.getDimensionList.bind(this);
    this.getDimension = this.getDimension.bind(this);
    this.setDimension = this.setDimension.bind(this);
    this.zoomToLayer = this.zoomToLayer.bind(this);
    this.setBBOX = this.setBBOX.bind(this);
    this.setDefaultBBOX = this.setDefaultBBOX.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.displayLegendInMap = this.displayLegendInMap.bind(this);
    this.showBoundingBox = this.showBoundingBox.bind(this);
    this.hideBoundingBox = this.hideBoundingBox.bind(this);
    this._adagucBeforeDraw = this._adagucBeforeDraw.bind(this);
    this._adagucBeforeCanvasDisplay = this._adagucBeforeCanvasDisplay.bind(this);
    this.displayScaleBarInMap = this.displayScaleBarInMap.bind(this);
    this.configureMapDimensions = this.configureMapDimensions.bind(this);
    this.mapPin = new MapPin(this);
    this.loadingDiv = document.createElement('div');
    this.loadingDiv.className = 'WMJSDivBuffer-loading';
    this.enableAutoPrefetching = true;
    this.isProjectionSupported = isProjectionSupported.bind(this);
    this.init();
  }
  _createClass(WMJSMap, [{
    key: "setWMTileRendererTileSettings",
    value: function setWMTileRendererTileSettings(_WMTileRendererTileSettings) {
      this.tileRenderSettings = _WMTileRendererTileSettings;
    }
    /**
     * Function which make a component ID which is unique over several WebMapJS instances
     * @param the desired id
     * @return the unique id
     */
  }, {
    key: "makeComponentId",
    value: function makeComponentId(id) {
      var availableId = "WebMapJSMapNo_".concat(WebMapJSMapNo);
      if (this.internalMapId === '') {
        this.internalMapId = availableId;
        WebMapJSMapNo += 1;
      }
      return "".concat(this.internalMapId, "_").concat(id);
    }
  }, {
    key: "setMessage",
    value: function setMessage(message) {
      if (!message || message === '') {
        this.setMessageValue = '';
      } else {
        this.setMessageValue = message;
      }
    }
  }, {
    key: "setTimeOffset",
    value: function setTimeOffset(message) {
      if (!message || message === '') {
        this.setTimeOffsetValue = '';
      } else {
        this.setTimeOffsetValue = message;
      }
    }
  }, {
    key: "_adagucBeforeDraw",
    value: function _adagucBeforeDraw(ctx) {
      if (this.baseLayers) {
        for (var l = 0; l < this.baseLayers.length; l += 1) {
          if (this.baseLayers[l].enabled && this.baseLayers[l].keepOnTop === false && this.baseLayers[l].type && this.baseLayers[l].type === 'twms' && this.tileRenderSettings) {
            ctx.globalAlpha = this.baseLayers[l].opacity;
            var _this$wmTileRenderer$ = this.wmTileRenderer.render(this.bbox, this.updateBBOX, this.srs, this.width, this.height, ctx, bgMapImageStore, this.tileRenderSettings, this.baseLayers[l].name),
              attributionText = _this$wmTileRenderer$.attributionText;
            ctx.globalAlpha = 1.0;
            var adagucAttribution = "ADAGUC webmapjs ".concat(this.WebMapJSMapVersion);
            var txt = attributionText ? "".concat(adagucAttribution, " | ").concat(attributionText) : adagucAttribution;
            var x = this.width - 8;
            var y = this.height - 8;
            ctx.font = '10px Arial';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = '#FFF';
            ctx.globalAlpha = 0.75;
            var _ctx$measureText = ctx.measureText(txt),
              width = _ctx$measureText.width;
            ctx.fillRect(x - width, y - 6, width + 8, 14);
            ctx.fillStyle = '#444';
            ctx.globalAlpha = 1.0;
            ctx.fillText(txt, x + 4, y + 2);
          }
        }
      }
    }
  }, {
    key: "_adagucBeforeCanvasDisplay",
    value: function _adagucBeforeCanvasDisplay(ctx) {
      var _this2 = this;
      var drawTextBG = function drawTextBG(_ctx, txt, x, y, fontSize) {
        _ctx.textBaseline = 'top';
        _ctx.textAlign = 'left';
        _ctx.fillStyle = '#FFF';
        _ctx.globalAlpha = 0.75;
        var _ctx$measureText2 = _ctx.measureText(txt),
          width = _ctx$measureText2.width;
        _ctx.fillRect(x - 8, y - 8, width + 16, fontSize + 14);
        _ctx.fillStyle = '#444';
        _ctx.globalAlpha = 1.0;
        _ctx.fillText(txt, x, y + 2);
      };
      /* Map Pin */
      if (this.mapPin.displayMapPin) {
        this.mapPin.drawMarker(ctx);
      }
      // /* Draw legends */
      if (this._displayLegendInMap) {
        drawLegend(ctx, this.width, this.height, this.layers);
      }
      /* Map header */
      if (this.isMapHeaderEnabled) {
        ctx.beginPath();
        ctx.rect(0, 0, this.width, this.mapHeader.height);
        if (this.mapIsActivated === false) {
          ctx.globalAlpha = this.mapHeader.hovering ? this.mapHeader.hover.opacity : this.mapHeader.fill.opacity;
          ctx.fillStyle = this.mapHeader.hovering ? this.mapHeader.hover.color : this.mapHeader.fill.color;
        } else {
          ctx.globalAlpha = this.mapHeader.hovering ? this.mapHeader.hoverSelected.opacity : this.mapHeader.selected.opacity;
          ctx.fillStyle = this.mapHeader.hovering ? this.mapHeader.hoverSelected.color : this.mapHeader.selected.color;
        }
        ctx.fill();
        ctx.globalAlpha = 1;
      }
      /* Gather errors */
      for (var i = 0; i < this.layers.length; i += 1) {
        for (var j = 0; j < this.layers[i].dimensions.length; j += 1) {
          if (this.layers[i].dimensions[j].currentValue === WMDateOutSideRange) {
            this.canvasErrors.push({
              linkedInfo: {
                layer: this.layers[i],
                message: 'Time outside range'
              }
            });
          } else if (this.layers[i].dimensions[j].currentValue === WMDateTooEarlyString) {
            this.canvasErrors.push({
              linkedInfo: {
                layer: this.layers[i],
                message: 'Time too early'
              }
            });
          } else if (this.layers[i].dimensions[j].currentValue === WMDateTooLateString) {
            this.canvasErrors.push({
              linkedInfo: {
                layer: this.layers[i],
                message: 'Time too late'
              }
            });
          }
        }
      }
      /* Display errors found during drawing canvas */
      if (this.canvasErrors && this.canvasErrors.length > 0) {
        var errorsToDisplay = getErrorsToDisplay(this.canvasErrors, this.getLayerByServiceAndName);
        this.canvasErrors = [];
        if (errorsToDisplay.length > 0) {
          var mw = this.width / 2;
          var mh = 6 + errorsToDisplay.length * 15;
          var mx = this.width - mw;
          var my = this.isMapHeaderEnabled ? this.mapHeader.height : 0;
          ctx.beginPath();
          ctx.rect(mx, my, mx + mw, my + mh);
          ctx.fillStyle = 'white';
          ctx.globalAlpha = 0.9;
          ctx.fill();
          ctx.globalAlpha = 1;
          ctx.fillStyle = 'black';
          ctx.font = '10pt Helvetica';
          ctx.textAlign = 'left';
          errorsToDisplay.forEach(function (message, j) {
            ctx.fillText(message, mx + 5, my + 11 + j * 15);
          });
        }
      }
      // Time offset message
      if (this.setTimeOffsetValue !== '') {
        ctx.font = '14px Helvetica';
        drawTextBG(ctx, this.setTimeOffsetValue, this.width / 2 - 70, this.height - 26, 20);
      }
      // Set message value
      if (this.setMessageValue !== '') {
        ctx.font = '15px Helvetica';
        drawTextBG(ctx, this.setMessageValue, this.width / 2 - 70, 2, 15);
      }
      // ScaleBar
      if (this.showScaleBarInMap === true) {
        var getScaleBarProperties = function getScaleBarProperties() {
          var desiredWidth = 25;
          var realWidth = 0;
          var numMapUnits = 1.0 / 10000000.0;
          var boxWidth = _this2.updateBBOX.right - _this2.updateBBOX.left;
          var pixelsPerUnit = _this2.width / boxWidth;
          if (pixelsPerUnit <= 0) {
            return undefined;
          }
          var a = desiredWidth / pixelsPerUnit;
          var divFactor = 0;
          do {
            numMapUnits *= 10.0;
            divFactor = a / numMapUnits;
            if (divFactor === 0) {
              return undefined;
            }
            realWidth = desiredWidth / divFactor;
          } while (realWidth < desiredWidth);
          do {
            numMapUnits /= 2.0;
            divFactor = a / numMapUnits;
            if (divFactor === 0) {
              return undefined;
            }
            realWidth = desiredWidth / divFactor;
          } while (realWidth > desiredWidth);
          do {
            numMapUnits *= 1.2;
            divFactor = a / numMapUnits;
            if (divFactor === 0) {
              return undefined;
            }
            realWidth = desiredWidth / divFactor;
          } while (realWidth < desiredWidth);
          var roundedMapUnits = numMapUnits;
          var d = Math.pow(10, Math.round(Math.log10(numMapUnits) + 0.5) - 1);
          roundedMapUnits = Math.round(roundedMapUnits / d);
          if (roundedMapUnits < 2.5) {
            roundedMapUnits = 2.5;
          }
          if (roundedMapUnits > 2.5 && roundedMapUnits < 7.5) {
            roundedMapUnits = 5;
          }
          if (roundedMapUnits > 7.5) {
            roundedMapUnits = 10;
          }
          roundedMapUnits *= d;
          divFactor = desiredWidth / pixelsPerUnit / roundedMapUnits;
          realWidth = desiredWidth / divFactor;
          return {
            width: parseInt(realWidth, 10),
            mapunits: roundedMapUnits
          };
        };
        var scaleBarProps = getScaleBarProperties();
        if (scaleBarProps) {
          var offsetX = 7.5;
          var offsetY = this.height - 25.5;
          var scaleBarHeight = 23;
          ctx.beginPath();
          ctx.lineWidth = 2.5;
          ctx.fillStyle = '#000';
          ctx.strokeStyle = '#000';
          ctx.font = '9px Helvetica';
          ctx.textBaseline = 'middle';
          ctx.textAlign = 'left';
          for (var _j = 0; _j < 2; _j += 1) {
            ctx.moveTo(offsetX, scaleBarHeight - 2 - _j + offsetY);
            ctx.lineTo(scaleBarProps.width * 2 + offsetX + 1, scaleBarHeight - 2 - _j + offsetY);
          }
          var subDivXW = parseInt(Math.round(scaleBarProps.width / 5), 10);
          ctx.lineWidth = 0.5;
          for (var _j2 = 1; _j2 < 5; _j2 += 1) {
            ctx.moveTo(offsetX + subDivXW * _j2, scaleBarHeight - 2 + offsetY);
            ctx.lineTo(offsetX + subDivXW * _j2, scaleBarHeight - 2 - 5 + offsetY);
          }
          ctx.lineWidth = 1.0;
          ctx.moveTo(offsetX, scaleBarHeight - 2 + offsetY);
          ctx.lineTo(offsetX, scaleBarHeight - 2 - 7 + offsetY);
          ctx.moveTo(offsetX + scaleBarProps.width, scaleBarHeight - 2 + offsetY);
          ctx.lineTo(offsetX + scaleBarProps.width, scaleBarHeight - 2 - 7 + offsetY);
          ctx.moveTo(offsetX + scaleBarProps.width * 2 + 1, scaleBarHeight - 2 + offsetY);
          ctx.lineTo(offsetX + scaleBarProps.width * 2 + 1, scaleBarHeight - 2 - 7 + offsetY);
          var units = '';
          if (this.srs === 'EPSG:3411') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:3412') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:3575') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:4326') {
            units = 'degrees';
          }
          if (this.srs === 'EPSG:28992') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:32661') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:3857') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:900913') {
            units = 'meter';
          }
          if (this.srs === 'EPSG:102100') {
            units = 'meter';
          }
          if (units === 'meter') {
            if (scaleBarProps.mapunits > 1000) {
              scaleBarProps.mapunits /= 1000;
              units = 'km';
            }
          }
          ctx.fillText('0', offsetX - 3, 12 + offsetY);
          var valueStr = "".concat(scaleBarProps.mapunits.toPrecision());
          ctx.fillText(valueStr, offsetX + scaleBarProps.width - valueStr.length * 2.5 + 0, 12 + offsetY);
          valueStr = "".concat((scaleBarProps.mapunits * 2).toPrecision());
          ctx.fillText(valueStr, offsetX + scaleBarProps.width * 2 - valueStr.length * 2.5 + 0, 12 + offsetY);
          ctx.fillText(units, offsetX + scaleBarProps.width * 2 + 10, 18 + offsetY);
          ctx.stroke();
        }
      }
      if (this.showCursorCoordinates === true) {
        // Mouse projected coords
        ctx.font = '10px Helvetica';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'left';
        if (isDefined(this.mouseGeoCoordXY)) {
          var roundingFactor = 1.0 / Math.pow(10, parseInt(Math.log((this.bbox.right - this.bbox.left) / this.width) / Math.log(10), 10) - 2);
          if (roundingFactor < 1) {
            roundingFactor = 1;
          }
          ctx.fillStyle = '#000000';
          var xText = Math.round(this.mouseGeoCoordXY.x * roundingFactor) / roundingFactor;
          var yText = Math.round(this.mouseGeoCoordXY.y * roundingFactor) / roundingFactor;
          var _units = '';
          if (this.srs === 'EPSG:3857') {
            _units = 'meter';
          }
          ctx.fillText("CoordYX: (".concat(yText, ", ").concat(xText, ") ").concat(_units), 5, this.height - 50);
        }
        // Mouse latlon coords
        if (isDefined(this.mouseUpdateCoordinates)) {
          var llCoord = this.getLatLongFromPixelCoord(this.mouseUpdateCoordinates);
          if (isDefined(llCoord)) {
            var _roundingFactor = 100;
            ctx.fillStyle = '#000000';
            var _xText = Math.round(llCoord.x * _roundingFactor) / _roundingFactor;
            var _yText = Math.round(llCoord.y * _roundingFactor) / _roundingFactor;
            ctx.fillText("Lat/Lon: (".concat(_yText.toFixed(2), ", ").concat(_xText.toFixed(2), ") degrees"), 5, this.height - 38);
          }
        }
        ctx.fillStyle = '#000000';
        ctx.fillText("Map projection: ".concat(this.srs), 5, this.height - 26);
      }
      /* Show layer metadata */
      if (this.showLayerInfo === true) {
        var metadataX = 100;
        var metadataY = 100;
        var dimStartX = 150;
        var rowHeight = 26;
        var rowNumber = 0;
        drawTextBG(ctx, 'Layer name', metadataX, metadataY + rowNumber * rowHeight, 10);
        drawTextBG(ctx, 'Dimensions', metadataX + dimStartX, metadataY + rowNumber * rowHeight, 10);
        rowNumber += 1;
        for (var _j3 = 0; _j3 < this.layers.length; _j3 += 1) {
          var layer = this.layers[_j3];
          drawTextBG(ctx, "#".concat(_j3, ":").concat(layer.name), metadataX, metadataY + rowNumber * rowHeight, 10);
          for (var d = 0; d < layer.dimensions.length; d += 1) {
            var dimension = layer.dimensions[d];
            drawTextBG(ctx, "".concat(dimension.name, " = ").concat(dimension.currentValue), metadataX + d * 200 + dimStartX, metadataY + rowNumber * rowHeight, 10);
          }
          rowNumber += 1;
        }
      }
    }
    /* Is called when the WebMapJS object is created */
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      if (!this.mainElement) {
        return;
      }
      if (this.mainElement.style) {
        if (!this.mainElement.style.height) {
          this.mainElement.style.height = '1px';
        }
        if (!this.mainElement.style.width) {
          this.mainElement.style.width = '1px';
        }
      }
      // baseDiv
      var baseDivId = this.makeComponentId('baseDiv');
      this.baseDiv = document.createElement('div');
      this.baseDiv.id = baseDivId;
      Object.assign(this.baseDiv.style, {
        position: 'relative',
        overflow: 'hidden',
        width: this.mainElement.clientWidth,
        height: this.mainElement.clientHeight,
        margin: 0,
        padding: 0,
        clear: 'both',
        left: '0px',
        top: '0px',
        cursor: 'default'
      });
      this.mainElement.appendChild(this.baseDiv);
      this.mainElement.style.margin = '0px';
      this.mainElement.style.padding = '0px';
      this.mainElement.style.border = 'none';
      this.mainElement.style.lineHeight = '0px';
      this.mainElement.style.display = 'inline-block';
      // Attach zoombox
      this.divZoomBox.className = 'wmjs-zoombox';
      this.divZoomBox.style.position = 'absolute';
      this.divZoomBox.style.display = 'none';
      this.divZoomBox.style.border = '2px dashed #000000';
      this.divZoomBox.style.margin = '0px';
      this.divZoomBox.style.padding = '0px';
      this.divZoomBox.style.lineHeight = '0';
      this.divZoomBox.style.background = '#AFFFFF';
      this.divZoomBox.style.opacity = '0.3'; // Gecko
      this.divZoomBox.style.filter = 'alpha(opacity=30)'; // Windows
      this.divZoomBox.style.left = '0px';
      this.divZoomBox.style.top = '0px';
      this.divZoomBox.style.width = '100px';
      this.divZoomBox.style.height = '100px';
      this.divZoomBox.style.zIndex = '1000';
      this.divZoomBox.oncontextmenu = function () {
        return false;
      };
      this.baseDiv.appendChild(this.divZoomBox);
      // Attach bbox box
      this.divBoundingBox.className = 'wmjs-boundingbox';
      this.divBoundingBox.style.position = 'absolute';
      this.divBoundingBox.style.display = 'none';
      this.divBoundingBox.style.border = '3px solid #6060FF';
      this.divBoundingBox.style.margin = '0px';
      this.divBoundingBox.style.padding = '0px';
      this.divBoundingBox.style.lineHeight = '0';
      this.divBoundingBox.style.left = '0px';
      this.divBoundingBox.style.top = '0px';
      this.divBoundingBox.style.width = '100px';
      this.divBoundingBox.style.height = '100px';
      this.divBoundingBox.style.zIndex = '1000';
      this.divBoundingBox.oncontextmenu = function () {
        return false;
      };
      this.baseDiv.appendChild(this.divBoundingBox);
      /* Attach divDimInfo */
      this.divDimInfo.style.position = 'absolute';
      this.divDimInfo.style.zIndex = '1000';
      this.divDimInfo.style.width = 'auto';
      this.divDimInfo.style.height = 'auto';
      this.divDimInfo.style.background = 'none';
      this.divDimInfo.oncontextmenu = function () {
        return false;
      };
      this.divDimInfo.innerHTML = '';
      this.baseDiv.appendChild(this.divDimInfo);
      /* Attach loading image */
      this.baseDiv.appendChild(this.loadingDiv);
      /* Attach events */
      this.attachEvents();
      this.bbox.left = -180;
      this.bbox.bottom = -90;
      this.bbox.right = 180;
      this.bbox.top = 90;
      this.srs = 'EPSG:4326';
      // IMAGE buffer
      this.divBuffer = new WMCanvasBuffer(this.callBack, getMapImageStore, this.getWidth(), this.getHeight(), {
        beforecanvasstartdraw: this._adagucBeforeDraw,
        beforecanvasdisplay: this._adagucBeforeCanvasDisplay,
        canvasonerror: function canvasonerror(e) {
          _this3.canvasErrors = e;
        }
      });
      this.baseDiv.appendChild(this.divBuffer.getBuffer());
      getLegendImageStore().addImageEventCallback(function (image, id, imageEventType) {
        if (imageEventType === WMImageEventType.Loaded) {
          _this3.draw('legendImageStore loaded');
        }
      }, this.internalMapId);
      this.callBack.addToCallback('display', this.display, true);
      this.callBack.addToCallback('draw', function () {
        debugLogger(DebugType.Log);
      }, true);
      bgMapImageStore.addImageEventCallback(function (image, id, imageEventType) {
        if (imageEventType === WMImageEventType.Loaded) {
          _this3.draw('bgMapImageStore loaded');
        }
      }, this.internalMapId);
      this._updateBoundingBox(this.bbox);
      this.wmAnimate = new WMJSAnimate(this);
      this.wmTileRenderer = new WMTileRenderer();
      this.initialized = true;
    }
  }, {
    key: "rebuildMapDimensions",
    value: function rebuildMapDimensions() {
      var _this4 = this;
      this.layers.forEach(function (layer) {
        layer.dimensions.forEach(function (dim) {
          var mapdim = _this4.getDimension(dim.name);
          if (!isDefined(mapdim)) {
            var newdim = dim.clone();
            _this4.mapdimensions.push(newdim);
          }
        });
      });
      this.callBack.triggerEvent('onmapdimupdate');
    }
  }, {
    key: "getLayerByServiceAndName",
    value: function getLayerByServiceAndName(layerService, layerName) {
      for (var j = 0; j < this.layers.length; j += 1) {
        var layer = this.layers[this.layers.length - j - 1];
        if (layer.name === layerName) {
          if (layer.service === layerService) {
            return layer;
          }
        }
      }
      return undefined;
    }
  }, {
    key: "getLayers",
    value: function getLayers() {
      /* Provide layers in reverse order */
      var returnlayers = [];
      for (var j = 0; j < this.layers.length; j += 1) {
        var layer = this.layers[this.layers.length - j - 1];
        returnlayers.push(layer);
      }
      return returnlayers;
    }
  }, {
    key: "hasLayer",
    value: function hasLayer(layer) {
      return this.layers.includes(layer) || this.baseLayers.includes(layer);
    }
  }, {
    key: "setLayer",
    value: function setLayer(layer) {
      return this.addLayer(layer);
    }
    /* Indicate weather this map component is active or not */
  }, {
    key: "setActive",
    value: function setActive(active) {
      this.mapIsActivated = active;
      this.isMapHeaderEnabled = true;
    }
  }, {
    key: "setActiveLayer",
    value: function setActiveLayer(layer) {
      for (var j = 0; j < this.layers.length; j += 1) {
        this.layers[j].active = false;
      }
      this.activeLayer = layer;
      this.activeLayer.active = true;
      this.callBack.triggerEvent('onchangeactivelayer');
    }
    // Calculates how many baselayers there are.
    // Useful when changing properties for a divbuffer index (for example setLayerOpacity)
  }, {
    key: "calculateNumBaseLayers",
    value: function calculateNumBaseLayers() {
      this.numBaseLayers = 0;
      if (this.baseLayers) {
        for (var l = 0; l < this.baseLayers.length; l += 1) {
          if (this.baseLayers[l].enabled) {
            if (this.baseLayers[l].keepOnTop === false) {
              this.numBaseLayers += 1;
            }
          }
        }
      }
    }
  }, {
    key: "enableLayer",
    value: function enableLayer(layer) {
      layer.enabled = true;
      this.calculateNumBaseLayers();
      this.rebuildMapDimensions();
    }
  }, {
    key: "disableLayer",
    value: function disableLayer(layer) {
      layer.enabled = false;
      this.calculateNumBaseLayers();
      this.rebuildMapDimensions();
    }
  }, {
    key: "toggleLayer",
    value: function toggleLayer(layer) {
      if (layer.enabled === true) {
        layer.enabled = false;
      } else {
        layer.enabled = true;
      }
      this.calculateNumBaseLayers();
      this.rebuildMapDimensions();
    }
  }, {
    key: "displayLayer",
    value: function displayLayer(layer, enabled) {
      layer.enabled = enabled;
      this.calculateNumBaseLayers();
      this.rebuildMapDimensions();
    }
  }, {
    key: "_getLayerIndex",
    value: function _getLayerIndex(layer) {
      if (!layer) {
        return undefined;
      }
      for (var j = 0; j < this.layers.length; j += 1) {
        if (this.layers[j] === layer) {
          return j;
        }
      }
      return -1;
    }
  }, {
    key: "removeAllLayers",
    value: function removeAllLayers() {
      for (var i = 0; i < this.layers.length; i += 1) {
        this.layers[i].setAutoUpdate(false);
      }
      this.layers.length = 0;
      this.mapdimensions.length = 0;
      this.callBack.triggerEvent('onlayeradd');
    }
  }, {
    key: "deleteLayer",
    value: function deleteLayer(layerToDelete) {
      if (this.layers.length <= 0) {
        return;
      }
      layerToDelete.setAutoUpdate(false);
      var layerIndex = this._getLayerIndex(layerToDelete);
      if (layerIndex >= 0) {
        // move everything up with id's higher than this layer
        for (var j = layerIndex; j < this.layers.length - 1; j += 1) {
          this.layers[j] = this.layers[j + 1];
        }
        this.layers.length -= 1;
        this.activeLayer = undefined;
        if (layerIndex >= 0 && layerIndex < this.layers.length) {
          this.rebuildMapDimensions();
          this.setActiveLayer(this.layers[layerIndex]);
        } else if (this.layers.length > 0) {
          this.rebuildMapDimensions();
          this.setActiveLayer(this.layers[this.layers.length - 1]);
        }
      }
      this.callBack.triggerEvent('onlayerchange');
      this.rebuildMapDimensions();
    }
  }, {
    key: "moveLayerDown",
    value: function moveLayerDown(layerToMove) {
      var layerIndex = this._getLayerIndex(layerToMove);
      if (layerIndex > 0) {
        var layerToMoveDown = this.layers[layerIndex - 1];
        var layer = this.layers[layerIndex];
        if (layerToMoveDown && layer) {
          this.layers[layerIndex] = layerToMoveDown;
          this.layers[layerIndex - 1] = layer;
        }
      } else {
        try {
          debugLogger(DebugType.Error, "WebMapJS warning: moveLayerDown: layer '".concat(layerToMove.name, "' not found."));
        } catch (e) {
          debugLogger(DebugType.Error);
        }
      }
    }
    /**
     * Reorder layers according to an index array with indices on how the layers should be reordered.
     */
  }, {
    key: "reorderLayers",
    value: function reorderLayers(order) {
      var _this5 = this;
      // The length should be the same
      if (order.length !== this.layers.length) {
        return false;
      }
      // There should be no duplicate indices
      if (order.length !== new Set(order).size) {
        return false;
      }
      var origList = this.layers.slice();
      var wasReordered = false;
      order.forEach(function (value, index) {
        if (value >= 0 || value < _this5.layers.length) {
          var indexA = _this5.layers.length - value - 1;
          var indexB = _this5.layers.length - index - 1;
          if (indexA !== indexB) {
            _this5.layers[indexA] = origList[indexB];
            wasReordered = true;
          }
        }
      });
      return wasReordered;
    }
  }, {
    key: "swapLayers",
    value: function swapLayers(_layerA, _layerB) {
      var layerIndexA = this._getLayerIndex(_layerA);
      var layerIndexB = this._getLayerIndex(_layerB);
      if (layerIndexA >= 0 && layerIndexB >= 0) {
        var layerA = this.layers[layerIndexA];
        var layerB = this.layers[layerIndexB];
        if (layerB && layerA) {
          this.layers[layerIndexA] = layerB;
          this.layers[layerIndexB] = layerA;
        }
      } else {
        try {
          debugLogger(DebugType.Error, "WebMapJS: moveLayers: layer '".concat(_layerA.name, "' not found."));
        } catch (e) {
          debugLogger(DebugType.Error);
        }
      }
    }
  }, {
    key: "moveLayerUp",
    value: function moveLayerUp(layerToMove) {
      var layerIndex = this._getLayerIndex(layerToMove);
      if (layerIndex < this.layers.length - 1) {
        var layerToMoveUp = this.layers[layerIndex + 1];
        var layer = this.layers[layerIndex];
        if (layerToMoveUp && layer) {
          this.layers[layerIndex] = layerToMoveUp;
          this.layers[layerIndex + 1] = layer;
        }
      } else {
        try {
          debugLogger(DebugType.Error, "WebMapJS: moveLayerUp: layer '".concat(layerToMove.name, "' not found."));
        } catch (e) {
          debugLogger(DebugType.Error);
        }
      }
    }
  }, {
    key: "configureMapDimensions",
    value: function configureMapDimensions(layer) {
      var _this6 = this;
      layer.dimensions.forEach(function (dimension) {
        var mapDim = _this6.getDimension(dimension.name);
        if ((mapDim === null || mapDim === void 0 ? void 0 : mapDim.currentValue) !== undefined && dimension.linked) {
          dimension.setClosestValue(mapDim.currentValue);
        }
      });
      this.rebuildMapDimensions();
    }
    /**
     * @param layer of type WMLayer
     */
  }, {
    key: "addLayer",
    value: function addLayer(layer) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        if (!isDefined(layer)) {
          debugLogger(DebugType.Warning);
          reject(new Error('undefined layer'));
          return;
        }
        if (!layer.constructor) {
          debugLogger(DebugType.Warning);
          reject(new Error('layer has no constructor'));
          return;
        }
        /* Set a reference in the layer to this map */
        layer.parentMap = _this7;
        _this7.layers.push(layer);
        var done = function done(layerCallback) {
          _this7.configureMapDimensions(layerCallback);
          _this7.callBack.triggerEvent('onlayeradd');
          resolve(_this7);
        };
        layer.parseLayer(done, undefined, 'WMJSMap addLayer');
      });
    }
  }, {
    key: "getActiveLayer",
    value: function getActiveLayer() {
      return this.activeLayer;
    }
    /**
     * setProjection
     * Set the projection of the current webmap object
     *_srs also accepts a projectionProperty object
     */
  }, {
    key: "setProjection",
    value: function setProjection(_srs, _bbox) {
      if (!_srs) {
        _srs = 'EPSG:4326';
      }
      if (_typeof(_srs) === 'object') {
        _bbox = _srs.bbox;
        _srs = _srs.srs;
      }
      if (!_srs) {
        _srs = 'EPSG:4326';
      }
      if (this.srs !== _srs) {
        this.defaultBBOX.setBBOX(_bbox);
      }
      this.srs = _srs;
      if (this.proj4.srs !== this.srs || !isDefined(this.proj4.projection)) {
        if (this.srs === 'GFI:TIME_ELEVATION') {
          this.proj4.projection = 'EPSG:4326';
        } else {
          this.proj4.projection = this.srs;
        }
        this.proj4.srs = this.srs;
      }
      this.setBBOX(_bbox);
      this.updateMouseCursorCoordinates(undefined);
      this.callBack.triggerEvent('onsetprojection', [this.srs, this.bbox]);
    }
  }, {
    key: "getBBOX",
    value: function getBBOX() {
      return this.updateBBOX;
    }
  }, {
    key: "getProjection",
    value: function getProjection() {
      return {
        srs: this.srs,
        bbox: this.resizeBBOX
      };
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return {
        width: this.width,
        height: this.height
      };
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.height;
    }
  }, {
    key: "getMapPin",
    value: function getMapPin() {
      return this.mapPin;
    }
  }, {
    key: "repositionLegendGraphic",
    value: function repositionLegendGraphic() {
      if (!this._displayLegendInMap) {
        this.draw();
      }
    }
  }, {
    key: "setSize",
    value: function setSize(w, h) {
      debugLogger(DebugType.Log, 'setSize', w, h, this.initialized);
      if (w < 4 || h < 4 || this.initialized === false) {
        return;
      }
      this.resizeWidth = w;
      this.resizeHeight = h;
      this._setSize(this.resizeWidth, this.resizeHeight);
      this.draw('setSize');
    }
  }, {
    key: "_setSize",
    value: function _setSize(w, h) {
      if (!w || !h) {
        return;
      }
      if (w < 4 || h < 4) {
        return;
      }
      debugLogger(DebugType.Log);
      var projinfo = this.getProjection();
      this.width = w;
      this.height = h;
      if (this.width < 4 || isNaN(this.width)) {
        this.width = 4;
      }
      if (this.height < 4 || isNaN(this.height)) {
        this.height = 4;
      }
      if (!projinfo.srs || !projinfo.bbox) {
        debugLogger(DebugType.Error);
        projinfo.srs = 'EPSG:4326';
        projinfo.bbox.left = -180;
        projinfo.bbox.bottom = -90;
        projinfo.bbox.right = 180;
        projinfo.bbox.top = 90;
        this.setProjection(projinfo.srs, projinfo.bbox);
      }
      if (!this.baseDiv || !this.baseDiv.style) {
        return;
      }
      Object.assign(this.baseDiv.style, {
        width: this.width,
        height: this.height
      });
      if (!this.mainElement || !this.mainElement.style) {
        return;
      }
      this.mainElement.style.width = "".concat(this.width, "px");
      this.mainElement.style.height = "".concat(this.height, "px");
      this.setBBOX(this.resizeBBOX);
      this.showBoundingBox();
      this.divBuffer.resize(this.getWidth().toString(), this.getHeight().toString());
      this.repositionLegendGraphic();
      /* Fire the onresize event, to notify listeners that something happened. */
      this.callBack.triggerEvent('onresize', [this.width, this.height]);
    }
  }, {
    key: "abort",
    value: function abort() {
      this.callBack.triggerEvent('onmapready');
      this.mapBusy = false;
      this.drawPending = false;
      this.layersBusy = false;
      this.callBack.triggerEvent('onloadingcomplete');
    }
  }, {
    key: "_makeInfoHTML",
    value: function _makeInfoHTML() {
      try {
        // Create the layerinformation table
        var infoHTML = '<table class="myTable">';
        var infoHTMLHasValidContent = false;
        // Make first a header with 'Layer' and the dimensions
        infoHTML += '<tr><th>Layer</th>';
        if (this.mapdimensions) {
          for (var d = 0; d < this.mapdimensions.length; d += 1) {
            infoHTML += "<th>".concat(this.mapdimensions[d].name, "</th>");
          }
        }
        infoHTML += '</tr>';
        infoHTML += '<tr><td>Map</tdh>';
        if (this.mapdimensions) {
          for (var _d = 0; _d < this.mapdimensions.length; _d += 1) {
            infoHTML += "<td>".concat(this.mapdimensions[_d].currentValue, "</td>");
          }
        }
        infoHTML += '</tr>';
        var l = 0;
        for (l = 0; l < this.getNumLayers(); l += 1) {
          var j = this.getNumLayers() - 1 - l;
          if (this.layers[j].service && this.layers[j].enabled) {
            var layerDimensionsObject = this.layers[j].dimensions;
            if (layerDimensionsObject) {
              var layerTitle = '';
              layerTitle += this.layers[j].title;
              infoHTML += "<tr><td>".concat(layerTitle, "</td>");
              for (var mapdim = 0; mapdim < this.mapdimensions.length; mapdim += 1) {
                var foundDim = false;
                for (var layerdim = 0; layerdim < layerDimensionsObject.length; layerdim += 1) {
                  if (layerDimensionsObject[layerdim].name.toUpperCase() === this.mapdimensions[mapdim].name.toUpperCase()) {
                    infoHTML += "<td>".concat(layerDimensionsObject[layerdim].currentValue, "</td>");
                    foundDim = true;
                    infoHTMLHasValidContent = true;
                    break;
                  }
                }
                if (foundDim === false) {
                  infoHTML += '<td>-</td>';
                }
              }
              infoHTML += '</tr>';
            }
          }
        }
        infoHTML += '</table>';
        if (infoHTMLHasValidContent === true) {
          this.divDimInfo.style.display = '';
          this.divDimInfo.innerHTML = infoHTML;
          var cx = 8;
          var cy = 8;
          this.divDimInfo.style.width = "".concat(Math.min(this.width - parseInt(this.divDimInfo.style.marginLeft, 10) - 210, 350), "px");
          this.divDimInfo.style.left = "".concat(cx, "px");
          this.divDimInfo.style.top = "".concat(cy, "px");
        } else {
          this.divDimInfo.style.display = 'none';
        }
      } catch (e) {
        debugLogger(DebugType.Error);
      }
    }
  }, {
    key: "showScaleBar",
    value: function showScaleBar() {
      this.showScaleBarInMap = true;
    }
  }, {
    key: "hideScaleBar",
    value: function hideScaleBar() {
      this.showScaleBarInMap = false;
    }
  }, {
    key: "showMouseCursorProperties",
    value: function showMouseCursorProperties() {
      this.showCursorCoordinates = true;
    }
  }, {
    key: "hideMouseCursorProperties",
    value: function hideMouseCursorProperties() {
      this.showCursorCoordinates = false;
    }
  }, {
    key: "displayScaleBarInMap",
    value: function displayScaleBarInMap(display) {
      this.showScaleBarInMap = display;
    }
  }, {
    key: "display",
    value: function display() {
      if (!this.divBuffer) {
        return;
      }
      this.divBuffer.display();
      this.drawnBBOX.setBBOX(this.bbox);
    }
  }, {
    key: "_animFrameRedraw",
    value: function _animFrameRedraw() {
      this._draw(this._animationList);
    }
  }, {
    key: "draw",
    value: function draw(animationList) {
      if (this.isDestroyed) {
        return;
      }
      if (_typeof(animationList) === 'object') {
        if (JSON.stringify(animationList) !== '{}') {
          this._animationList = animationList;
        }
      }
      if (this.isAnimating) {
        debugLogger(DebugType.Log);
        return;
      }
      this._draw(this._animationList);
    }
    /**
     * API Function called to draw the layers, fires getmap request and shows the layers on the screen
     */
  }, {
    key: "_draw",
    value: function _draw(animationList) {
      debugLogger(DebugType.Log);
      this.drawnBBOX.setBBOX(this.bbox);
      this._drawAndLoad(animationList);
    }
  }, {
    key: "_drawReady",
    value: function _drawReady() {
      this.drawPending = false;
      if (this.needsRedraw) {
        this.needsRedraw = false;
        this.draw(this._animationList);
      }
    }
  }, {
    key: "_drawAndLoad",
    value: function _drawAndLoad(inputAnimationList) {
      var _this8 = this;
      if (this.width < 4 || this.height < 4) {
        this._drawReady();
        return;
      }
      this.callBack.triggerEvent('beforedraw');
      if (this.isAnimating === false && inputAnimationList !== undefined && _typeof(inputAnimationList) === 'object' && inputAnimationList.length > 0) {
        // Ensure the time dimension has been loaded for the map before starting animation
        var timeDim = this.getDimension('time');
        if (!timeDim) {
          return;
        }
        var selectedTime = timeDim.currentValue;
        this.isAnimating = true;
        this.callBack.triggerEvent('onstartanimation', this);
        this.currentAnimationStep = this.initialAnimationStep;
        this.animationList = [];
        this.mouseHoverAnimationBox = false;
        inputAnimationList.forEach(function (animationStepWithoutRequests, j) {
          if (selectedTime && animationStepWithoutRequests.value === selectedTime) {
            _this8.currentAnimationStep = j;
          }
          var animationStep = {
            name: animationStepWithoutRequests.name,
            value: animationStepWithoutRequests.value,
            requests: []
          };
          _this8.setDimension(animationStepWithoutRequests.name, animationStepWithoutRequests.value, false);
          animationStep.requests = _this8.getWMSRequests();
          _this8.animationList.push(animationStep);
        });
        this.setDimension(this.animationList[this.currentAnimationStep].name, this.animationList[this.currentAnimationStep].value, false);
        this.wmAnimate.loopAnimation();
      }
      this.addLayersToCanvasAndDisplayThem();
    }
  }, {
    key: "_onLayersReadyCallbackFunction",
    value: function _onLayersReadyCallbackFunction() {
      this.draw('onlayersready callback');
    }
  }, {
    key: "_onMapReadyCallbackFunction",
    value: function _onMapReadyCallbackFunction() {
      debugLogger(DebugType.Log);
      this.draw('onmapready callback');
    }
  }, {
    key: "_onResumeSuspendCallbackFunction",
    value: function _onResumeSuspendCallbackFunction() {
      this.draw('onresumesuspend callback');
    }
  }, {
    key: "getWMSRequests",
    value: function getWMSRequests(dimensionOverride) {
      var _this9 = this;
      var requests = [];
      this.layers.forEach(function (layer) {
        if (layer.service && layer.enabled) {
          var request = buildWMSGetMapRequest(_this9, layer, dimensionOverride);
          if (request === null || request === void 0 ? void 0 : request.url) {
            requests.push(request);
          }
        }
      });
      return requests;
    }
  }, {
    key: "addLayersToCanvasAndDisplayThem",
    value: function addLayersToCanvasAndDisplayThem() {
      var _this10 = this;
      debugLogger(DebugType.Log);
      this.divBuffer.reset();
      var currentLayerIndex = 0;
      this.numBaseLayers = 0;
      this.baseLayers && this.baseLayers.forEach(function (baseLayer) {
        var _a;
        if (baseLayer.enabled && baseLayer.keepOnTop === false && baseLayer.type && baseLayer.type !== 'twms') {
          _this10.numBaseLayers += 1;
          var requestURL = (_a = buildWMSGetMapRequest(_this10, baseLayer)) === null || _a === void 0 ? void 0 : _a.url;
          if (requestURL) {
            _this10.divBuffer.setSrc(currentLayerIndex, requestURL, {
              layer: baseLayer
            }, baseLayer.opacity, _this10.getDrawBBOX());
            currentLayerIndex += 1;
          }
        }
      });
      if (!this.isAnimating && this.enableAutoPrefetching) {
        prefetchImagesForNonAnimation(this);
      }
      /* Loop through all layers */
      this.layers && this.layers.forEach(function (layer) {
        var _a;
        if (layer.service && layer.enabled && layer.isConfigured) {
          var requestURL = (_a = buildWMSGetMapRequest(_this10, layer)) === null || _a === void 0 ? void 0 : _a.url;
          if (requestURL) {
            _this10.divBuffer.setSrc(currentLayerIndex, requestURL, {
              layer: layer
            }, layer.opacity, _this10.getDrawBBOX());
            currentLayerIndex += 1;
          }
        }
      });
      this.baseLayers && this.baseLayers.forEach(function (baseLayer) {
        var _a;
        if (baseLayer.enabled && baseLayer.keepOnTop === true) {
          var requestURL = (_a = buildWMSGetMapRequest(_this10, baseLayer)) === null || _a === void 0 ? void 0 : _a.url;
          if (requestURL) {
            _this10.divBuffer.setSrc(currentLayerIndex, requestURL, {
              layer: baseLayer
            }, baseLayer.opacity, _this10.getDrawBBOX());
            currentLayerIndex += 1;
          }
        }
      });
      this.divBuffer.display();
      this.callBack.triggerEvent('onmapready', this);
    }
  }, {
    key: "_updateBoundingBox",
    value: function _updateBoundingBox(_mapbbox) {
      var triggerEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.divBuffer) {
        return;
      }
      var mapbbox = this.bbox;
      if (isDefined(_mapbbox)) {
        mapbbox = _mapbbox;
      }
      this.updateBBOX.setBBOX(mapbbox);
      this.divBuffer.setBBOX(this.updateBBOX, this.drawnBBOX);
      this.drawnBBOX.setBBOX(mapbbox);
      this.showBoundingBox(this.divBoundingBox.bbox, this.updateBBOX);
      this.mapPin.repositionMapPin(_mapbbox);
      if (triggerEvent) {
        this.callBack.triggerEvent('onupdatebbox', this.updateBBOX);
      }
    }
  }, {
    key: "redrawBuffer",
    value: function redrawBuffer() {
      this.divBuffer.display();
      debugLogger(DebugType.Log);
      this.drawnBBOX.setBBOX(this.bbox);
      this.draw();
    }
  }, {
    key: "addBaseLayers",
    value: function addBaseLayers(layer) {
      if (layer) {
        this.numBaseLayers = 0;
        this.baseLayers.push(layer);
        for (var j = 0; j < this.baseLayers.length; j += 1) {
          if (this.baseLayers[j].keepOnTop === true) {
            this.numBaseLayers += 1;
          }
        }
        this.callBack.triggerEvent('onlayeradd');
      } else {
        this.baseLayers = undefined;
      }
    }
  }, {
    key: "setBaseLayers",
    value: function setBaseLayers(layer) {
      if (layer) {
        this.numBaseLayers = 0;
        this.baseLayers = layer;
        for (var j = 0; j < this.baseLayers.length; j += 1) {
          this.baseLayers[j].parentMap = this;
          if (this.baseLayers[j].keepOnTop !== true) {
            this.numBaseLayers += 1;
          }
        }
        this.callBack.triggerEvent('onlayerchange');
      } else {
        this.baseLayers = undefined;
      }
    }
  }, {
    key: "getBaseLayers",
    value: function getBaseLayers() {
      return this.baseLayers;
    }
  }, {
    key: "getNumLayers",
    value: function getNumLayers() {
      return this.layers.length;
    }
  }, {
    key: "getBaseElement",
    value: function getBaseElement() {
      return this.baseDiv;
    }
  }, {
    key: "mouseWheelEvent",
    value: function mouseWheelEvent(event) {
      preventdefaultEvent(event);
      if (this.mouseWheelBusy === 1) {
        return;
      }
      var _this$getMouseCoordin = this.getMouseCoordinatesForDocument(event),
        x = _this$getMouseCoordin.x,
        y = _this$getMouseCoordin.y;
      this.setMouseCoordinates(x, y);
      var delta = -event.deltaY;
      this.mouseWheelBusy = 1;
      var w = this.updateBBOX.right - this.updateBBOX.left;
      var h = this.updateBBOX.bottom - this.updateBBOX.top;
      var geoMouseXY = this.getGeoCoordFromPixelCoord({
        x: this.mouseX,
        y: this.mouseY
      }, this.drawnBBOX);
      var nx = (geoMouseXY.x - this.updateBBOX.left) / w; // Normalized to 0-1
      var ny = (geoMouseXY.y - this.updateBBOX.top) / h;
      var zoomW;
      var zoomH;
      if (delta < 0) {
        zoomW = w * -0.25;
        zoomH = h * -0.25;
      } else {
        zoomW = w * 0.2;
        zoomH = h * 0.2;
      }
      var newLeft = this.updateBBOX.left + zoomW;
      var newTop = this.updateBBOX.top + zoomH;
      var newRight = this.updateBBOX.right - zoomW;
      var newBottom = this.updateBBOX.bottom - zoomH;
      var newW = newRight - newLeft;
      var newH = newBottom - newTop;
      var newX = nx * newW + newLeft;
      var newY = ny * newH + newTop;
      var panX = newX - geoMouseXY.x;
      var panY = newY - geoMouseXY.y;
      newLeft -= panX;
      newRight -= panX;
      newTop -= panY;
      newBottom -= panY;
      this.mouseWheelEventBBOXCurrent.copy(this.updateBBOX);
      this.mouseWheelEventBBOXNew.left = newLeft;
      this.mouseWheelEventBBOXNew.bottom = newBottom;
      this.mouseWheelEventBBOXNew.right = newRight;
      this.mouseWheelEventBBOXNew.top = newTop;
      this.mouseWheelBusy = 0;
      if (Math.abs(delta) < 4) {
        this.wMFlyToBBox.flyZoomToBBOXStartZoomThrottled(this.mouseWheelEventBBOXCurrent, this.mouseWheelEventBBOXNew);
      } else {
        this.wMFlyToBBox.flyZoomToBBOXStartZoom(this.mouseWheelEventBBOXCurrent, this.mouseWheelEventBBOXNew);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.initialized) {
        return;
      }
      this.stopAnimating();
      for (var i = this.layers.length - 1; i >= 0; i -= 1) {
        this.layers[i].setAutoUpdate(false);
      }
      this.detachEvents();
      this.callBack.destroy();
      this.callBack = null;
      getMapImageStore.removeEventCallback(this.internalMapId);
      bgMapImageStore.removeEventCallback(this.internalMapId);
      getLegendImageStore().removeEventCallback(this.internalMapId);
      this.internalMapId = '';
      this.mainElement.removeChild(this.baseDiv);
      this.baseDiv.innerHTML = '';
      this.divZoomBox.innerHTML = '';
      this.divBoundingBox.innerHTML = '';
      this.divDimInfo.innerHTML = '';
      this.loadingDiv.innerHTML = '';
      this.baseDiv = undefined;
      this.divZoomBox = undefined;
      this.divBoundingBox = undefined;
      this.divDimInfo = undefined;
      this.loadingDiv = undefined;
      this.isDestroyed = true;
      this.initialized = false;
    }
  }, {
    key: "detachEvents",
    value: function detachEvents() {
      this.baseDiv.removeEventListener('mousedown', this.mouseDownEvent);
      this.baseDiv.removeEventListener('mouseup', this.mouseUpEvent);
      this.baseDiv.removeEventListener('mousemove', this.mouseMoveEvent);
      this.baseDiv.removeEventListener('contextmenu', this.onContextMenu);
      this.baseDiv.removeEventListener('wheel', this.mouseWheelEvent);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this.baseDiv.addEventListener('mousedown', this.mouseDownEvent);
      this.baseDiv.addEventListener('mouseup', this.mouseUpEvent);
      this.baseDiv.addEventListener('mousemove', this.mouseMoveEvent);
      this.baseDiv.addEventListener('contextmenu', this.onContextMenu);
      this.baseDiv.addEventListener('wheel', this.mouseWheelEvent);
      this.setMapModePan();
    }
    /* Returns all dimensions with its current values as object */
  }, {
    key: "_buildLayerDims",
    value: function _buildLayerDims() {
      var _this11 = this;
      if (this.buildLayerDimsBusy === true) {
        return;
      }
      this.mapdimensions.forEach(function (mapDim) {
        _this11.layers.forEach(function (layer) {
          layer.dimensions.forEach(function (layerDim) {
            if (layerDim.linked === true && layerDim.name === mapDim.name) {
              if (mapDim.currentValue === 'current' || mapDim.currentValue === 'default' || mapDim.currentValue === '' || mapDim.currentValue === 'earliest' || mapDim.currentValue === 'middle' || mapDim.currentValue === 'latest') {
                mapDim.currentValue = layerDim.getClosestValue(mapDim.currentValue);
              }
              _this11.buildLayerDimsBusy = true;
              layerDim.setClosestValue(mapDim.currentValue);
              _this11.buildLayerDimsBusy = false;
            }
          });
        });
      });
    }
  }, {
    key: "getMapMode",
    value: function getMapMode() {
      return this.mapMode;
    }
    // Makes a valid getfeatureinfoURL for each layer
  }, {
    key: "getWMSGetFeatureInfoRequestURL",
    value: function getWMSGetFeatureInfoRequestURL(layer, x, y) {
      var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text/html';
      /* For invalid layers we cannot build an url */
      if (!layer.name) {
        return '';
      }
      var request = WMJScheckURL(layer.service);
      request += "&SERVICE=WMS&REQUEST=GetFeatureInfo&VERSION=".concat(layer.version);
      request += "&LAYERS=".concat(URLEncode(layer.name));
      request += "&QUERY_LAYERS=".concat(URLEncode(layer.name));
      request += "&".concat(getBBOXandProjString(this, layer));
      request += "WIDTH=".concat(this.width);
      request += "&HEIGHT=".concat(this.height);
      if (layer.version === WMSVersion.version100 || layer.version === WMSVersion.version111) {
        request += "&X=".concat(x);
        request += "&Y=".concat(y);
      }
      if (layer.version === WMSVersion.version130) {
        request += "&I=".concat(x);
        request += "&J=".concat(y);
      }
      request += '&FORMAT=image/gif';
      request += "&INFO_FORMAT=".concat(format);
      request += '&STYLES=';
      try {
        request += "&".concat(getMapDimURL(layer));
      } catch (e) {
        return undefined;
      }
      debugLogger(DebugType.Log);
      return request;
    }
    /* End of GetFeature info handling */
  }, {
    key: "setMapModeGetInfo",
    value: function setMapModeGetInfo() {
      this.mapMode = 'info';
      this.baseDiv.style.cursor = 'default';
    }
  }, {
    key: "setMapModeZoomBoxIn",
    value: function setMapModeZoomBoxIn() {
      this.mapMode = 'zoom';
      this.baseDiv.style.cursor = 'default';
    }
  }, {
    key: "setMapModeZoomOut",
    value: function setMapModeZoomOut() {
      this.mapMode = 'zoomout';
      this.baseDiv.style.cursor = 'default';
    }
  }, {
    key: "setMapModePan",
    value: function setMapModePan() {
      this.mapMode = 'pan';
      this.baseDiv.style.cursor = 'default';
    }
  }, {
    key: "setMapModePoint",
    value: function setMapModePoint() {
      this.mapMode = 'point';
      this.baseDiv.style.cursor = 'url(webmapjs/img/aero_pen.cur), default';
    }
  }, {
    key: "setMapModeNone",
    value: function setMapModeNone() {
      this.mapMode = 'none';
      this.baseDiv.style.cursor = 'default';
    }
  }, {
    key: "getMouseCoordinatesForDocument",
    value: function getMouseCoordinatesForDocument(e) {
      if (isDefined(e.changedTouches)) {
        return {
          x: e.changedTouches[0].screenX,
          y: e.changedTouches[0].screenY
        };
      }
      var parentOffset = this.mainElement.parentElement.getBoundingClientRect();
      var pageX = e.pageX;
      var pageY = e.pageY;
      if (pageX === undefined) {
        pageX = getMouseXCoordinate(e);
      }
      if (pageY === undefined) {
        pageY = getMouseYCoordinate(e);
      }
      var relX = pageX - parentOffset.left;
      var relY = pageY - parentOffset.top;
      return {
        x: relX,
        y: relY
      };
    }
  }, {
    key: "getMouseCoordinatesForElement",
    value: function getMouseCoordinatesForElement(e) {
      if (isDefined(e.changedTouches)) {
        return {
          x: e.changedTouches[0].screenX,
          y: e.changedTouches[0].screenY
        };
      }
      var parentOffset = this.mainElement.parentElement.getBoundingClientRect();
      var pageX = e.pageX;
      var pageY = e.pageY;
      if (pageX === undefined) {
        pageX = getMouseXCoordinate(e);
      }
      if (pageY === undefined) {
        pageY = getMouseYCoordinate(e);
      }
      var relX = pageX - parentOffset.left;
      var relY = pageY - parentOffset.top;
      return {
        x: relX,
        y: relY
      };
    }
  }, {
    key: "mouseDown",
    value: function mouseDown(mouseCoordX, mouseCoordY, event) {
      var shiftKey = false;
      if (event) {
        if (event.shiftKey === true) {
          shiftKey = true;
        }
      }
      this.mouseDownX = mouseCoordX;
      this.mouseDownY = mouseCoordY;
      this.mouseDownPressed = 1;
      if (this.mouseDragging === 0) {
        if (this._checkInvalidMouseAction(this.mouseDownX, this.mouseDownY) === 0) {
          var triggerResults = this.callBack.triggerEvent('beforemousedown', {
            mouseX: mouseCoordX,
            mouseY: mouseCoordY,
            mouseDown: true,
            event: event,
            leftButton: detectLeftButton(event),
            rightButton: detectRightButton(event),
            shiftKey: shiftKey
          });
          for (var j = 0; j < triggerResults.length; j += 1) {
            if (triggerResults[j] === false) {
              return;
            }
          }
        }
      }
      this.controlsBusy = true;
      if (!shiftKey) {
        if (this.oldMapMode !== undefined) {
          this.mapMode = this.oldMapMode;
          this.oldMapMode = undefined;
        }
      } else {
        if (this.oldMapMode === undefined) {
          this.oldMapMode = this.mapMode;
        }
        this.mapMode = 'zoom';
      }
      this.callBack.triggerEvent('mousedown', {
        map: this,
        x: this.mouseDownX,
        y: this.mouseDownY
      });
      if (this.mapMode === 'info' || this.mapMode === 'point') {
        var mouseDownLatLon = this.getLatLongFromPixelCoord({
          x: this.mouseDownX,
          y: this.mouseDownY
        });
        var geoCoords = this.getGeoCoordFromPixelCoord({
          x: this.mouseDownX,
          y: this.mouseDownY
        });
        this.callBack.triggerEvent('onsetmappin', {
          map: this,
          lon: mouseDownLatLon.x,
          lat: mouseDownLatLon.y,
          screenOffsetX: this.mouseDownX,
          screenOffsetY: this.mouseDownY,
          projectionX: geoCoords.x,
          projectionY: geoCoords.y,
          srs: this.srs
        });
        this.mapPin.setMapPin(this.mouseDownX, this.mouseDownY);
      }
    }
  }, {
    key: "_checkInvalidMouseAction",
    value: function _checkInvalidMouseAction(MX, MY) {
      if (MY < 0 || MX < 0 || MX > this.width || MY > this.height) {
        this.InValidMouseAction = 1;
        return -1;
      }
      return 0;
    }
  }, {
    key: "updateMouseCursorCoordinates",
    value: function updateMouseCursorCoordinates(coordinates) {
      if (!coordinates || this.mouseUpdateCoordinates.x === coordinates.x && this.mouseUpdateCoordinates.y === coordinates.y) {
        return;
      }
      this.mouseUpdateCoordinates.x = coordinates.x;
      this.mouseUpdateCoordinates.y = coordinates.y;
      this.mouseGeoCoordXY = this.getGeoCoordFromPixelCoord(coordinates);
      this.display();
    }
  }, {
    key: "mouseDownEvent",
    value: function mouseDownEvent(e) {
      this.previousMouseButtonState = 'down';
      var mouseCoords = this.getMouseCoordinatesForDocument(e);
      if (this.mapHeader.cursorSet && mouseCoords.y < this.mapHeader.height) {
        return;
      }
      this.mouseDown(mouseCoords.x, mouseCoords.y, e);
    }
  }, {
    key: "mouseMoveEvent",
    value: function mouseMoveEvent(e) {
      /* Small state machine to detect mouse changes outside of the base element */
      var currentMouseButtonState = e.buttons === 0 ? 'up' : 'down';
      if (this.previousMouseButtonState === 'down' && currentMouseButtonState === 'up') {
        this.mouseUpEvent(e);
      }
      if (this.previousMouseButtonState !== currentMouseButtonState) {
        this.previousMouseButtonState = currentMouseButtonState;
      }
      var mouseCoords = this.getMouseCoordinatesForDocument(e);
      if (this.mouseDownPressed === 0 && mouseCoords.y >= 0 && mouseCoords.y < this.mapHeader.height && mouseCoords.x >= 0 && mouseCoords.x <= this.width) {
        if (this.mapHeader.cursorSet === false) {
          this.mapHeader.cursorSet = true;
          this.mapHeader.prevCursor = this.currentCursor;
          this.mapHeader.hovering = true;
          this.setCursor('pointer');
          this.draw('mouseMoveEvent');
        }
      } else if (this.mapHeader.cursorSet === true) {
        this.mapHeader.cursorSet = false;
        this.mapHeader.hovering = false;
        this.setCursor(this.mapHeader.prevCursor);
        this.draw('mouseMoveEvent');
      }
      this.mouseMove(mouseCoords.x, mouseCoords.y, e);
    }
  }, {
    key: "mouseUpEvent",
    value: function mouseUpEvent(e) {
      preventdefaultEvent(e);
      this.previousMouseButtonState = 'up';
      var mouseCoords = this.getMouseCoordinatesForDocument(e);
      this.mouseUp(mouseCoords.x, mouseCoords.y, e);
    }
  }, {
    key: "mouseMove",
    value: function mouseMove(mouseCoordX, mouseCoordY, event) {
      this.setMouseCoordinates(mouseCoordX, mouseCoordY);
      // TODO: add tests to ensure mouse cursor coordinates are still updated while in drawing mode. See: https://gitlab.com/opengeoweb/opengeoweb/-/issues/1319
      this.updateMouseCursorCoordinates({
        x: this.mouseX,
        y: this.mouseY
      });
      if (this.mouseDragging === 0) {
        var triggerResults = this.callBack.triggerEvent('beforemousemove', {
          mouseX: this.mouseX,
          mouseY: this.mouseY,
          mouseDown: this.mouseDownPressed === 1,
          leftButton: detectLeftButton(event),
          rightButton: detectRightButton(event)
        });
        for (var j = 0; j < triggerResults.length; j += 1) {
          if (triggerResults[j] === false) {
            return;
          }
        }
      }
      if (this.divBoundingBox.displayed === true && this.mapPanning === 0) {
        var tlpx = this.getPixelCoordFromGeoCoord({
          x: this.divBoundingBox.bbox.left,
          y: this.divBoundingBox.bbox.top
        });
        var brpx = this.getPixelCoordFromGeoCoord({
          x: this.divBoundingBox.bbox.right,
          y: this.divBoundingBox.bbox.bottom
        });
        var foundBBOXRib = false;
        if (this.mouseDownPressed === 0) {
          if (this.resizingBBOXEnabled === '') {
            this.resizingBBOXCursor = getComputedStyle(this.baseDiv).cursor;
          }
          // Find left rib
          if (Math.abs(this.mouseX - tlpx.x) < 6 && this.mouseY > tlpx.y && this.mouseY < brpx.y) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'col-resize';
            this.resizingBBOXEnabled = 'left';
          }
          // Find top rib
          if (Math.abs(this.mouseY - tlpx.y) < 6 && this.mouseX > tlpx.x && this.mouseX < brpx.x) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'row-resize';
            this.resizingBBOXEnabled = 'top';
          }
          // Find right rib
          if (Math.abs(this.mouseX - brpx.x) < 6 && this.mouseY > tlpx.y && this.mouseY < brpx.y) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'col-resize';
            this.resizingBBOXEnabled = 'right';
          }
          // Find bottom rib
          if (Math.abs(this.mouseY - brpx.y) < 6 && this.mouseX > tlpx.x && this.mouseX < brpx.x) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'row-resize';
            this.resizingBBOXEnabled = 'bottom';
          }
          // Find topleft corner
          if (Math.abs(this.mouseX - tlpx.x) < 6 && Math.abs(this.mouseY - tlpx.y) < 6) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'nw-resize';
            this.resizingBBOXEnabled = 'topleft';
          }
          // Find topright corner
          if (Math.abs(this.mouseX - brpx.x) < 6 && Math.abs(this.mouseY - tlpx.y) < 6) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'ne-resize';
            this.resizingBBOXEnabled = 'topright';
          }
          // Find bottomleft corner
          if (Math.abs(this.mouseX - tlpx.x) < 6 && Math.abs(this.mouseY - brpx.y) < 6) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'sw-resize';
            this.resizingBBOXEnabled = 'bottomleft';
          }
          // Find bottomright corner
          if (Math.abs(this.mouseX - brpx.x) < 6 && Math.abs(this.mouseY - brpx.y) < 6) {
            foundBBOXRib = true;
            this.baseDiv.style.cursor = 'se-resize';
            this.resizingBBOXEnabled = 'bottomright';
          }
        }
        if (foundBBOXRib === true || this.resizingBBOXEnabled !== '' && this.mouseDownPressed === 1) {
          if (this.mouseDownPressed === 1) {
            if (this.resizingBBOXEnabled === 'left') {
              tlpx.x = this.mouseX;
            }
            if (this.resizingBBOXEnabled === 'top') {
              tlpx.y = this.mouseY;
            }
            if (this.resizingBBOXEnabled === 'right') {
              brpx.x = this.mouseX;
            }
            if (this.resizingBBOXEnabled === 'bottom') {
              brpx.y = this.mouseY;
            }
            if (this.resizingBBOXEnabled === 'topleft') {
              tlpx.x = this.mouseX;
              tlpx.y = this.mouseY;
            }
            if (this.resizingBBOXEnabled === 'topright') {
              brpx.x = this.mouseX;
              tlpx.y = this.mouseY;
            }
            if (this.resizingBBOXEnabled === 'bottomleft') {
              tlpx.x = this.mouseX;
              brpx.y = this.mouseY;
            }
            if (this.resizingBBOXEnabled === 'bottomright') {
              brpx.x = this.mouseX;
              brpx.y = this.mouseY;
            }
            tlpx = this.getGeoCoordFromPixelCoord(tlpx);
            brpx = this.getGeoCoordFromPixelCoord(brpx);
            this.divBoundingBox.bbox.left = tlpx.x;
            this.divBoundingBox.bbox.top = tlpx.y;
            this.divBoundingBox.bbox.right = brpx.x;
            this.divBoundingBox.bbox.bottom = brpx.y;
            this.showBoundingBox(this.divBoundingBox.bbox);
            var data = {
              map: this,
              bbox: this.divBoundingBox.bbox
            };
            this.callBack.triggerEvent('bboxchanged', data);
          }
          return;
        }
        this.resizingBBOXEnabled = '';
        this.baseDiv.style.cursor = this.resizingBBOXCursor;
      }
      if (this._checkInvalidMouseAction(this.mouseX, this.mouseY) === -1) {
        try {
          this.callBack.triggerEvent('onmousemove', [undefined, undefined]);
          this.updateMouseCursorCoordinates(undefined);
        } catch (e) {
          debugLogger(DebugType.Error);
        }
        this.mouseUpX = this.mouseX;
        this.mouseUpY = this.mouseY;
        if (this.mapPanning === 0) {
          return;
        }
        if (this.mouseDownPressed === 1) {
          if (this.mapMode === 'zoomout') {
            this.zoomOut();
          }
        }
        this.mouseDownPressed = 0;
        if (this.mouseDragging === 1) {
          this.mouseDragEnd(this.mouseUpX, this.mouseUpY);
        }
        return;
      }
      if (this.mouseDownPressed === 1) {
        if (!(Math.abs(this.mouseDownX - this.mouseX) < 3 && Math.abs(this.mouseDownY - this.mouseY) < 3)) {
          this.mouseDrag(this.mouseX, this.mouseY);
        }
      }
      this.callBack.triggerEvent('onmousemove', [this.mouseX, this.mouseY]);
    }
  }, {
    key: "mouseUp",
    value: function mouseUp(mouseCoordX, mouseCoordY, e) {
      this.controlsBusy = false;
      this.mouseUpX = mouseCoordX;
      this.mouseUpY = mouseCoordY;
      if (this.mouseDragging === 0) {
        if (this._checkInvalidMouseAction(this.mouseUpX, this.mouseUpY) === 0) {
          var triggerResults = this.callBack.triggerEvent('beforemouseup', {
            mouseX: mouseCoordX,
            mouseY: mouseCoordY,
            mouseDown: false,
            event: e
          });
          for (var j = 0; j < triggerResults.length; j += 1) {
            if (triggerResults[j] === false) {
              this.mouseDownPressed = 0;
              return;
            }
          }
        }
      }
      if (this.mouseDownPressed === 1) {
        if (this.mapMode === 'zoomout') {
          this.zoomOut();
        }
        if (this.mouseDragging === 0) {
          if (Math.abs(this.mouseDownX - this.mouseUpX) < 3 && Math.abs(this.mouseDownY - this.mouseUpY) < 3) {
            if (isDefined(e)) {
              this.callBack.triggerEvent('mouseclicked', {
                map: this,
                x: this.mouseUpX,
                y: this.mouseUpY,
                shiftKeyPressed: e.shiftKey === true
              });
            }
            this.mapPin.setMapPin(this.mouseDownX, this.mouseDownY);
            var mouseDownLatLon = this.getLatLongFromPixelCoord({
              x: this.mouseDownX,
              y: this.mouseDownY
            });
            this.callBack.triggerEvent('onsetmappin', {
              map: this,
              lon: mouseDownLatLon.x,
              lat: mouseDownLatLon.y
            });
          }
        }
        this.callBack.triggerEvent('mouseup', {
          map: this,
          x: this.mouseUpX,
          y: this.mouseUpY
        });
      }
      this.mouseDownPressed = 0;
      if (this.mouseDragging === 1) {
        this.mouseDragEnd(this.mouseUpX, this.mouseUpY);
      }
    }
    /* Derived mouse methods */
  }, {
    key: "_mouseDragStart",
    value: function _mouseDragStart(x, y) {
      if (this.mapMode === 'pan') {
        this._mapPanStart(x, y);
      }
      if (this.mapMode === 'zoom') {
        this._mapZoomStart();
      }
    }
  }, {
    key: "mouseDrag",
    value: function mouseDrag(x, y) {
      if (this.mouseDragging === 0) {
        this._mouseDragStart(x, y);
        this.mouseDragging = 1;
      }
      if (this.mapMode === 'pan') {
        this._mapPan(x, y);
      }
      if (this.mapMode === 'zoom') {
        this._mapZoom();
      }
    }
  }, {
    key: "mouseDragEnd",
    value: function mouseDragEnd(x, y) {
      if (this.mouseDragging === 0) {
        return;
      }
      this.mouseDragging = 0;
      if (this.mapMode === 'pan') {
        this._mapPanEnd(x, y);
      }
      if (this.mapMode === 'zoom') {
        this._mapZoomEnd();
      }
      this.callBack.triggerEvent('mapdragend', {
        map: this,
        x: this.mouseUpX,
        y: this.mouseUpY
      });
    }
    /* Map zoom and pan methodss */
  }, {
    key: "_mapPanStart",
    value: function _mapPanStart(x, y) {
      this.zoomTo(this.updateBBOX);
      this.wMFlyToBBox.flyZoomToBBOXStop();
      this.baseDiv.style.cursor = 'move';
      for (var j = 0; j < this.gfiDialogList.length; j += 1) {
        this.gfiDialogList[j].origX = this.gfiDialogList[j].x;
        this.gfiDialogList[j].origY = this.gfiDialogList[j].y;
      }
      this.mapPanning = 1;
      debugLogger(DebugType.Log);
      this.bbox.setBBOX(this.drawnBBOX);
      this.updateBBOX.setBBOX(this.drawnBBOX);
      this.mapPanStartGeoCoords = this.getGeoCoordFromPixelCoord({
        x: x,
        y: y
      }, this.bbox);
    }
  }, {
    key: "_mapPan",
    value: function _mapPan(x, y) {
      if (this.mapPanning === 0) {
        return;
      }
      if (this.mouseX < 0 || this.mouseY < 0 || this.mouseX > this.mainElement.clientWidth || this.mouseY > this.mainElement.clientHeight) {
        this._mapPanEnd(x, y);
        return;
      }
      var mapPanGeoCoords = this.getGeoCoordFromPixelCoord({
        x: x,
        y: y
      }, this.updateBBOX);
      var diffX = mapPanGeoCoords.x - this.mapPanStartGeoCoords.x;
      var diffY = mapPanGeoCoords.y - this.mapPanStartGeoCoords.y;
      var newLeft = this.updateBBOX.left - diffX;
      var newBottom = this.updateBBOX.bottom - diffY;
      var newRight = this.updateBBOX.right - diffX;
      var newTop = this.updateBBOX.top - diffY;
      this.updateBBOX.left = newLeft;
      this.updateBBOX.bottom = newBottom;
      this.updateBBOX.right = newRight;
      this.updateBBOX.top = newTop;
      this._updateBoundingBox(this.updateBBOX);
    }
  }, {
    key: "_mapPanEnd",
    value: function _mapPanEnd(x, y) {
      this.baseDiv.style.cursor = 'default';
      if (this.mapPanning === 0) {
        return;
      }
      this.mapPanning = 0;
      var mapPanGeoCoords = this.getGeoCoordFromPixelCoord({
        x: x,
        y: y
      }, this.drawnBBOX);
      var diffX = mapPanGeoCoords.x - this.mapPanStartGeoCoords.x;
      var diffY = mapPanGeoCoords.y - this.mapPanStartGeoCoords.y;
      this.updateBBOX.left = this.drawnBBOX.left - diffX;
      this.updateBBOX.bottom = this.drawnBBOX.bottom - diffY;
      this.updateBBOX.right = this.drawnBBOX.right - diffX;
      this.updateBBOX.top = this.drawnBBOX.top - diffY;
      this._updateBoundingBox(this.updateBBOX);
      this.zoomTo(this.updateBBOX);
      this.draw('mapPanEnd');
    }
  }, {
    key: "mapPanPercentage",
    value: function mapPanPercentage(percentageDiffX, percentageDiffY) {
      var _this$updateBBOX = this.updateBBOX,
        left = _this$updateBBOX.left,
        bottom = _this$updateBBOX.bottom,
        right = _this$updateBBOX.right,
        top = _this$updateBBOX.top;
      if (percentageDiffX !== 0) {
        var diffX = percentageDiffX * Math.abs(left - right);
        this.updateBBOX.left = left - diffX;
        this.updateBBOX.right = right - diffX;
      }
      if (percentageDiffY !== 0) {
        var diffY = percentageDiffY * Math.abs(top - bottom);
        this.updateBBOX.bottom = bottom - diffY;
        this.updateBBOX.top = top - diffY;
      }
      this._updateBoundingBox(this.updateBBOX);
      this._mapPanPercentageEnd();
    }
  }, {
    key: "_mapPanPercentageEnd",
    value: function _mapPanPercentageEnd() {
      this.zoomTo(this.updateBBOX);
      this.draw('mapPanEnd');
    }
  }, {
    key: "_mapZoomStart",
    value: function _mapZoomStart() {
      this.baseDiv.style.cursor = 'crosshair';
      this.mapZooming = 1;
    }
  }, {
    key: "_mapZoom",
    value: function _mapZoom() {
      if (this.mapZooming === 0) {
        return;
      }
      var x = this.mouseX - this.mouseDownX;
      var y = this.mouseY - this.mouseDownY;
      if (x < 0 && y < 0) {
        this.baseDiv.style.cursor = 'not-allowed';
      } else {
        this.baseDiv.style.cursor = 'crosshair';
      }
      var w = x;
      var h = y;
      this.divZoomBox.style.display = '';
      if (w < 0) {
        w = -w;
        this.divZoomBox.style.left = "".concat(this.mouseX, "px");
      } else {
        this.divZoomBox.style.left = "".concat(this.mouseDownX, "px");
      }
      if (h < 0) {
        h = -h;
        this.divZoomBox.style.top = "".concat(this.mouseY, "px");
      } else {
        this.divZoomBox.style.top = "".concat(this.mouseDownY, "px");
      }
      this.divZoomBox.style.width = "".concat(w, "px");
      this.divZoomBox.style.height = "".concat(h, "px");
    }
  }, {
    key: "_mapZoomEnd",
    value: function _mapZoomEnd() {
      var x = this.mouseUpX - this.mouseDownX;
      var y = this.mouseUpY - this.mouseDownY;
      this.baseDiv.style.cursor = 'default';
      if (this.mapZooming === 0) {
        return;
      }
      this.mapZooming = 0;
      this.divZoomBox.style.display = 'none';
      if (x < 0 && y < 0) {
        return;
      }
      var zoomBBOXPixels = new WMBBOX();
      if (x < 0) {
        zoomBBOXPixels.left = this.mouseDownX + x;
        zoomBBOXPixels.right = this.mouseDownX;
      } else {
        zoomBBOXPixels.left = this.mouseDownX;
        zoomBBOXPixels.right = this.mouseDownX + x;
      }
      if (y < 0) {
        zoomBBOXPixels.top = this.mouseDownY + y;
        zoomBBOXPixels.bottom = this.mouseDownY;
      } else {
        zoomBBOXPixels.top = this.mouseDownY;
        zoomBBOXPixels.bottom = this.mouseDownY + y;
      }
      var p1 = this.pixelCoordinatesToXY({
        x: zoomBBOXPixels.left,
        y: zoomBBOXPixels.bottom
      });
      var p2 = this.pixelCoordinatesToXY({
        x: zoomBBOXPixels.right,
        y: zoomBBOXPixels.top
      });
      zoomBBOXPixels.left = p1.x;
      zoomBBOXPixels.bottom = p1.y;
      zoomBBOXPixels.right = p2.x;
      zoomBBOXPixels.top = p2.y;
      this.zoomTo(zoomBBOXPixels);
      this.draw('mapZoomEnd');
    }
  }, {
    key: "setCursor",
    value: function setCursor(cursor) {
      if (cursor) {
        this.currentCursor = cursor;
      } else {
        this.currentCursor = 'default';
      }
      this.baseDiv.style.cursor = this.currentCursor;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.makeComponentId('webmapjsinstance');
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(_newbbox) {
      var _this12 = this;
      debugLogger(DebugType.Log);
      var setOrigBox = false;
      var newbbox = new WMBBOX(_newbbox);
      // Maintain aspect ratio
      var ratio = 1;
      try {
        ratio = (this.resizeBBOX.left - this.resizeBBOX.right) / (this.resizeBBOX.bottom - this.resizeBBOX.top);
      } catch (e) {
        setOrigBox = true;
      }
      // Check whether we have had valid bbox values
      if (isNaN(ratio)) {
        setOrigBox = true;
      }
      if (setOrigBox === true) {
        debugLogger(DebugType.Error);
        ratio = 1;
      }
      if (ratio < 0) {
        ratio = -ratio;
      }
      var screenRatio = this.width / this.height;
      // Is W > H?
      if (ratio > screenRatio) {
        // W is more than H, so calc H
        var centerH = (newbbox.top + newbbox.bottom) / 2;
        var extentH = (newbbox.left - newbbox.right) / 2 / ratio;
        newbbox.bottom = centerH + extentH;
        newbbox.top = centerH - extentH;
      } else {
        // H is more than W, so calc W
        var centerW = (newbbox.right + newbbox.left) / 2;
        var extentW = (newbbox.bottom - newbbox.top) / 2 * ratio;
        newbbox.left = centerW + extentW;
        newbbox.right = centerW - extentW;
      }
      this.setBBOX(newbbox);
      this._updateBoundingBox(this.bbox);
      this.drawnBBOX.setBBOX(this.bbox);
      var resetMapPinAndDialogs = function resetMapPinAndDialogs() {
        for (var j = 0; j < _this12.gfiDialogList.length; j += 1) {
          var newpos = _this12.getPixelCoordFromGeoCoord({
            x: _this12.gfiDialogList[j].geoPosX,
            y: _this12.gfiDialogList[j].geoPosY
          });
          if (_this12.gfiDialogList[j].hasBeenDragged === false) {
            if (_this12.gfiDialogList[j].moveToMouseCursor === true) {
              _this12.gfiDialogList[j].setXY(_this12.gfiDialogList[j].origX + newpos.x, _this12.gfiDialogList[j].origY + newpos.y);
            }
          }
        }
      };
      resetMapPinAndDialogs();
    }
  }, {
    key: "pixelCoordinatesToXY",
    value: function pixelCoordinatesToXY(coordinates) {
      return this.getGeoCoordFromPixelCoord(coordinates);
    }
  }, {
    key: "getGeoCoordFromPixelCoord",
    value: function getGeoCoordFromPixelCoord(coordinates, _bbox) {
      var mybbox = this.bbox;
      if (_bbox) {
        mybbox = _bbox;
      }
      if (!isDefined(coordinates)) {
        return undefined;
      }
      try {
        var lon = coordinates.x / this.width * (mybbox.right - mybbox.left) + mybbox.left;
        var lat = coordinates.y / this.height * (mybbox.bottom - mybbox.top) + mybbox.top;
        return {
          x: lon,
          y: lat
        };
      } catch (e) {
        return undefined;
      }
    }
  }, {
    key: "getProj4",
    value: function getProj4() {
      if (!this.srs || this.srs === 'GFI:TIME_ELEVATION') {
        return null;
      }
      if (this.proj4.srs !== this.srs || !isDefined(this.proj4.projection)) {
        this.proj4.projection = this.srs;
        this.proj4.srs = this.srs;
      }
      return {
        lonlat: this.longlat,
        crs: this.proj4.projection,
        proj4: proj4
      };
    }
  }, {
    key: "getPixelCoordFromLatLong",
    value: function getPixelCoordFromLatLong(coordinates) {
      if (!this.srs || this.srs === 'GFI:TIME_ELEVATION') {
        return coordinates;
      }
      var result;
      try {
        var p = {
          x: undefined,
          y: undefined
        };
        p.x = parseFloat(coordinates.x);
        p.y = parseFloat(coordinates.y);
        if (this.proj4.srs !== this.srs || !isDefined(this.proj4.projection)) {
          this.proj4.projection = this.srs;
          this.proj4.srs = this.srs;
        }
        result = proj4(this.longlat, this.proj4.projection, [p.x, p.y]);
      } catch (e) {
        debugLogger(DebugType.Error);
        return undefined;
      }
      return this.getPixelCoordFromGeoCoord({
        x: result[0],
        y: result[1]
      });
    }
  }, {
    key: "calculateBoundingBoxAndZoom",
    value: function calculateBoundingBoxAndZoom(lat, lng) {
      var lengthToBBOX = 500000;
      if (this.srs === 'EPSG:4326' || this.srs === 'EPSG:50001') {
        lengthToBBOX = 5;
      }
      var latlng = this.getPixelCoordFromLatLong({
        x: lng,
        y: lat
      });
      var geolatlng = this.getGeoCoordFromPixelCoord(latlng);
      var searchZoomBBOX = new WMBBOX();
      /* Making the boundingbox. */
      searchZoomBBOX.left = geolatlng.x - lengthToBBOX;
      searchZoomBBOX.bottom = geolatlng.y - lengthToBBOX;
      searchZoomBBOX.right = geolatlng.x + lengthToBBOX;
      searchZoomBBOX.top = geolatlng.y + lengthToBBOX;
      this.zoomTo(searchZoomBBOX);
      this.mapPin.positionMapPinByLatLon({
        x: lng,
        y: lat
      });
      this.draw('zoomIn');
    }
  }, {
    key: "getLatLongFromPixelCoord",
    value: function getLatLongFromPixelCoord(coordinates) {
      if (!this.srs || this.srs === 'GFI:TIME_ELEVATION') {
        return coordinates;
      }
      try {
        var p = {
          x: undefined,
          y: undefined
        };
        p.x = coordinates.x / this.width * (this.bbox.right - this.bbox.left) + this.bbox.left;
        p.y = coordinates.y / this.height * (this.bbox.bottom - this.bbox.top) + this.bbox.top;
        if (this.proj4.srs !== this.srs) {
          this.proj4.projection = this.srs;
          this.proj4.srs = this.srs;
        }
        var result = proj4(this.proj4.projection, this.longlat, [p.x, p.y]);
        return {
          x: result[0],
          y: result[1]
        };
      } catch (e) {
        return undefined;
      }
    }
  }, {
    key: "getPixelCoordFromGeoCoord",
    value: function getPixelCoordFromGeoCoord(coordinates, _bbox, _width, _height) {
      var w = this.width;
      var h = this.height;
      var b = this.updateBBOX;
      if (isDefined(_width)) {
        w = _width;
      }
      if (isDefined(_height)) {
        h = _height;
      }
      if (isDefined(_bbox)) {
        b = _bbox;
      }
      var x = w * (coordinates.x - b.left) / (b.right - b.left);
      var y = h * (coordinates.y - b.top) / (b.bottom - b.top);
      return {
        x: x,
        y: y
      };
    }
    // listeners:
  }, {
    key: "addListener",
    value: function addListener(name,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    f) {
      var keep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.callBack.addToCallback(name, f, keep);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "removeListener",
    value: function removeListener(name, f) {
      if (this.isDestroyed) {
        return;
      }
      this.callBack.removeEvents(name, f);
    }
  }, {
    key: "getListener",
    value: function getListener() {
      return this.callBack;
    }
  }, {
    key: "suspendEvent",
    value: function suspendEvent(name) {
      this.callBack.suspendEvent(name);
    }
  }, {
    key: "resumeEvent",
    value: function resumeEvent(name) {
      this.callBack.resumeEvent(name);
    }
  }, {
    key: "getDimensionList",
    value: function getDimensionList() {
      return this.mapdimensions;
    }
  }, {
    key: "getDimension",
    value: function getDimension(name) {
      for (var i = 0; i < this.mapdimensions.length; i += 1) {
        if (this.mapdimensions[i].name === name) {
          return this.mapdimensions[i];
        }
      }
      return undefined;
    }
  }, {
    key: "setTimeDimension",
    value: function setTimeDimension(value, triggerEvent) {
      this.setDimension('time', value, triggerEvent);
    }
  }, {
    key: "setDimension",
    value: function setDimension(name, value) {
      var triggerEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var adjustLayerDims = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      debugLogger(DebugType.Log);
      if (!isDefined(name) || !isDefined(value)) {
        debugLogger(DebugType.Error);
        return;
      }
      var dim = this.getDimension(name);
      if (isDefined(dim) === false) {
        dim = new WMJSDimension({
          name: name,
          currentValue: value
        });
        this.mapdimensions.push(dim);
      }
      if (dim.currentValue !== value) {
        dim.currentValue = value;
        if (adjustLayerDims) {
          this._buildLayerDims();
        }
        if (triggerEvent === true) {
          this.callBack.triggerEvent('ondimchange', name);
        }
      }
    }
  }, {
    key: "zoomToLayer",
    value: function zoomToLayer(_layer) {
      // Tries to zoom to the layers boundingbox corresponding to the current map projection
      // If something fails, the defaultBBOX is used instead.
      var layer = _layer;
      if (!layer) {
        layer = this.activeLayer;
      }
      if (!layer) {
        this.zoomTo(this.defaultBBOX);
        this.draw('zoomTolayer');
        return;
      }
      for (var j = 0; j < layer.projectionProperties.length; j += 1) {
        if (layer.projectionProperties[j].srs === this.srs) {
          var w = layer.projectionProperties[j].bbox.right - layer.projectionProperties[j].bbox.left;
          var h = layer.projectionProperties[j].bbox.top - layer.projectionProperties[j].bbox.bottom;
          var newBBOX = layer.projectionProperties[j].bbox.clone();
          newBBOX.left -= w / 100;
          newBBOX.right += w / 100;
          newBBOX.bottom -= h / 100;
          newBBOX.top += h / 100;
          this.zoomTo(newBBOX);
          this.draw('zoomTolayer');
          return;
        }
      }
      debugLogger(DebugType.Error, "WebMapJS: Unable to find the correct bbox with current map projection ".concat(this.srs, " for layer ").concat(layer.title, ". Using default bbox instead."));
      this.zoomTo(this.defaultBBOX);
      this.draw('zoomTolayer');
    }
  }, {
    key: "setDefaultBBOX",
    value: function setDefaultBBOX(bbox) {
      this.defaultBBOX.setBBOX(bbox);
    }
  }, {
    key: "setBBOX",
    value: function setBBOX(left, bottom, right, top) {
      debugLogger(DebugType.Log);
      this.bbox.setBBOX(left, bottom, right, top);
      this.resizeBBOX.setBBOX(this.bbox);
      this.wMFlyToBBox.flyZoomToBBOXFly.setBBOX(this.bbox);
      if (this.srs !== 'GFI:TIME_ELEVATION') {
        var divRatio = this.width / this.height;
        var bboxRatio = (this.bbox.right - this.bbox.left) / (this.bbox.top - this.bbox.bottom);
        if (bboxRatio > divRatio) {
          var centerH = (this.bbox.top + this.bbox.bottom) / 2;
          var extentH = (this.bbox.left - this.bbox.right) / 2 / divRatio;
          this.bbox.bottom = centerH + extentH;
          this.bbox.top = centerH - extentH;
        } else {
          /* H is more than W, so calc W */
          var centerW = (this.bbox.right + this.bbox.left) / 2;
          var extentW = (this.bbox.bottom - this.bbox.top) / 2 * divRatio;
          this.bbox.left = centerW + extentW;
          this.bbox.right = centerW - extentW;
        }
      }
      this.updateBBOX.setBBOX(this.bbox);
      this.drawnBBOX.setBBOX(this.bbox);
      this.mapPin.repositionMapPin(this.bbox);
      /* Undo part */
      if (this.DoRedo === 0 && this.DoUndo === 0) {
        if (this.UndoPointer !== 0) {
          for (var j = 0; j <= this.UndoPointer; j += 1) {
            this.WMProjectionTempUndo[j] = this.WMProjectionUndo[j];
          }
          for (var _j4 = 0; _j4 <= this.UndoPointer; _j4 += 1) {
            this.WMProjectionUndo[_j4] = this.WMProjectionTempUndo[this.UndoPointer - _j4];
          }
          this.UndoPointer = 0;
        }
        for (var _j5 = this.MaxUndos - 1; _j5 > 0; _j5 -= 1) {
          this.WMProjectionUndo[_j5].bbox.setBBOX(this.WMProjectionUndo[_j5 - 1].bbox);
          this.WMProjectionUndo[_j5].srs = this.WMProjectionUndo[_j5 - 1].srs;
        }
        this.WMProjectionUndo[0].bbox.setBBOX(this.bbox);
        this.WMProjectionUndo[0].srs = this.srs;
        this.NrOfUndos += 1;
        if (this.NrOfUndos > this.MaxUndos) {
          this.NrOfUndos = this.MaxUndos;
        }
      }
      this.DoRedo = 0;
      this.DoUndo = 0;
      this.callBack.triggerEvent('aftersetbbox', this);
      if (this.bbox.equals(left, bottom, right, top) === true) {
        return false;
      }
      return true;
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var a = (this.resizeBBOX.right - this.resizeBBOX.left) / 6;
      this.zoomTo(new WMBBOX(this.resizeBBOX.left - a, this.resizeBBOX.bottom - a, this.resizeBBOX.right + a, this.resizeBBOX.top + a));
      this.draw('zoomOut');
    }
  }, {
    key: "zoomIn",
    value: function zoomIn(ratio) {
      var a = (this.resizeBBOX.left - this.resizeBBOX.right) / 8;
      if (isDefined(ratio) === false) {
        ratio = 1;
      } else if (ratio === 0) {
        return;
      }
      a *= ratio;
      this.zoomTo(new WMBBOX(this.resizeBBOX.left - a, this.resizeBBOX.bottom - a, this.resizeBBOX.right + a, this.resizeBBOX.top + a));
      this.draw('zoomIn');
    }
  }, {
    key: "displayLegendInMap",
    value: function displayLegendInMap(_displayLegendInMap) {
      this._displayLegendInMap = _displayLegendInMap;
      this.repositionLegendGraphic();
    }
  }, {
    key: "showBoundingBox",
    value: function showBoundingBox(_bbox, _mapbbox) {
      if (isDefined(_bbox)) {
        this.divBoundingBox.bbox = _bbox;
        this.divBoundingBox.style.display = '';
        this.divBoundingBox.displayed = true;
      }
      if (this.divBoundingBox.displayed !== true) {
        return;
      }
      var b = this.bbox;
      if (isDefined(_mapbbox)) {
        b = _mapbbox;
      }
      var coord1 = this.getPixelCoordFromGeoCoord({
        x: this.divBoundingBox.bbox.left,
        y: this.divBoundingBox.bbox.top
      }, b);
      var coord2 = this.getPixelCoordFromGeoCoord({
        x: this.divBoundingBox.bbox.right,
        y: this.divBoundingBox.bbox.bottom
      }, b);
      this.divBoundingBox.style.left = "".concat(coord1.x - 1, "px");
      this.divBoundingBox.style.top = "".concat(coord1.y - 2, "px");
      this.divBoundingBox.style.width = "".concat(coord2.x - coord1.x, "px");
      this.divBoundingBox.style.height = "".concat(coord2.y - coord1.y - 1, "px");
    }
  }, {
    key: "hideBoundingBox",
    value: function hideBoundingBox() {
      this.divBoundingBox.style.display = 'none';
      this.divBoundingBox.displayed = false;
    }
  }, {
    key: "getDrawBBOX",
    value: function getDrawBBOX() {
      return this.bbox;
    }
  }]);
  return WMJSMap;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Global service store for re-use of services
 */
var WMServiceStore = [];
var WMServiceStoreXML2JSONRequest = {
  proxy: 'Check WMJSGlobals WMJSServiceStoreXML2JSONRequest'
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var I18n = {
  "delete": {
    text: 'Delete'
  },
  delete_selected_flag_tooltip: {
    tooltip: 'Delete selected flag'
  },
  add_flag_tooltip: {
    tooltip: 'Add a flag with current latitude, longitude and name'
  },
  are_you_sure: {
    text: 'Are you sure about deleting this flag?'
  },
  delete_title_confirm: {
    text: 'Delete flag'
  },
  default_selected_flag: {
    text: 'None'
  },
  selected_flag: {
    text: 'Nearest flag:'
  },
  add_point_interest_abstract: {
    text: 'Add or update your point of interest here with a latitude, a longitude and a name of choice.'
  },
  insert_name: {
    text: 'Name:'
  },
  add_point_interest: {
    text: 'Add point of interest'
  },
  add: {
    text: 'Add'
  },
  place_search_term: {
    text: 'Search for location&hellip;'
  },
  debug_searching_location: {
    text: 'Searching for location in SQLite DB:'
  },
  debug_searching_sqlite_location: {
    text: 'Searching for location with GeoNames API:'
  },
  geonames_api_call_failed: {
    text: 'GeoNames API request failed'
  },
  geonames_sqlite_call_failed: {
    text: 'GeoNames SQLite request failed.'
  },
  no_results_search: {
    text: 'No results for search'
  },
  unable_to_connect_server: {
    text: 'Unable to connect to the service.'
  },
  unable_to_search: {
    text: 'Unable to perform a search'
  },
  no_urls_in_config: {
    text: 'No GeoNames URLs defined in config file'
  },
  only_alpha_num_allowed: {
    text: 'Search may only contain alpha numeric characters'
  },
  no_search_definition: {
    text: 'Search term is empty'
  },
  service_has_error: {
    text: '--- service has an error ---'
  },
  no_time_dimension_in_layer: {
    text: 'No time dimension found in this layer'
  },
  no_service_defined: {
    text: 'No service defined'
  },
  service_url_empty: {
    text: 'Service URL is empty'
  },
  wms_service_exception_code: {
    text: 'WMS Service exception with code '
  },
  unnamed_service: {
    text: 'Unnamed service'
  },
  add_layers: {
    text: 'Add layers&hellip;',
    tooltip: 'Add new datasets, layers and services'
  },
  add_custom_service: {
    text: 'Add a custom version 1.1.1 Web Map Service (WMS)'
  },
  properties_for: {
    text: 'Properties for'
  },
  color_range: {
    text: 'Color range'
  },
  reset: {
    text: 'Reset'
  },
  apply: {
    text: 'Apply'
  },
  min_value: {
    text: 'Min value'
  },
  max_value: {
    text: 'Max value'
  },
  wms_version: {
    text: 'WMS version'
  },
  wms_comp_mode: {
    text: 'WMS 1.3.0 BBOX compatibility mode'
  },
  projections: {
    text: 'Projections'
  },
  projection: {
    text: 'Projection'
  },
  epsg_code: {
    text: 'EPSG Code'
  },
  bounding_box: {
    text: 'Bounding Box'
  },
  file_metadata: {
    text: 'File metadata'
  },
  show_file_metadata: {
    text: 'Show file metadata'
  },
  download_data_wcs: {
    text: 'Download data via WCS'
  },
  coordinate_reference_system: {
    text: 'Coordinate reference system'
  },
  area_bounding_box: {
    text: 'Area / Bounding box'
  },
  dimensions: {
    text: 'Dimensions'
  },
  dimension: {
    text: 'Dimension'
  },
  formats: {
    text: 'Formats'
  },
  north: {
    text: 'North'
  },
  west: {
    text: 'West'
  },
  east: {
    text: 'East'
  },
  south: {
    text: 'South'
  },
  cell_size: {
    text: 'Cell size'
  },
  x_resolution: {
    text: 'X Resolution'
  },
  y_resolution: {
    text: 'Y Resolution'
  },
  raster_size: {
    text: 'Raster size'
  },
  raster_width: {
    text: 'Raster width'
  },
  raster_height: {
    text: 'Raster height'
  },
  format: {
    text: 'Format'
  },
  show: {
    text: 'Show'
  },
  create_permanent_links: {
    text: 'Create permanent links'
  },
  please_select_product: {
    text: 'Please select a product'
  },
  no_capability_element_found: {
    text: 'No Capability element found in service'
  },
  no_wms_capability_element_found: {
    text: 'No WMS Capability element found'
  },
  no_wms_layer_element_found: {
    text: 'No WMS Layer element found'
  },
  settings_and_options: {
    tooltip: 'Settings and options'
  },
  show_time_selection_window: {
    text: 'Show time selection window&hellip;'
  },
  create_animation: {
    text: 'Create animation&hellip;'
  },
  create_link: {
    text: 'Create link&hellip;'
  },
  show_debug_information: {
    text: 'Show debug information&hellip;'
  },
  add_custom_wms_service: {
    text: 'Add custom WMS service&hellip;'
  },
  undo_zoom_pan_action: {
    text: 'Undo zoom/pan action'
  },
  redo_zoom_pan_action: {
    text: 'Redo zoom/pan action'
  },
  abort_loading: {
    text: 'Abort loading'
  },
  about_the_adaguc_viewer: {
    text: 'About the ADAGUC viewer',
    tooptip: 'Display info about the ADAGUC viewer'
  },
  about_adaguc: {
    text: 'About ADAGUC'
  },
  about_adaguc_more_information: {
    text: '<br/><br/>Please visit <a target="_blank" href="http://adaguc.knmi.nl/">http://adaguc.knmi.nl/</a> for more information.<div>'
  },
  layers: {
    text: 'Layers',
    tooltip: 'Layers'
  },
  predefined_areas: {
    tooltip: 'Select predefined areas'
  },
  basemaps_overlays: {
    tooltip: 'Select basemaps and overlays'
  },
  add_layers_and_services: {
    text: 'Add Layers and Services'
  },
  add_new_layer: {
    tooltip: 'Add new layer'
  },
  clone_this_layer: {
    tooltip: 'Clone this layer and place it on top of the layerlist'
  },
  remove_this_layer: {
    tooltip: 'Remove this layer'
  },
  move_layer_up: {
    tooltip: 'Move this layer up in the list and the map view'
  },
  move_layer_down: {
    tooltip: 'Move this layer down in the list and the map view'
  },
  title: {
    text: 'Title'
  },
  layer: {
    text: 'Layer'
  },
  type: {
    text: 'Type'
  },
  name: {
    text: 'Name'
  },
  "abstract": {
    text: 'Abstract'
  },
  service: {
    text: 'Service'
  },
  description: {
    text: 'Description'
  },
  no_dimensions_available: {
    text: 'No layers with a time dimension available.'
  },
  load_all: {
    text: 'Load all'
  },
  play_animation: {
    text: 'Play animation'
  },
  stop: {
    text: 'Stop'
  },
  start: {
    text: 'Start'
  },
  opacity: {
    text: 'Opacity:'
  },
  zoom_to_this_layer: {
    tooltip: 'Zoom to this layer'
  },
  start_or_stop_animation: {
    tooltip: 'Start or stop animation'
  },
  reload_this_layer: {
    tooltip: 'Reload this layer'
  },
  layer_properties: {
    tooltip: 'Layer properties'
  },
  hide_or_display_layer: {
    tooltip: 'Hide or display this layer'
  },
  select_layer_product_from_service: {
    tooltip: 'Select a layer or product from the service'
  },
  change_style_layer: {
    tooltip: 'Change the style of this layer'
  },
  available_styles: {
    text: 'Available styles'
  },
  no_styles_available: {
    text: 'No styles available'
  },
  "default": {
    text: 'Default'
  },
  embed: {
    text: 'Embed'
  },
  time_selection: {
    text: 'Time selection'
  },
  local_time: {
    text: 'Local time'
  },
  year: {
    text: 'Year'
  },
  month: {
    text: 'Month'
  },
  day: {
    text: 'Day'
  },
  hour: {
    text: 'Hour'
  },
  min: {
    text: 'Min'
  },
  select_layer: {
    text: 'Select layer'
  },
  select_dimension: {
    text: 'Select dimension'
  },
  start_at: {
    text: 'Start at'
  },
  number_of_steps: {
    text: 'Number of steps'
  },
  delay_ms: {
    text: 'Delay (ms)'
  },
  enter_wms_version_url: {
    text: 'Enter WMS version 1.1.1 URL here...'
  },
  enter_search_term: {
    text: 'Enter your location here&hellip;'
  },
  not_available_message: {
    text: 'Not available'
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var WMXMLStringToXMLDocument = function WMXMLStringToXMLDocument(xmlString) {
  var xmlData = new DOMParser().parseFromString(xmlString, 'text/xml');
  if (xmlData.documentElement.nodeName === 'parsererror') {
    throw new TypeError("Error while parsing: ".concat(xmlData));
  }
  return xmlData;
};
var WMXMLtoJSON = function WMXMLtoJSON(xmlDocument) {
  // eslint-disable-next-line no-shadow
  var traverse = function traverse(data, path, json) {
    if (data.children && data.children.length) {
      for (var childc = 0; childc < data.children.length; childc += 1) {
        var child = data.children[childc];
        var newPath = "".concat(path, "->").concat(child.nodeName);
        var newJson = null;
        var nodeName = child.nodeName;
        if (json[nodeName]) {
          newJson = {
            attr: {}
          };
          // eslint-disable-next-line no-empty
          if (json[nodeName] instanceof Array) ; else {
            var obj = Object.assign({}, json[nodeName]);
            // eslint-disable-next-line no-param-reassign
            json[nodeName] = [];
            json[nodeName].push(obj);
          }
          json[nodeName].push(newJson);
        } else {
          // eslint-disable-next-line no-param-reassign
          json[nodeName] = {
            attr: {}
          };
          newJson = json[nodeName];
        }
        // Value
        if (child.childNodes && child.childNodes.length > 0) {
          if (child.childNodes[0].nodeValue) {
            var value = child.childNodes[0].nodeValue.trim();
            if (value !== '\n' && value.length > 0) {
              newJson.value = value;
            }
          }
        }
        // Attributes
        if (child.attributes && child.attributes.length > 0) {
          for (var attrc = 0; attrc < child.attributes.length; attrc += 1) {
            newJson.attr[child.attributes[attrc].name] = child.attributes[attrc].value;
          }
        }
        traverse(child, newPath, newJson);
      }
    }
  };
  var json = {};
  traverse(xmlDocument, '', json);
  return json;
};
var WMXMLStringToJson = function WMXMLStringToJson(xmlString) {
  return WMXMLtoJSON(WMXMLStringToXMLDocument(xmlString));
};
var WMXMLParser = function WMXMLParser(url, headers) {
  return new Promise(function (resolve, reject) {
    var fetchHeaders = new Headers();
    if (headers && headers.length > 0) {
      for (var j = 0; j < headers.length; j += 1) {
        fetchHeaders.append(headers[j].name, headers[j].value);
      }
    }
    fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: fetchHeaders
    }).then(function (response) {
      var contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/xml')) {
        return response.text();
      }
      return response.text();
    })["catch"](function (e) {
      return reject(e);
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then(function (data) {
      try {
        var result = WMXMLStringToJson(data);
        return resolve(result);
      } catch (e) {
        return reject(e);
      }
    });
  });
};

var loadGetCapabilitiesViaProxy = function loadGetCapabilitiesViaProxy(url, succes, fail, xml2jsonrequestURL) {
  var getcapreq = "".concat(xml2jsonrequestURL, "request=");
  getcapreq += URLEncode(url);
  try {
    fetch(getcapreq, {}).then(function (result) {
      return result.text();
    }).then(function (result) {
      debugLogger(DebugType.Log, 'loadGetCapabilitiesViaProxy succesfully finished');
      succes(result);
    })["catch"](function () {
      fail("Request failed for ".concat(getcapreq));
    });
  } catch (_a) {
    fail("Request failed for ".concat(getcapreq));
  }
};
var getWMSUrl = function getWMSUrl() {
  var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var additionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getUriAddParam(service, Object.assign({
    service: 'WMS',
    request: 'GetCapabilities'
  }, additionalParams));
};
/**
 * Global getcapabilities function
 */
var WMJSGetCapabilities = function WMJSGetCapabilities(service, succes, fail, options) {
  var disableCache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  /* Make the getCapabilitiesJSONrequest */
  var headers = [];
  if (options && options.headers) {
    headers = options.headers;
  }
  if (!isDefined(service)) {
    fail(I18n.no_service_defined.text);
    return;
  }
  if (service.length === 0) {
    debugLogger(DebugType.Error);
    fail(I18n.service_url_empty.text);
    return;
  }
  /* Allow relative URL's */
  if (service.startsWith('/') && !service.startsWith('//')) {
    var splittedHREF = window.location.href.split('/').filter(function (e) {
      return e.length > 0;
    });
    var hostName = "".concat(splittedHREF[0], "//").concat(splittedHREF[1], "/");
    // eslint-disable-next-line no-param-reassign
    service = hostName + service;
  }
  if (!service.startsWith('http://') && !service.startsWith('https:') && !service.startsWith('//')) {
    debugLogger(DebugType.Error);
    fail(I18n.service_url_empty.text);
    return;
  }
  if (service.indexOf('?') === -1) {
    // eslint-disable-next-line no-param-reassign
    service += '?';
  }
  debugLogger(DebugType.Log);
  var addParams = disableCache ? {
    random: Math.random()
  } : {};
  var url = getWMSUrl(service, addParams);
  WMXMLParser(url, headers).then(function (data) {
    try {
      succes(data);
    } catch (e) {
      debugLogger(DebugType.Error, e.message);
    }
  })["catch"](function () {
    loadGetCapabilitiesViaProxy(url, succes, function () {
      fail("Request failed for ".concat(url));
    }, WMServiceStoreXML2JSONRequest.proxy);
  });
};
var generatedServiceIds = 0;
var generateWMJSServiceId = function generateWMJSServiceId() {
  generatedServiceIds += 1;
  return "serviceid_".concat(generatedServiceIds);
};
/**
 * WMJSService Class
 *
 * options:
 *   service
 *   title (optional)
 */
var WMJSService = /*#__PURE__*/function () {
  function WMJSService(options) {
    _classCallCheck(this, WMJSService);
    this.id = undefined;
    this.service = undefined;
    this.id = generateWMJSServiceId();
    this.service = undefined;
    this.title = undefined;
    this.onlineresource = undefined;
    this["abstract"] = undefined;
    this.version = WMSVersion.version111;
    this.getcapabilitiesDoc = undefined;
    this.busy = false;
    this._flatLayerObject = undefined;
    if (options) {
      this.service = options.service;
      this.title = options.title;
    }
    this.checkVersion111 = this.checkVersion111.bind(this);
    this.checkVersion130 = this.checkVersion130.bind(this);
    this.getCapabilityElement = this.getCapabilityElement.bind(this);
    this.checkVersion = this.checkVersion.bind(this);
    this.getCapabilities = this.getCapabilities.bind(this);
    this.checkException = this.checkException.bind(this);
    this.getNodes = this.getNodes.bind(this);
    this.getLayerObjectsFlat = this.getLayerObjectsFlat.bind(this);
    this.functionCallbackList = [];
  }
  _createClass(WMJSService, [{
    key: "checkVersion111",
    value: function checkVersion111(jsonData) {
      try {
        var rootLayer = jsonData.WMT_MS_Capabilities.Capability.Layer;
        if (!rootLayer) {
          throw new Error('No 111 layer');
        }
      } catch (e) {
        var message = this.checkException(jsonData);
        if (message !== undefined) {
          throw new Error(message);
        }
        if (!jsonData.WMT_MS_Capabilities.Capability) {
          throw new Error(I18n.no_wms_capability_element_found.text);
        }
        if (!jsonData.WMT_MS_Capabilities.Capability.Layer) {
          throw new Error(I18n.no_wms_layer_element_found.text);
        }
      }
    }
  }, {
    key: "checkVersion130",
    value: function checkVersion130(jsonData) {
      try {
        var rootLayer = jsonData.WMS_Capabilities.Capability.Layer;
        if (!rootLayer) {
          throw new Error('No 130 layer');
        }
      } catch (e) {
        var message = this.checkException(jsonData);
        if (message !== undefined) {
          throw new Error(message);
        }
        if (!jsonData.WMS_Capabilities.Capability) {
          throw new Error(I18n.no_wms_capability_element_found.text);
        }
        if (!jsonData.WMS_Capabilities.Capability.Layer) {
          throw new Error(I18n.no_wms_layer_element_found.text);
        }
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getCapabilityElement",
    value: function getCapabilityElement(jsonData) {
      var capabilityObject;
      try {
        capabilityObject = jsonData.WMT_MS_Capabilities.Capability;
      } catch (e) {
        try {
          capabilityObject = jsonData.WMS_Capabilities.Capability;
        } catch (_a) {
          throw new Error(I18n.no_capability_element_found.text);
        }
      }
      return capabilityObject;
    }
  }, {
    key: "checkVersion",
    value: function checkVersion(jsonData) {
      var version = null;
      try {
        if (WMSVersion.version100 === jsonData.WMT_MS_Capabilities.attr.version) {
          version = WMSVersion.version100;
        }
        if (WMSVersion.version111 === jsonData.WMT_MS_Capabilities.attr.version) {
          version = WMSVersion.version111;
        }
        if (WMSVersion.version130 === jsonData.WMT_MS_Capabilities.attr.version) {
          version = WMSVersion.version130;
        }
      } catch (e) {
        try {
          if (WMSVersion.version100 === jsonData.WMS_Capabilities.attr.version) {
            version = WMSVersion.version100;
          }
          if (WMSVersion.version111 === jsonData.WMS_Capabilities.attr.version) {
            version = WMSVersion.version111;
          }
          if (WMSVersion.version130 === jsonData.WMS_Capabilities.attr.version) {
            version = WMSVersion.version130;
          }
        } catch (_a) {
          var message = this.checkException(jsonData);
          if (message) {
            throw new Error(message);
          } else {
            throw new Error('Unable to determine WMS version');
          }
        }
      }
      if (version === WMSVersion.version111) {
        this.checkVersion111(jsonData);
        return version;
      }
      if (version === WMSVersion.version130) {
        this.checkVersion130(jsonData);
        return version;
      }
      return WMSVersion.version111;
    }
    /**
     * Does getcapabilities for a service.
     * When multple getCapabilities for the same service are made,
     * this method makes one get request and fires all callbacks with the same result.
     * @param succescallback Function called upon succes, cannot be left blank
     * @param failcallback Function called upon failure, cannot be left blank
     */
  }, {
    key: "getCapabilities",
    value: function getCapabilities(succescallback, failcallback, forceReload,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    options) {
      var _this = this;
      if (options) {
        this._options = options;
      }
      if (this.busy) {
        var cf = {
          callback: succescallback,
          fail: failcallback
        };
        this.functionCallbackList.push(cf);
        return;
      }
      this._flatLayerObject = undefined;
      if (!this.getcapabilitiesDoc || forceReload === true) {
        this.busy = true;
        var _cf = {
          callback: succescallback,
          fail: failcallback
        };
        this.functionCallbackList.push(_cf);
        /* Fail functions */
        var fail = function fail(jsonData) {
          _this.busy = false;
          var current;
          while (current = _this.functionCallbackList.pop()) {
            current.fail(jsonData);
          }
        };
        /* Success functions */
        var succes = function succes(jsonData) {
          _this.busy = false;
          _this.getcapabilitiesDoc = jsonData;
          try {
            _this.version = _this.checkVersion(jsonData);
          } catch (e) {
            fail(e.message);
            return;
          }
          var WMSCapabilities = jsonData.WMS_Capabilities;
          if (!WMSCapabilities) {
            WMSCapabilities = jsonData.WMT_MS_Capabilities;
          }
          // Get Abstract
          try {
            _this["abstract"] = WMSCapabilities.Service.Abstract.value;
          } catch (e) {
            _this["abstract"] = I18n.not_available_message.text;
          }
          // Get Title
          try {
            _this.title = WMSCapabilities.Service.Title.value;
          } catch (e) {
            _this.title = I18n.not_available_message.text;
          }
          // Get OnlineResource
          try {
            if (WMSCapabilities.Service.OnlineResource.value) {
              _this.onlineresource = WMSCapabilities.Service.OnlineResource.value;
            } else {
              _this.onlineresource =
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              WMSCapabilities.Service.OnlineResource.attr['xlink:href'];
            }
          } catch (e) {
            _this.onlineresource = I18n.not_available_message.text;
          }
          // Fill in flatlayer object
          _this.getLayerObjectsFlat(function () {
            return null;
          }, function () {
            return null;
          }, false, options);
          var current;
          while (current = _this.functionCallbackList.pop()) {
            current.callback(jsonData);
          }
        };
        WMJSGetCapabilities(this.service, succes, fail, options);
      } else {
        succescallback(this.getcapabilitiesDoc);
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "checkException",
    value: function checkException(jsonData) {
      try {
        if (jsonData.ServiceExceptionReport) {
          var code;
          var value;
          var se = jsonData.ServiceExceptionReport.ServiceException;
          if (se) {
            try {
              if (se.attr.code) {
                code = se.attr.code;
              }
            } catch (e) {
              // do nothing
            }
            if (se.value) {
              value = se.value;
              return "Exception: ".concat(code, ".\n").concat(value);
            }
          }
          return I18n.wms_service_exception_code.text + code;
        }
      } catch (e) {
        // do nothing
      }
      return undefined;
    }
    /**
     * Calls succes with a hierarchical node structure
     * Calls failure with a string when someting goes wrong
     */
  }, {
    key: "getNodes",
    value: function getNodes(succes, failure, forceReload, options) {
      var _this2 = this;
      if (!failure) {
        // eslint-disable-next-line no-param-reassign
        failure = function failure(msg) {
          debugLogger(DebugType.Error);
        };
      }
      var parse = function parse(jsonData) {
        var rootLayer = _this2.getCapabilityElement(jsonData).Layer;
        try {
          _this2.version = _this2.checkVersion(jsonData);
        } catch (e) {
          failure(e.message);
          return;
        }
        var layerTreeStructure = buildLayerTreeFromNestedWMSLayer(rootLayer);
        succes(layerTreeStructure);
      };
      var callback = function callback(jsonData) {
        parse(jsonData);
      };
      var fail = function fail(data) {
        failure(data);
      };
      this.getCapabilities(callback, fail, forceReload, options);
    }
    /** Calls succes with an array of all layerobjects
     * Calls failure when something goes wrong
     */
  }, {
    key: "getLayerObjectsFlat",
    value: function getLayerObjectsFlat(succes, failure, forceReload) {
      var _this3 = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._options;
      if (isDefined(this._flatLayerObject) && forceReload !== true) {
        succes(this._flatLayerObject);
        return;
      }
      var callback = function callback(layerTree) {
        _this3._flatLayerObject = flattenLayerTree(layerTree);
        succes(_this3._flatLayerObject);
      };
      this.getNodes(callback, failure, forceReload, options);
    }
  }]);
  return WMJSService;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var WMGetServiceFromStore = function WMGetServiceFromStore(serviceName) {
  for (var j = 0; j < WMServiceStore.length; j += 1) {
    if (WMServiceStore[j].service === serviceName) {
      return WMServiceStore[j];
    }
  }
  var service = new WMJSService({
    service: serviceName
  });
  WMServiceStore.push(service);
  return service;
};

var LayerType;
(function (LayerType) {
  LayerType["mapLayer"] = "mapLayer";
  LayerType["baseLayer"] = "baseLayer";
  LayerType["overLayer"] = "overLayer";
  LayerType["featureLayer"] = "featureLayer";
})(LayerType || (LayerType = {}));
/**
 * Helper function to figure out the dimensions from the WMS layer object (From WMS GetCapabilities). Parses both WMS 1.1.1 and WMS 1.3.0.
 * @param layerObjectFromWMS The corresponding layer object from the WMS GetCapabilities.
 * @param layer THe WMLayer to configure
 * @param layerDimNamesToRemove A set of dimensions names which are flagged for removal, this function removes the dimension from the set if found in the layer.
 */
var addDimsForLayer = function addDimsForLayer(layerProps, layer, layerDimNamesToRemove) {
  var _a;
  /* Loop through all the dims from the WMS GetCapabilities document for this layer */
  (_a = layerProps.dimensions) === null || _a === void 0 ? void 0 : _a.forEach(function (layerDimension) {
    /* Obtain layerDim info from the GetCapabilities document and put into a WMSLayerDimInfo object  */
    var dimName = (layerDimension.name || '').toLowerCase();
    var layerDim = {
      name: dimName,
      units: layerDimension.units || '',
      unitSymbol: layerDimension.unitSymbol || '',
      value: layerDimension.values || '',
      "default": layerDimension.currentValue,
      /* If presets with other dimensions, like elevation, cause
      problems, try to add the dimension here */
      linkDimensionToMap: dimName !== 'reference_time' && dimName !== 'interval_start' && dimName !== 'interval_end'
    };
    /* Flag that this dim should not be removed from the layer */
    layerDimNamesToRemove["delete"](layerDim.name);
    /* Now configure the dimensions in the Layer based on the obtained info */
    var wmLayerDimensionIndex = layer.dimensions.findIndex(function (dim) {
      return dim.name === layerDim.name;
    });
    /* Index === -1: Dimension was not found */
    if (wmLayerDimensionIndex === -1) {
      /* Add a new dimension for this layer */
      var dimension = new WMJSDimension({
        name: layerDim.name,
        units: layerDim.units,
        values: layerDim.value,
        currentValue: layerDim["default"],
        defaultValue: layerDim["default"],
        linked: layerDim.linkDimensionToMap,
        unitSymbol: layerDim.unitSymbol
      });
      /* Check if the dimension should take the value from the map */
      if (layer.parentMap) {
        var mapDim = layer.parentMap.getDimension(layerDim.name);
        if (mapDim && mapDim.linked && isDefined(mapDim.currentValue)) {
          var dimensionCurrentValue = dimension.getClosestValue(mapDim.currentValue);
          dimension.setValue(dimensionCurrentValue);
        }
      }
      layer.dimensions.push(dimension);
    } else {
      /* Dimension already exists, keep its current value but update the rest of its properties */
      var dimensionToUpdate = layer.dimensions[wmLayerDimensionIndex];
      var currentValue = dimensionToUpdate.getValue();
      dimensionToUpdate.values = layerDim.value;
      dimensionToUpdate.name = layerDim.name;
      dimensionToUpdate.units = layerDim.units;
      dimensionToUpdate.unitSymbol = layerDim.unitSymbol;
      dimensionToUpdate.reInitializeValues(dimensionToUpdate.values);
      dimensionToUpdate.setClosestValue(currentValue);
    }
  });
};
/**
 * Helper function to configure the WMS Styles from the WMS GetCapabilities document.
 * @param nestedLayerPath Array of WMS Layers from `[Root WMS Layer] => [Parent(s) WMS Layer] => [This WMS layer]`.
 * @param wmLayer The WMLayer object to configure
 */
var configureStyles = function configureStyles(layerProps, wmLayer) {
  // eslint-disable-next-line no-param-reassign
  wmLayer.styles = layerProps.styles || [];
  /* Set the default style */
  if (wmLayer.styles.length > 0) {
    /* Check if the current style is in the list */
    var styleIndex = wmLayer.styles.findIndex(function (style) {
      return style.name === wmLayer.currentStyle;
    });
    /* If not found or not set, set the first one */
    if (styleIndex === -1) {
      wmLayer.setStyle(wmLayer.styles[0].name);
    } else {
      /* Otherwise set it */
      wmLayer.setStyle(wmLayer.styles[styleIndex].name);
    }
  }
};
/**
 * Helper function to configure the dimensions for this layer from the WMS GetCapabilities document.
 * @param nestedLayerPath Array of WMS Layers from `[Root WMS Layer] => [Parent(s) WMS Layer] => [This WMS layer]`.
 * @param wmLayer The WMLayer object to configure
 */
var configureDimensions = function configureDimensions(layerProps, wmLayer) {
  /*
  WMS 1.1.1:
    <Dimension name="time" units="ISO8601"/>
    <Extent name="time" default="2021-05-14T10:35:00Z" multipleValues="1" nearestValue="0">2021-03-31T09:25:00Z/2021-05-14T10:35:00Z/PT5M</Extent>
     WMS 1.3.0:
    <Dimension name="time" units="ISO8601" default="2021-05-14T07:35:00Z" multipleValues="1" nearestValue="0" current="1">2021-03-31T09:25:00Z/2021-05-14T07:35:00Z/PT5M</Dimension>
  */
  /* Flag dimensions which are currently in use for this layer, it is possible that the update will remove dimensions from this layer; keep track of the current ones */
  var layerDimNamesToRemove = new Set();
  for (var d = 0; d < wmLayer.dimensions.length; d += 1) {
    layerDimNamesToRemove.add(wmLayer.dimensions[d].name);
  }
  /* Now start adding all dimensions starting with the parent layer. Layers more deeply nested will inherit Dimension info */
  addDimsForLayer(layerProps, wmLayer, layerDimNamesToRemove);
  /* The list with dimensions to remove is now complete, remove the unneeded dimensions from the layer */
  layerDimNamesToRemove.forEach(function (dimName) {
    var dimIndex = wmLayer.dimensions.findIndex(function (dim) {
      return dim.name === dimName;
    });
    if (dimIndex !== -1) {
      wmLayer.dimensions.splice(dimIndex, 1);
    }
  });
  /* Handle reference time dim */
  var refTimeDimension = wmLayer.getDimension('reference_time');
  if (refTimeDimension) {
    wmLayer.handleReferenceTime('reference_time', refTimeDimension.getValue());
  }
  if (wmLayer.parentMap) {
    wmLayer.parentMap.configureMapDimensions(wmLayer);
  }
};
var configureGeographicBoundingBox = function configureGeographicBoundingBox(layerProps, wmLayer) {
  var bbox = layerProps.geographicBoundingBox;
  if (bbox) {
    // eslint-disable-next-line no-param-reassign
    wmLayer.geographicBoundingBox = bbox;
  }
};
var WMLayer = /*#__PURE__*/function () {
  function WMLayer(options) {
    var _this = this;
    _classCallCheck(this, WMLayer);
    var _a;
    this.init = this.init.bind(this);
    this.getLayerName = this.getLayerName.bind(this);
    this.toggleAutoUpdate = this.toggleAutoUpdate.bind(this);
    this.setAutoUpdate = this.setAutoUpdate.bind(this);
    this.setOpacity = this.setOpacity.bind(this);
    this.getOpacity = this.getOpacity.bind(this);
    this.remove = this.remove.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.zoomToLayer = this.zoomToLayer.bind(this);
    this.draw = this.draw.bind(this);
    this.handleReferenceTime = this.handleReferenceTime.bind(this);
    this.setDimension = this.setDimension.bind(this);
    this.parseLayer = this.parseLayer.bind(this);
    this.__parseGetCapForLayer = this.__parseGetCapForLayer.bind(this);
    this.parseLayerPromise = this.parseLayerPromise.bind(this);
    this.cloneLayer = this.cloneLayer.bind(this);
    this.setName = this.setName.bind(this);
    this.setStyle = this.setStyle.bind(this);
    this.getStyles = this.getStyles.bind(this);
    this.getStyleObject = this.getStyleObject.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.getDimension = this.getDimension.bind(this);
    this.getProjection = this.getProjection.bind(this);
    this.getCRS = this.getCRS.bind(this);
    this.getCRSByName = this.getCRSByName.bind(this);
    this.setSLDURL = this.setSLDURL.bind(this);
    this.display = this.display.bind(this);
    this.getDimensions = this.getDimensions.bind(this);
    this.init();
    this._options = options;
    this.sldURL = null;
    this.headers = [];
    if (options) {
      this.service = options.service;
      this.getmapURL = options.service;
      this.getfeatureinfoURL = options.service;
      this.getlegendgraphicURL = options.service;
      if (options.active === true) {
        this.active = true;
      } else {
        this.active = false;
      }
      this.name = options.name;
      if (options.getgraphinfoURL) {
        this.getgraphinfoURL = options.getgraphinfoURL;
      }
      if (options.style) {
        this.currentStyle = options.style;
      }
      if (options.currentStyle) {
        this.currentStyle = options.currentStyle;
      }
      if (options.sldURL) {
        this.sldURL = options.sldURL;
      }
      if (options.id) {
        this.id = options.id;
      }
      if (options.format) {
        this.format = options.format;
      } else {
        this.format = 'image/png';
      }
      if (isDefined(options.opacity)) {
        this.opacity = options.opacity;
      }
      if (options.title) {
        this.title = options.title;
      }
      this["abstract"] = I18n.not_available_message.text;
      if (options.enabled === false) {
        this.enabled = false;
      }
      if (options.keepOnTop === true) {
        this.keepOnTop = true;
      }
      if (options.transparent === false) {
        this.transparent = false;
      }
      if ((_a = options.dimensions) === null || _a === void 0 ? void 0 : _a.length) {
        options.dimensions.forEach(function (dimension) {
          _this.dimensions.push(new WMJSDimension(dimension));
        });
      }
      if (isDefined(options.onReady)) {
        this.onReady = options.onReady;
      }
      if (isDefined(options.type)) {
        this.type = options.type;
      }
      if (options.parentMap) {
        this.parentMap = options.parentMap;
      }
      if (options.headers) {
        this.headers = options.headers;
      }
      if (options.geojson) {
        this.geojson = options.geojson;
      }
    }
  }
  _createClass(WMLayer, [{
    key: "init",
    value: function init() {
      this.autoupdate = false;
      this.timer = undefined;
      this.service = undefined; // URL of the WMS Service
      this.getmapURL = undefined;
      this.getfeatureinfoURL = undefined;
      this.getlegendgraphicURL = undefined;
      this.keepOnTop = false;
      this.transparent = true;
      this.hasError = false;
      this.legendIsDimensionDependent = true;
      this.wms130bboxcompatibilitymode = false;
      this.version = WMSVersion.version111;
      this.path = '';
      this.type = 'wms';
      this.wmsextensions = {
        url: '',
        colorscalerange: []
      };
      this.name = undefined;
      this.title = WMEmptyLayerTitle;
      this["abstract"] = undefined;
      this.dimensions = []; // Array of Dimension
      this.legendGraphic = '';
      this.projectionProperties = []; // Array of WMProjections
      this.queryable = false;
      this.enabled = true;
      this.styles = [];
      this.currentStyle = '';
      this.id = '-1';
      this.opacity = 1.0; // Ranges from 0.0-1.0
      this.serviceTitle = 'not defined';
      this.parentMap = null;
      this.sldURL = null;
      this.isConfigured = false;
    }
  }, {
    key: "getLayerName",
    value: function getLayerName() {
      return this.name;
    }
  }, {
    key: "toggleAutoUpdate",
    value: function toggleAutoUpdate() {
      var _this2 = this;
      this.autoupdate = !this.autoupdate;
      if (this.autoupdate) {
        var numDeltaMS = 60000;
        this.timer = setInterval(function () {
          _this2.parseLayer(undefined, true, 'WMLayer toggleAutoUpdate');
        }, numDeltaMS);
      } else {
        clearInterval(this.timer);
      }
    }
  }, {
    key: "setAutoUpdate",
    value: function setAutoUpdate(val, interval, callback) {
      var _this3 = this;
      if (val !== this.autoupdate) {
        this.autoupdate = val;
        if (!val) {
          clearInterval(this.timer);
        } else {
          this.timer = setInterval(function () {
            _this3.parseLayer(callback, true, 'WMLayer setAutoUpdate');
          }, interval);
        }
      }
    }
  }, {
    key: "setOpacity",
    value: function setOpacity(opacityValue) {
      this.opacity = opacityValue;
      this.parentMap && this.parentMap.redrawBuffer();
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      return this.opacity;
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.parentMap) {
        this.parentMap.deleteLayer(this);
        this.parentMap.draw('WMLayer::remove');
      }
      clearInterval(this.timer);
    }
  }, {
    key: "moveUp",
    value: function moveUp() {
      if (this.parentMap) {
        this.parentMap.moveLayerUp(this);
        this.parentMap.draw('WMLayer::moveUp');
      }
    }
  }, {
    key: "moveDown",
    value: function moveDown() {
      if (this.parentMap) {
        this.parentMap.moveLayerDown(this);
        this.parentMap.draw('WMLayer::moveDown');
      }
    }
  }, {
    key: "zoomToLayer",
    value: function zoomToLayer() {
      if (this.parentMap) {
        this.parentMap.zoomToLayer(this);
      }
    }
  }, {
    key: "draw",
    value: function draw(e) {
      if (this.parentMap) {
        this.parentMap.draw("WMLayer::draw::".concat(e));
      }
    }
  }, {
    key: "handleReferenceTime",
    value: function handleReferenceTime(name, value) {
      var updateMapDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (name !== 'reference_time') {
        return;
      }
      var timeDim = this.getDimension('time');
      var referenceTimeDim = this.getDimension(name);
      if (timeDim) {
        timeDim.setTimeValuesForReferenceTime(value, referenceTimeDim);
        if (updateMapDimensions && this.parentMap && this.enabled !== false) {
          this.parentMap.getListener().triggerEvent('ondimchange', 'time');
        }
      }
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return this.dimensions;
    }
  }, {
    key: "setDimension",
    value: function setDimension(name, value) {
      var updateMapDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!isDefined(value)) {
        return;
      }
      var dim = this.getDimension(name);
      if (!dim) {
        return;
      }
      dim.setValue(value);
      this.handleReferenceTime(name, value, updateMapDimensions);
      if (updateMapDimensions && dim.linked === true && this.parentMap) {
        this.parentMap.setDimension(name, dim.getValue());
      }
    }
  }, {
    key: "__parseGetCapForLayer",
    value: function __parseGetCapForLayer(getcapabilitiesjson, layerDoneCallback, fail) {
      var _this4 = this;
      if (!getcapabilitiesjson) {
        this.title = I18n.service_has_error.text;
        this["abstract"] = I18n.not_available_message.text;
        fail(this, I18n.unable_to_connect_server.text);
        return;
      }
      var wmjsService = WMGetServiceFromStore(this.service);
      // Get the capability object
      var capabilityObject;
      try {
        capabilityObject = wmjsService.getCapabilityElement(getcapabilitiesjson);
      } catch (_a) {
        fail(this, 'No capability element in service');
        return;
      }
      this.version = wmjsService.version;
      // Get the rootLayer
      var rootLayer = capabilityObject.Layer;
      if (!isDefined(rootLayer)) {
        fail(this, 'No Layer element in service');
        return;
      }
      try {
        this.serviceTitle = rootLayer.Title.value;
      } catch (e) {
        this.serviceTitle = 'Unnamed service';
      }
      this.optimalFormat = 'image/png';
      // Get the optimal image format for this layer
      try {
        var serverFormats = capabilityObject.Request.GetMap.Format;
        for (var f = 0; f < serverFormats.length; f += 1) {
          if (serverFormats[f].value.indexOf('24') > 0) {
            this.optimalFormat = serverFormats[f].value;
          }
          if (serverFormats[f].value.indexOf('32') > 0) {
            this.optimalFormat = serverFormats[f].value;
          }
        }
      } catch (e) {
        debugLogger(DebugType.Error);
      }
      if (this.name === undefined || this.name.length < 1) {
        this.title = WMEmptyLayerTitle;
        this["abstract"] = I18n.not_available_message.text;
        layerDoneCallback(this);
        return;
      }
      this.getmapURL = undefined;
      try {
        this.getmapURL = capabilityObject.Request.GetMap.DCPType.HTTP.Get.OnlineResource.attr['xlink:href'];
      } catch (e) {
        /* Do nothing */
      }
      if (!isDefined(this.getmapURL)) {
        this.getmapURL = this.service;
        debugLogger(DebugType.Error);
      }
      this.getfeatureinfoURL = undefined;
      try {
        this.getfeatureinfoURL = capabilityObject.Request.GetFeatureInfo.DCPType.HTTP.Get.OnlineResource.attr['xlink:href'];
      } catch (e) {
        /* Do nothing */
      }
      if (!isDefined(this.getfeatureinfoURL)) {
        this.getfeatureinfoURL = this.service;
        debugLogger(DebugType.Error);
      }
      this.getlegendgraphicURL = undefined;
      try {
        this.getlegendgraphicURL = capabilityObject.Request.GetLegendGraphic.DCPType.HTTP.Get.OnlineResource.attr['xlink:href'];
      } catch (e) {
        /* Do nothing */
      }
      if (!isDefined(this.getlegendgraphicURL)) {
        this.getlegendgraphicURL = this.service;
      }
      // TODO Should be arranged also for the other services:
      this.getmapURL = WMJScheckURL(this.getmapURL);
      this.getfeatureinfoURL = WMJScheckURL(this.getfeatureinfoURL);
      this.getlegendgraphicURL = WMJScheckURL(this.getlegendgraphicURL);
      this.styles = [];
      this.projectionProperties = [];
      /* Set default to layer name, try to find details in next steps */
      this.title = this.name;
      this["abstract"] = '';
      this.path = '';
      // Function will be called when the layer with the right name is found in the getcap doc
      var populateLayerFromTreeElement = function populateLayerFromTreeElement(jsonlayer) {
        _this4.title = jsonlayer.title || jsonlayer.name || '';
        _this4["abstract"] = jsonlayer["abstract"] || I18n.not_available_message.text;
        _this4.path = jsonlayer.path.join('/');
        /** ***************** Go through styles **************** */
        configureStyles(jsonlayer, _this4);
        /** ***************** Go through Dimensions **************** */
        configureDimensions(jsonlayer, _this4);
        /** ***************** Go through geographicBoundingBox **************** */
        configureGeographicBoundingBox(jsonlayer, _this4);
        _this4.queryable = jsonlayer.queryable || false;
        if (jsonlayer.crs) {
          jsonlayer.crs.forEach(function (p) {
            var wmProjection = new WMProjection();
            wmProjection.srs = p.name || '';
            if (p.bbox) {
              var swapBBOX = _this4.version === WMSVersion.version130 && wmProjection.srs === 'EPSG:4326' && _this4.wms130bboxcompatibilitymode === false;
              if (swapBBOX) {
                wmProjection.bbox.setBBOX(p.bbox.bottom, p.bbox.left, p.bbox.top, p.bbox.right);
              } else {
                wmProjection.bbox.setBBOX(p.bbox.left, p.bbox.bottom, p.bbox.right, p.bbox.top);
              }
            }
            _this4.projectionProperties.push(wmProjection);
          });
        }
      };
      var layerTreeStructure = buildLayerTreeFromNestedWMSLayer(rootLayer);
      /* Recursively walk the layertree until a child is found with the corresponding name */
      var findTreeNode = function findTreeNode(tree) {
        if (tree.name === _this4.name) {
          return tree;
        }
        if (tree.children) {
          var foundChild;
          tree.children.find(function (node) {
            foundChild = findTreeNode(node);
            return foundChild;
          });
          return foundChild;
        }
        return undefined;
      };
      var foundLayer = findTreeNode(layerTreeStructure);
      if (!foundLayer) {
        /* Layer was not found... */
        var message = '';
        if (this.name) {
          message = "Unable to find layer '".concat(this.name, "' in service '").concat(this.service, "'");
        } else {
          message = "Unable to find layer '".concat(this.title, "' in service '").concat(this.service, "'");
        }
        this.title = '--- layer not found in service ---';
        this["abstract"] = I18n.not_available_message.text;
        fail(this, message);
        return;
      }
      /* Layer was found */
      populateLayerFromTreeElement(foundLayer);
      if (this.onReady) {
        this.onReady(this);
      }
      this.isConfigured = true;
      layerDoneCallback(this);
    }
    /**
     * Calls success with a configured layer object
     * Calls options.failure with error message.
     * Throws string exceptions when someting goes wrong
     */
  }, {
    key: "parseLayer",
    value: function parseLayer(_layerDoneCallback, forceReload,
    // eslint-disable-next-line no-unused-vars
    origin) {
      var _this5 = this;
      this.hasError = false;
      var layerDoneCallback = function layerDoneCallback(__layer) {
        if (isDefined(_layerDoneCallback)) {
          try {
            _layerDoneCallback(__layer);
          } catch (e) {
            debugLogger(DebugType.Error, e.message);
          }
        }
      };
      var fail = function fail(_layer, message) {
        _this5.hasError = true;
        _this5.lastError = message;
        _this5.title = I18n.service_has_error.text;
        layerDoneCallback(_layer);
        if (isDefined(_this5._options.failure)) {
          _this5._options.failure(_layer, message);
        }
      };
      var callback = function callback(data) {
        _this5.__parseGetCapForLayer(data, layerDoneCallback, fail);
      };
      var requestfail = function requestfail() {
        fail(_this5, I18n.no_capability_element_found.text);
      };
      var options = {
        headers: {}
      };
      if (this.headers && this.headers.length > 0) {
        options.headers = this.headers;
      }
      var wmjsService = WMGetServiceFromStore(this.service);
      if (wmjsService.service !== undefined) {
        wmjsService.getCapabilities(function (data) {
          callback(data);
        }, requestfail, forceReload, options);
      }
    }
    /**
     * A Promise to parse the layer, it will fetch the WMS GetCapabilities document, configure the layer and resolve to a WMLayer object
     * @param forceReload Do not use the cache of the WMS GetCapabilties document, but instead fetch new data from the server
     * @returns WMLayer object
     */
  }, {
    key: "parseLayerPromise",
    value: function parseLayerPromise() {
      var _this6 = this;
      var forceReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (resolve, reject) {
        _this6.parseLayer(function (layer) {
          if (layer.hasError === true) {
            debugLogger(DebugType.Error, "[ERROR] Parse layer failed, Reason [".concat(layer.lastError, "]"));
            reject(layer);
          } else {
            resolve(layer);
          }
        }, forceReload, 'WMLayer parseLayerPromise');
      });
    }
  }, {
    key: "cloneLayer",
    value: function cloneLayer() {
      return new WMLayer(this._options);
    }
    /**
     * Set or change the name of this layer. This involves re-parsing the WMS GetCapabilities document and updating the affected layer properties. When done, it resolves the WMLayer
     * @param name The name of the layer
     * @returns Promise resolving to a WMLayer object
     */
  }, {
    key: "setName",
    value: function setName(name) {
      this.name = name;
      return this.parseLayerPromise(false);
    }
    /**
     * Sets the style by its name
     * @param style: The name of the style (not the object)
     */
  }, {
    key: "setStyle",
    value: function setStyle(styleName) {
      debugLogger(DebugType.Log);
      if (!this.styles || this.styles.length === 0) {
        this.currentStyle = '';
        this.legendGraphic = '';
        debugLogger(DebugType.Log);
        return;
      }
      var styleFound = false;
      for (var j = 0; j < this.styles.length; j += 1) {
        if (this.styles[j].name === styleName) {
          this.legendGraphic = this.styles[j].legendURL;
          this.currentStyle = this.styles[j].name;
          styleFound = true;
        }
      }
      if (!styleFound) {
        debugLogger(DebugType.Log, "WMLayer::setStyle: Style ".concat(styleName, " not found, setting style ").concat(this.styles[0].name));
        this.currentStyle = this.styles[0].name;
        this.legendGraphic = this.styles[0].legendURL;
      }
      /* Check if this legenURL has already a Layer Property set. If so set the Layer to the name of this layer */
      this.legendGraphic = getUriWithParam(this.legendGraphic);
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      if (this.styles) {
        return this.styles;
      }
      return [];
    }
    /**
     * Get the styleobject by name
     * @param styleName The name of the style
     * @param nextPrev, can be -1 or +1 to get the next or previous style object in circular manner.
     */
  }, {
    key: "getStyleObject",
    value: function getStyleObject(styleName, nextPrev) {
      if (isDefined(this.styles) === false) {
        return undefined;
      }
      for (var j = 0; j < this.styles.length; j += 1) {
        if (this.styles[j].name === styleName) {
          if (nextPrev === -1) {
            j -= 1;
          }
          if (nextPrev === 1) {
            j += 1;
          }
          if (j < 0) {
            j = this.styles.length - 1;
          }
          if (j > this.styles.length - 1) {
            j = 0;
          }
          return this.styles[j];
        }
      }
      return undefined;
    }
    /*
     *Get the current stylename as used in the getmap request
     */
  }, {
    key: "getStyle",
    value: function getStyle() {
      return this.currentStyle;
    }
  }, {
    key: "getDimension",
    value: function getDimension(name) {
      return this.dimensions.find(function (dim) {
        return dim.name === name;
      });
    }
    /**
     * Returns the Coordinate Reference Systems for this layer
     * @returns List of WMProjection objects
     */
  }, {
    key: "getCRS",
    value: function getCRS() {
      var crs = [];
      for (var j = 0; j < this.projectionProperties.length; j += 1) {
        var projectionProperty = this.projectionProperties[j];
        if (projectionProperty) {
          var bbox = projectionProperty.bbox;
          if (bbox) {
            crs.push({
              srs: "".concat(projectionProperty.srs),
              bbox: new WMBBOX(bbox.left, bbox.bottom, bbox.right, bbox.top)
            });
          }
        }
      }
      return crs;
    }
    /**
     * Get Coordinate reference system by name
     *
     * @param srsName Name of the coordinate reference system to get
     * @returns A WMProjection object if found, otherwise undefined.
     */
  }, {
    key: "getCRSByName",
    value: function getCRSByName(srsName) {
      for (var j = 0; j < this.projectionProperties.length; j += 1) {
        if (this.projectionProperties[j].srs === srsName) {
          var returnSRS = {
            srs: '',
            bbox: new WMBBOX(undefined, undefined, undefined, undefined)
          };
          returnSRS.srs = "".concat(this.projectionProperties[j].srs);
          returnSRS.bbox = new WMBBOX(this.projectionProperties[j].bbox.left, this.projectionProperties[j].bbox.bottom, this.projectionProperties[j].bbox.right, this.projectionProperties[j].bbox.top);
          return returnSRS;
        }
      }
      return undefined;
    }
    /**
     * Get Coordinate reference system by name. Note 2021-05-17: It is more inline with other function names to use the getCRSByName function instead.
     *
     * @param srsName Name of the coordinate reference system to get
     * @returns A WMProjection object if found, otherwise undefined.
     */
  }, {
    key: "getProjection",
    value: function getProjection(srsName) {
      return this.getCRSByName(srsName);
    }
  }, {
    key: "setSLDURL",
    value: function setSLDURL(url) {
      this.sldURL = url;
    }
  }, {
    key: "display",
    value: function display(displayornot) {
      this.enabled = displayornot;
      if (this.parentMap) {
        this.parentMap.displayLayer(this, this.enabled);
      }
    }
  }]);
  return WMLayer;
}();

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * */
var generatedLayerIds = 0;
var generateLayerId = function generateLayerId() {
  generatedLayerIds += 1;
  return "layerid_".concat(generatedLayerIds);
};
var generatedMapIds = 0;
var generateMapId = function generateMapId() {
  generatedMapIds += 1;
  return "mapid_".concat(generatedMapIds);
};
var generatedTimesliderIds = 0;
var generateTimesliderId = function generateTimesliderId() {
  generatedTimesliderIds += 1;
  return "timesliderid_".concat(generatedTimesliderIds);
};
/**
 * Map for registering wmlayers with their id's
 */
var registeredWMLayersForReactLayerId = {};
/**
 * Registers a WMJSLayer in a lookuptable with a layerId
 * @param {WMLayer} wmLayer
 * @param {string} layerId
 */
var registerWMLayer = function registerWMLayer(wmLayer, layerId) {
  registeredWMLayersForReactLayerId[layerId] = wmLayer;
};
/**
 * Get the WMLayer from the lookuptable with layerId
 * @param {string} layerId
 */
var getWMLayerById = function getWMLayerById(layerId) {
  return registeredWMLayersForReactLayerId[layerId];
};
var unRegisterWMJSLayer = function unRegisterWMJSLayer(layerId) {
  var layer = registeredWMLayersForReactLayerId[layerId];
  if (layer) {
    delete registeredWMLayersForReactLayerId[layerId];
  }
};
var unRegisterAllWMJSLayersAndMaps = function unRegisterAllWMJSLayersAndMaps() {
  var allLayerIds = Object.keys(registeredWMLayersForReactLayerId);
  allLayerIds.forEach(function (layerId) {
    unRegisterWMJSLayer(layerId);
  });
  var allMapIds = Object.keys(registeredWMMapForReactMapId);
  allMapIds.forEach(function (mapId) {
    unRegisterWMJSMap(mapId);
  });
};
/**
 * Map for registering wmlayers with their id's
 */
var registeredWMMapForReactMapId = {};
/**
 * Registers a WMJSMap in a lookuptable with a wmjsMapId
 * @param {WMJSMap} wmjsMap
 * @param {string} wmjsMapId
 */
var registerWMJSMap = function registerWMJSMap(wmjsMap, wmjsMapId) {
  if (registeredWMMapForReactMapId[wmjsMapId]) {
    console.warn("Map with id ".concat(wmjsMapId, " already made"));
  }
  registeredWMMapForReactMapId[wmjsMapId] = wmjsMap;
};
var unRegisterWMJSMap = function unRegisterWMJSMap(wmjsMapId) {
  var wmjsMap = registeredWMMapForReactMapId[wmjsMapId];
  if (wmjsMap) {
    wmjsMap.getListener().suspendEvents();
    try {
      wmjsMap.stopAnimating && wmjsMap.stopAnimating();
    } catch (e) {
      console.warn(e);
    }
    Object.keys(registeredWMLayersForReactLayerId).forEach(function (layerId) {
      var wmLayer = getWMLayerById(layerId);
      if (wmLayer.parentMap === wmjsMap) {
        unRegisterWMJSLayer(layerId);
      }
    });
    wmjsMap.destroy();
    delete registeredWMMapForReactMapId[wmjsMapId];
  }
};
/**
 * Get the wmjsMap from the lookuptable with wmjsMapId
 * @param {string} wmjsMapId
 */
var getWMJSMapById = function getWMJSMapById(wmjsMapId) {
  return registeredWMMapForReactMapId[wmjsMapId];
};
/**
 * Get all wmjsMap id's from the lookuptable with wmjsMapId
 * @param {string} wmjsMapId
 */
var getWMJSMapIds = function getWMJSMapIds() {
  return Object.keys(registeredWMMapForReactMapId);
};
/**
 * Returns the WMJSDimension object for given layerId and dimension name
 * @param layerId The layerId
 * @param dimensionName The dimension to lookup
 */
var getWMJSDimensionForLayerAndDimension = function getWMJSDimensionForLayerAndDimension(layerId, dimensionName) {
  var wmLayer = getWMLayerById(layerId);
  if (!wmLayer || !dimensionName) {
    return undefined;
  }
  var wmjsDimension = wmLayer.getDimension(dimensionName);
  if (!wmjsDimension) {
    return undefined;
  }
  return wmjsDimension;
};
/**
 * Gets the WMJSTimeDimension for given activeLayerId and dimensions list
 * @param layerId: The layer id to search the WMJSDimension for
 * @return: The WMJSDimension if found, otherwise null
 */
var getWMJSTimeDimensionForLayerId = function getWMJSTimeDimensionForLayerId(layerId) {
  var wmLayer = getWMLayerById(layerId);
  if (!wmLayer) {
    return null;
  }
  return wmLayer.getDimension('time');
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateLayerId: generateLayerId,
  generateMapId: generateMapId,
  generateTimesliderId: generateTimesliderId,
  registerWMLayer: registerWMLayer,
  getWMLayerById: getWMLayerById,
  unRegisterWMJSLayer: unRegisterWMJSLayer,
  unRegisterAllWMJSLayersAndMaps: unRegisterAllWMJSLayersAndMaps,
  registerWMJSMap: registerWMJSMap,
  unRegisterWMJSMap: unRegisterWMJSMap,
  getWMJSMapById: getWMJSMapById,
  getWMJSMapIds: getWMJSMapIds,
  getWMJSDimensionForLayerAndDimension: getWMJSDimensionForLayerAndDimension,
  getWMJSTimeDimensionForLayerId: getWMJSTimeDimensionForLayerId
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * */
var defaultReduxLayerRadarColor = {
  service: 'https://testservice',
  name: 'RAD_NL25_PCP_CM',
  title: 'RAD_NL25_PCP_CM',
  format: 'image/png',
  style: 'rainbow/nearest',
  enabled: true,
  layerType: LayerType.mapLayer,
  dimensions: [],
  id: generateLayerId()
};
var multiDimensionLayer = {
  service: 'https://testservice',
  id: 'multiDimensionLayerMock',
  name: 'MULTI_DIMENSION_LAYER',
  title: 'MULTI_DIMENSION_LAYER',
  layerType: LayerType.mapLayer,
  enabled: true,
  dimensions: [{
    name: 'flight level',
    units: 'hft',
    currentValue: '625',
    values: '25,325,625'
  }, {
    name: 'elevation',
    units: 'meters',
    currentValue: '9000',
    values: '1000,5000,9000'
  }, {
    name: 'time',
    units: 'ISO8601',
    currentValue: '2020-03-13T14:40:00Z'
  }]
};
var WmdefaultReduxLayerRadarKNMI = new WMLayer({
  service: 'https://testservice',
  name: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
  title: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
  format: 'image/png',
  style: 'knmiradar/nearest',
  enabled: true,
  layerType: LayerType.mapLayer,
  dimensions: [{
    name: 'time',
    units: 'ISO8601',
    currentValue: '2020-03-13T13:30:00Z'
  }],
  id: 'layerid_3'
});
var defaultReduxLayerRadarKNMI = {
  service: 'https://testservice',
  name: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
  title: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
  format: 'image/png',
  style: 'knmiradar/nearest',
  enabled: true,
  layerType: LayerType.mapLayer,
  dimensions: [{
    name: 'time',
    units: 'ISO8601',
    currentValue: '2020-03-13T13:30:00Z'
  }],
  styles: [{
    title: 'knmiradar/nearest',
    name: 'knmiradar/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=knmiradar/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip/nearest',
    name: 'precip/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip-transparent/nearest',
    name: 'precip-transparent/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip-transparent/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip-gray/nearest',
    name: 'precip-gray/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip-gray/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip-rainbow/nearest',
    name: 'precip-rainbow/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip-rainbow/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip-blue/nearest',
    name: 'precip-blue/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip-blue/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'precip-blue-transparent/nearest',
    name: 'precip-blue-transparent/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=precip-blue-transparent/nearest',
    "abstract": 'No abstract available'
  }, {
    title: 'pseudoradar/nearest',
    name: 'pseudoradar/nearest',
    legendURL: 'https://geoservices.knmi.nl/wms?dataset=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RADNL_OPER_R___25PCPRR_L3_KNMI&format=image/png&STYLE=pseudoradar/nearest',
    "abstract": 'No abstract available'
  }],
  id: 'layerid_2'
};
var makeGeoservicesRadarLayer = function makeGeoservicesRadarLayer(dimensions) {
  return new WMLayer({
    service: 'https://geoservices.knmi.nl/wms?dataset=RADAR&',
    name: 'RAD_NL25_PCP_CM',
    format: 'image/png',
    enabled: true,
    style: 'radar/nearest',
    id: generateLayerId(),
    layerType: LayerType.mapLayer,
    title: 'RAD_NL25_PCP_CM',
    dimensions: dimensions !== null && dimensions !== void 0 ? dimensions : [{
      name: 'time',
      units: 'ISO8601',
      currentValue: '2021-04-15T00:00:00Z'
    }]
  });
};
var WmMultiDimensionLayer = new WMLayer({
  service: 'https://testservice',
  id: 'multiDimensionLayerMock',
  name: 'MULTI_DIMENSION_LAYER',
  title: 'MULTI_DIMENSION_LAYER',
  layerType: LayerType.mapLayer,
  enabled: true,
  dimensions: [{
    name: 'flight level',
    units: 'hft',
    currentValue: '625',
    values: '25,325,625'
  }, {
    name: 'elevation',
    units: 'meters',
    currentValue: '9000',
    values: '1000,5000,9000'
  }, {
    name: 'time',
    units: 'ISO8601',
    currentValue: '2020-03-13T14:40:00Z',
    values: '2020-03-13T10:40:00Z/2020-03-13T14:40:00Z/PT5M'
  }]
});
var layerWithoutTimeDimension = {
  service: 'https://testservice',
  id: 'layerWithoutTime',
  name: 'LAYER_WITHOUT_TIME',
  layerType: LayerType.mapLayer,
  dimensions: [{
    name: 'flight level',
    units: 'hft',
    currentValue: '625',
    values: '25,325,625'
  }]
};
var WmLayerWithoutTimeDimension = new WMLayer(layerWithoutTimeDimension);
var crsListForRADNL25PCPCMLayer = [{
  name: 'EPSG:3411',
  bbox: {
    left: 2682754.74362,
    right: 3759536.917562,
    bottom: -3245034.014141,
    top: -2168251.989038
  }
}, {
  name: 'EPSG:3412',
  bbox: {
    left: 0,
    right: 7413041.166015,
    bottom: 32318824.826266,
    top: 40075258.815074
  }
}, {
  name: 'EPSG:3575',
  bbox: {
    left: -770622.801471,
    right: 56845.766135,
    bottom: -4485814.811314,
    top: -3684039.44362
  }
}, {
  name: 'EPSG:3857',
  bbox: {
    left: 0,
    right: 1208534.698398,
    bottom: 6257115.219364,
    top: 7553161.958695
  }
}, {
  name: 'EPSG:4258',
  bbox: {
    left: 0,
    right: 10.856452,
    bottom: 48.895303,
    top: 55.9736
  }
}, {
  name: 'EPSG:4326',
  bbox: {
    left: 0,
    right: 10.856452,
    bottom: 48.895303,
    top: 55.9736
  }
}, {
  name: 'CRS:84',
  bbox: {
    left: 0,
    right: 10.856452,
    bottom: 48.895303,
    top: 55.9736
  }
}, {
  name: 'EPSG:25831',
  bbox: {
    left: 282182.345905,
    right: 997135.658653,
    bottom: 5433247.394267,
    top: 6207204.592736
  }
}, {
  name: 'EPSG:25832',
  bbox: {
    left: -153083.019482,
    right: 617595.626092,
    bottom: 5415817.312927,
    top: 6239769.309937
  }
}, {
  name: 'EPSG:28992',
  bbox: {
    left: -236275.338083,
    right: 501527.918656,
    bottom: 106727.731651,
    top: 900797.079725
  }
}, {
  name: 'EPSG:7399',
  bbox: {
    left: 0,
    right: 763611.971696,
    bottom: 5757301.056717,
    top: 6483919.801602
  }
}, {
  name: 'EPSG:50001',
  bbox: {
    left: -2000000,
    right: 10000000,
    bottom: -2000000,
    top: 8500000
  }
}, {
  name: 'EPSG:54030',
  bbox: {
    left: 0,
    right: 853649.695106,
    bottom: 5211855.054125,
    top: 5936394.291427
  }
}, {
  name: 'EPSG:32661',
  bbox: {
    left: 2000000,
    right: 2745713.040381,
    bottom: -2703305.597319,
    top: -1888346.21671
  }
}, {
  name: 'EPSG:40000',
  bbox: {
    left: 0,
    right: 750214.326339,
    bottom: -4731695.771951,
    top: -3911817.119426
  }
}, {
  name: 'EPSG:900913',
  bbox: {
    left: 0,
    right: 1208534.698398,
    bottom: 6257115.219364,
    top: 7553161.958695
  }
}, {
  name: 'PROJ4:%2Bproj%3Dstere%20%2Blat_0%3D90%20%2Blon_0%3D0%20%2Blat_ts%3D60%20%2Ba%3D6378%2E14%20%2Bb%3D6356%2E75%20%2Bx_0%3D0%20y_0%3D0',
  bbox: {
    left: 0,
    right: 700.00242,
    bottom: -3649.999338,
    top: -4415.002986
  }
}];
var styleListForRADNL25PCPCMLayer = [{
  title: 'radar/nearest',
  name: 'radar/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=radar/nearest',
  "abstract": 'No abstract available'
}, {
  title: 'precip-rainbow/nearest',
  name: 'precip-rainbow/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=precip-rainbow/nearest',
  "abstract": 'No abstract available'
}, {
  title: 'precip-gray/nearest',
  name: 'precip-gray/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=precip-gray/nearest',
  "abstract": 'No abstract available'
}, {
  title: 'precip-blue/nearest',
  name: 'precip-blue/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=precip-blue/nearest',
  "abstract": 'No abstract available'
}, {
  title: 'precip-blue-transparent/nearest',
  name: 'precip-blue-transparent/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=precip-blue-transparent/nearest',
  "abstract": 'No abstract available'
}, {
  title: 'precip-with-range/nearest',
  name: 'precip-with-range/nearest',
  legendURL: 'https://geoservices.knmi.nl/wms?DATASET=RADAR&SERVICE=WMS&&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=RAD_NL25_PCP_CM&format=image/png&STYLE=precip-with-range/nearest',
  "abstract": 'No abstract available'
}];
var multiDimensionLayer3 = {
  service: 'https://testservicedimensions',
  id: 'multiDimensionLayerMock2',
  name: 'netcdf_5dims',
  layerType: LayerType.mapLayer,
  dimensions: [{
    name: 'member',
    units: 'member number',
    currentValue: 'member1',
    values: 'member1,member2,member3,member4'
  }, {
    name: 'elevation',
    units: 'meters',
    currentValue: '9000',
    values: '1000,5000,9000'
  }, {
    name: 'time',
    units: 'ISO8601',
    currentValue: '2017-01-01T00:25:00Z',
    timeInterval: {
      year: 0,
      month: 0,
      day: 0,
      hour: 0,
      minute: 5,
      second: 0,
      isRegularInterval: true
    }
  }]
};

var testSettings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultReduxLayerRadarColor: defaultReduxLayerRadarColor,
  multiDimensionLayer: multiDimensionLayer,
  WmdefaultReduxLayerRadarKNMI: WmdefaultReduxLayerRadarKNMI,
  defaultReduxLayerRadarKNMI: defaultReduxLayerRadarKNMI,
  makeGeoservicesRadarLayer: makeGeoservicesRadarLayer,
  WmMultiDimensionLayer: WmMultiDimensionLayer,
  layerWithoutTimeDimension: layerWithoutTimeDimension,
  WmLayerWithoutTimeDimension: WmLayerWithoutTimeDimension,
  crsListForRADNL25PCPCMLayer: crsListForRADNL25PCPCMLayer,
  styleListForRADNL25PCPCMLayer: styleListForRADNL25PCPCMLayer,
  multiDimensionLayer3: multiDimensionLayer3
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
var EPSGCode;
(function (EPSGCode) {
  EPSGCode["EPSG3857"] = "EPSG:3857";
  EPSGCode["EPSG28992"] = "EPSG:28992";
  EPSGCode["TODO_EPSG4326"] = "TODO__EPSG:4326";
  EPSGCode["EPSG3411"] = "EPSG:3411";
  EPSGCode["EPSG32661"] = "EPSG:32661";
  EPSGCode["EPSG54030"] = "EPSG:54030";
  EPSGCode["EPSG4326"] = "EPSG:4326";
  EPSGCode["EPSG4258"] = "EPSG:4258";
  EPSGCode["EPSG3412"] = "EPSG:3412";
  EPSGCode["EPSG3575"] = "EPSG:3575";
  EPSGCode["EPSG3067"] = "EPSG:3067";
})(EPSGCode || (EPSGCode = {}));
var tilesettings = {
  WorldMap_Light_Grey_Canvas: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap_Light_Grey_Canvas/EPSG3857/',
      minLevel: 0,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  OpenStreetMap_NL: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OpenStreetMap_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    },
    'EPSG:28992': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OpenStreets_NL/EPSG28992/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  OpenStreets_NL: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OpenStreets_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    },
    'EPSG:28992': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OpenStreets_NL/EPSG28992/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  Positron_NL: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/Positron_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Positron_NL_NoLabels: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/Positron_NL_NoLabels/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Klokantech_Basic_NL: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/Klokantech_Basic_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  Klokantech_Basic_NL_NoLabels: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/Klokantech_Basic_NL_NoLabels/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | OpenMapTiles | Ingmapping'
    }
  },
  OSM_Blossom_NL: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OSM_Blossom_NL/EPSG3857/',
      minLevel: 0,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    }
  },
  WorldMap: {
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG3857/',
      minLevel: 0,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'TODO__EPSG:4326': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG4326/',
      minLevel: 0,
      maxLevel: 9,
      origX: -180,
      origY: 90,
      resolution: 1.422222,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3411': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG3411/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:28992': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG28992/',
      minLevel: 5,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3412': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG3412/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:32661': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG32661/',
      minLevel: 4,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:54030': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG54030/',
      minLevel: 3,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    },
    'EPSG:3575': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/WorldMap/EPSG3575/',
      minLevel: 5,
      maxLevel: 9,
      tileServerType: 'osm',
      copyRight: 'Natural Earth II | Ingmapping'
    }
  },
  OSM_Antarctica: {
    'EPSG:3412': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/OSM_Antarctica/EPSG3412/',
      minLevel: 1,
      maxLevel: 7,
      origX: -3000000,
      origY: 3000000,
      resolution: 23437.5,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors | Ingmapping'
    }
  },
  arcGisCanvas: {
    title: 'ArcGIS canvas map',
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/',
      minLevel: 1,
      maxLevel: 16,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap copyright: 2013 ESRI, DeLorme, NAVTEQ'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/arcgis/rest/services/Basiskaarten/Canvas/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: ESRI Nederland, ESRI, Kadaster, CBS en Rijkswaterstaat'
    },
    'EPSG:3067': {
      home: '',
      minLevel: -1,
      maxLevel: -1,
      tileServerType: 'arcgisonline',
      copyRight: ''
    }
  },
  arcGisTopo: {
    title: 'ArcGIS topo map',
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/',
      minLevel: 1,
      maxLevel: 19,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap sources: ESRI, DeLorme, NAVTEQ, TomTom, Intermap, increment P Corp., GEBCO, USGS, FAO, NPS, NRCAN, GeoBase, IGN, Kadaster NL, Ordnance Survey, ESRI Japan, METI, ESRI China (Hong Kong), and the GIS User Community'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/arcgis/rest/services/Basiskaarten/Topo/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: ESRI Nederland, ESRI, Kadaster, CBS, Min VROM, Rijkswaterstaat en gemeenten: Rotterdam, Breda, Tilburg'
    }
  },
  arcGisOceanBaseMap: {
    'EPSG:3857': {
      title: 'ArcGIS ocean map',
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/',
      minLevel: 1,
      maxLevel: 19,
      tileServerType: 'arcgisonline',
      copyRight: 'Basemap sources: ESRI, GEBCO, NOAA, National Geographic, DeLorme, NAVTEQ, Geonames.org, and other contributors'
    }
  },
  arcGisSat: {
    title: 'ArcGIS satellite map',
    'EPSG:4326': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/ESRI_Imagery_World_2D/MapServer/tile/',
      minLevel: 1,
      maxLevel: 15,
      tileServerType: 'arcgisonline',
      origX: -180,
      origY: 90,
      resolution: 0.3515625,
      tileSize: 512,
      copyRight: 'ESRI'
    },
    'EPSG:3857': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/',
      minLevel: 1,
      maxLevel: 18,
      tileServerType: 'arcgisonline',
      copyRight: 'ESRI'
    }
  },
  OpenStreetMap_Service: {
    title: 'OpenStreetMap Service',
    'EPSG:3857': {
      home: 'https://b.tile.openstreetmap.org/',
      minLevel: 1,
      maxLevel: 16,
      tileServerType: 'osm',
      copyRight: 'OpenStreetMap - contributors'
    },
    'EPSG:28992': {
      home: 'https://services.arcgisonline.com/ArcGIS/rest/services/Basiskaarten/PDOK_BRT/MapServer/tile/',
      minLevel: 1,
      maxLevel: 12,
      origX: -285401.92,
      origY: 903401.92,
      resolution: 3440.64,
      tileServerType: 'arcgisonline',
      copyRight: 'Basiskaart bronnen: PDOK, Kadaster, OpenStreetMap'
    }
  },
  NaturalEarth2: {
    'EPSG:3411': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG3411/',
      minLevel: 1,
      maxLevel: 6,
      origX: -12400000,
      origY: 12400000,
      resolution: 96875,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3412': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG3412/',
      minLevel: 1,
      maxLevel: 6,
      origX: -12400000,
      origY: 12400000,
      resolution: 96875,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3575': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG3575/',
      minLevel: 1,
      maxLevel: 6,
      origX: -13000000,
      origY: 13000000,
      resolution: 101562.5,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:3857': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG3857/',
      minLevel: 1,
      maxLevel: 7,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:4258': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG4326/',
      minLevel: 1,
      maxLevel: 6,
      origX: -180,
      origY: 90,
      resolution: 0.703125,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:4326': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG4326/',
      minLevel: 1,
      maxLevel: 6,
      origX: -180,
      origY: 90,
      resolution: 0.703125,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:28992': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG28992/',
      minLevel: 1,
      maxLevel: 5,
      origX: -2999000,
      origY: 2995500,
      resolution: 23437,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:32661': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG32661/',
      minLevel: 1,
      maxLevel: 7,
      origX: -5000000,
      origY: 4000000,
      resolution: 58593.75,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    },
    'EPSG:54030': {
      home: 'https://geoweb-maps-assets.pmc.knmi.cloud/NaturalEarth2/EPSG54030/',
      minLevel: 1,
      maxLevel: 7,
      origX: -17000000,
      origY: 8625830,
      resolution: 132812.5,
      tileServerType: 'wmst',
      copyRight: 'NPS - Natural Earth II'
    }
  }
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var WMS111GetCapabilitiesGeoServicesRADAR = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<!DOCTYPE WMT_MS_Capabilities SYSTEM \"http://schemas.opengis.net/wms/1.1.1/WMS_MS_Capabilities.dtd\" [\n  <!ELEMENT VendorSpecificCapabilities EMPTY>\n]>\n<!-- end of DOCTYPE declaration -->\n<WMT_MS_Capabilities version=\"1.1.1\">\n   <Service>\n      <Name>OGC:WMS</Name>\n      <Title>RADAR</Title>\n      <Abstract>This service demonstrates how the ADAGUC server can be used to create OGC services.</Abstract>\n      <ServerInfo>ADAGUCServer version 2.5.8, of Apr 13 2021 07:55:43</ServerInfo>\n      <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n      <ContactInformation />\n   </Service>\n   <Capability>\n      <Request>\n         <GetCapabilities>\n            <Format>application/vnd.ogc.wms_xml</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </GetCapabilities>\n         <GetMap>\n            <Format>image/png</Format>\n            <Format>image/gif</Format>\n            <Format>image/png32</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </GetMap>\n         <GetFeatureInfo>\n            <Format>text/plain</Format>\n            <Format>text/html</Format>\n            <Format>text/xml</Format>\n            <Format>application/vnd.ogc.gml</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </GetFeatureInfo>\n         <DescribeLayer>\n            <Format>text/xml</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </DescribeLayer>\n         <GetLegendGraphic>\n            <Format>image/png</Format>\n            <Format>image/gif</Format>\n            <Format>image/png32</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </GetLegendGraphic>\n         <GetStyles>\n            <Format>text/xml</Format>\n            <DCPType>\n               <HTTP>\n                  <Get>\n                     <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;\" />\n                  </Get>\n               </HTTP>\n            </DCPType>\n         </GetStyles>\n      </Request>\n      <Exception>\n         <Format>application/vnd.ogc.se_xml</Format>\n         <Format>application/vnd.ogc.se_inimage</Format>\n         <Format>application/vnd.ogc.se_blank</Format>\n      </Exception>\n      <VendorSpecificCapabilities />\n      <UserDefinedSymbolization SupportSLD=\"1\" UserLayer=\"0\" UserStyle=\"1\" RemoteWFS=\"0\" />\n      <Layer>\n         <Title>WMS of  RADAR</Title>\n         <SRS>EPSG:3411</SRS>\n         <SRS>EPSG:3412</SRS>\n         <SRS>EPSG:3575</SRS>\n         <SRS>EPSG:3857</SRS>\n         <SRS>EPSG:4258</SRS>\n         <SRS>EPSG:4326</SRS>\n         <SRS>CRS:84</SRS>\n         <SRS>EPSG:25831</SRS>\n         <SRS>EPSG:25832</SRS>\n         <SRS>EPSG:28992</SRS>\n         <SRS>EPSG:7399</SRS>\n         <SRS>EPSG:50001</SRS>\n         <SRS>EPSG:54030</SRS>\n         <SRS>EPSG:32661</SRS>\n         <SRS>EPSG:40000</SRS>\n         <SRS>EPSG:900913</SRS>\n         <SRS>PROJ4:%2Bproj%3Dstere%20%2Blat_0%3D90%20%2Blon_0%3D0%20%2Blat_ts%3D60%20%2Ba%3D6378%2E14%20%2Bb%3D6356%2E75%20%2Bx_0%3D0%20y_0%3D0</SRS>\n         <Layer queryable=\"1\" opaque=\"1\" cascaded=\"0\">\n            <Name>RAD_NL25_PCP_CM</Name>\n            <Title>Precipitation Radar NL</Title>\n            <Abstract>Radar NL</Abstract>\n            <KeywordList>\n              <Keyword>Radar</Keyword>\n            </KeywordList>\n            <SRS>EPSG:3411</SRS>\n            <BoundingBox SRS=\"EPSG:3411\" minx=\"2682754.743620\" miny=\"-3245034.014141\" maxx=\"3759536.917562\" maxy=\"-2168251.989038\" />\n            <SRS>EPSG:3412</SRS>\n            <BoundingBox SRS=\"EPSG:3412\" minx=\"0.000000\" miny=\"32318824.826266\" maxx=\"7413041.166015\" maxy=\"40075258.815074\" />\n            <SRS>EPSG:3575</SRS>\n            <BoundingBox SRS=\"EPSG:3575\" minx=\"-770622.801471\" miny=\"-4485814.811314\" maxx=\"56845.766135\" maxy=\"-3684039.443620\" />\n            <SRS>EPSG:3857</SRS>\n            <BoundingBox SRS=\"EPSG:3857\" minx=\"0.000000\" miny=\"6257115.219364\" maxx=\"1208534.698398\" maxy=\"7553161.958695\" />\n            <SRS>EPSG:4258</SRS>\n            <BoundingBox SRS=\"EPSG:4258\" minx=\"0.000000\" miny=\"48.895303\" maxx=\"10.856452\" maxy=\"55.973600\" />\n            <SRS>EPSG:4326</SRS>\n            <BoundingBox SRS=\"EPSG:4326\" minx=\"0.000000\" miny=\"48.895303\" maxx=\"10.856452\" maxy=\"55.973600\" />\n            <SRS>CRS:84</SRS>\n            <BoundingBox SRS=\"CRS:84\" minx=\"0.000000\" miny=\"48.895303\" maxx=\"10.856452\" maxy=\"55.973600\" />\n            <SRS>EPSG:25831</SRS>\n            <BoundingBox SRS=\"EPSG:25831\" minx=\"282182.345905\" miny=\"5433247.394267\" maxx=\"997135.658653\" maxy=\"6207204.592736\" />\n            <SRS>EPSG:25832</SRS>\n            <BoundingBox SRS=\"EPSG:25832\" minx=\"-153083.019482\" miny=\"5415817.312927\" maxx=\"617595.626092\" maxy=\"6239769.309937\" />\n            <SRS>EPSG:28992</SRS>\n            <BoundingBox SRS=\"EPSG:28992\" minx=\"-236275.338083\" miny=\"106727.731651\" maxx=\"501527.918656\" maxy=\"900797.079725\" />\n            <SRS>EPSG:7399</SRS>\n            <BoundingBox SRS=\"EPSG:7399\" minx=\"0.000000\" miny=\"5757301.056717\" maxx=\"763611.971696\" maxy=\"6483919.801602\" />\n            <SRS>EPSG:50001</SRS>\n            <BoundingBox SRS=\"EPSG:50001\" minx=\"-2000000.000000\" miny=\"-2000000.000000\" maxx=\"10000000.000000\" maxy=\"8500000.000000\" />\n            <SRS>EPSG:54030</SRS>\n            <BoundingBox SRS=\"EPSG:54030\" minx=\"0.000000\" miny=\"5211855.054125\" maxx=\"853649.695106\" maxy=\"5936394.291427\" />\n            <SRS>EPSG:32661</SRS>\n            <BoundingBox SRS=\"EPSG:32661\" minx=\"2000000.000000\" miny=\"-2703305.597319\" maxx=\"2745713.040381\" maxy=\"-1888346.216710\" />\n            <SRS>EPSG:40000</SRS>\n            <BoundingBox SRS=\"EPSG:40000\" minx=\"0.000000\" miny=\"-4731695.771951\" maxx=\"750214.326339\" maxy=\"-3911817.119426\" />\n            <SRS>EPSG:900913</SRS>\n            <BoundingBox SRS=\"EPSG:900913\" minx=\"0.000000\" miny=\"6257115.219364\" maxx=\"1208534.698398\" maxy=\"7553161.958695\" />\n            <SRS>PROJ4:%2Bproj%3Dstere%20%2Blat_0%3D90%20%2Blon_0%3D0%20%2Blat_ts%3D60%20%2Ba%3D6378%2E14%20%2Bb%3D6356%2E75%20%2Bx_0%3D0%20y_0%3D0</SRS>\n            <BoundingBox SRS=\"PROJ4:%2Bproj%3Dstere%20%2Blat_0%3D90%20%2Blon_0%3D0%20%2Blat_ts%3D60%20%2Ba%3D6378%2E14%20%2Bb%3D6356%2E75%20%2Bx_0%3D0%20y_0%3D0\" minx=\"0.000000\" miny=\"-3649.999338\" maxx=\"700.002420\" maxy=\"-4415.002986\" />\n            <LatLonBoundingBox minx=\"0.000000\" miny=\"48.895303\" maxx=\"10.856452\" maxy=\"55.973600\" />\n            <Dimension name=\"time\" units=\"ISO8601\" />\n            <Extent name=\"time\" default=\"2021-05-17T00:00:00Z\" multipleValues=\"1\" nearestValue=\"0\">2021-03-31T09:25:00Z/2021-05-18T07:45:00Z/PT5M</Extent>\n            <Style>\n               <Name>radar/nearest</Name>\n               <Title>radar/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=radar/nearest\" />\n               </LegendURL>\n            </Style>\n            <Style>\n               <Name>precip-rainbow/nearest</Name>\n               <Title>precip-rainbow/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=precip-rainbow/nearest\" />\n               </LegendURL>\n            </Style>\n            <Style>\n               <Name>precip-gray/nearest</Name>\n               <Title>precip-gray/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=precip-gray/nearest\" />\n               </LegendURL>\n            </Style>\n            <Style>\n               <Name>precip-blue/nearest</Name>\n               <Title>precip-blue/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=precip-blue/nearest\" />\n               </LegendURL>\n            </Style>\n            <Style>\n               <Name>precip-blue-transparent/nearest</Name>\n               <Title>precip-blue-transparent/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=precip-blue-transparent/nearest\" />\n               </LegendURL>\n            </Style>\n            <Style>\n               <Name>precip-with-range/nearest</Name>\n               <Title>precip-with-range/nearest</Title>\n               <LegendURL width=\"300\" height=\"400\">\n                  <Format>image/png</Format>\n                  <OnlineResource xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:type=\"simple\" xlink:href=\"https://geoservices.knmi.nl/wms?DATASET=RADAR&amp;SERVICE=WMS&amp;&amp;version=1.1.1&amp;service=WMS&amp;request=GetLegendGraphic&amp;layer=RAD_NL25_PCP_CM&amp;format=image/png&amp;STYLE=precip-with-range/nearest\" />\n               </LegendURL>\n            </Style>\n            <ScaleHint min=\"0\" max=\"10000\" />\n         </Layer>\n      </Layer>\n   </Capability>\n</WMT_MS_Capabilities>";

var MOCK_URL_WITH_CHILDREN = 'https://mockUrlWithChildren.nl';
var MOCK_URL_NO_CHILDREN = 'https://mockUrlNoChildren.nl';
var MOCK_URL_WITH_NO_TITLE = 'https://mockUrlWithNoTitle.nl';
var MOCK_URL_WITH_NO_TITLE_OR_NAME = 'https://mockUrlWithNoTitleOrName.nl/wms?';
var MOCK_URL_WITH_SUBCATEGORY = 'https://mockUrlWithSubcategory.nl';
var MOCK_URL_INVALID = 'https://notawmsservice.nl';
var MOCK_URL_SLOW = 'https://slowresolve.nl';
var MOCK_URL_SLOW_FAILS = 'https://slowreject.nl';
var MOCK_URL_DEFAULT = 'https://defaultservice.nl';
var MOCK_URL_DEFAULT2 = 'https://defaultservice2.nl';
var MOCK_URL_HTTP = 'http://wmsservice.nl';
var mockLayersNoChildren = {
  leaf: false,
  name: null,
  title: 'RADNL_OPER_R___25PCPRR_L3_WMS',
  path: [],
  children: []
};
var mockLayersWithChildren = {
  leaf: false,
  name: null,
  title: 'RADNL_OPER_R___25PCPRR_L3_WMS',
  path: [],
  children: [{
    leaf: true,
    name: 'RAD_NL25_PCP_CM',
    title: 'RAD_NL25_PCP_CM',
    path: [],
    children: []
  }, {
    leaf: true,
    name: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
    title: 'RADNL_OPER_R___25PCPRR_L3_KNMI',
    path: [],
    children: []
  }]
};
var mockLayersWithNoTitle = {
  leaf: false,
  name: 'UNTITLED_WMS',
  title: null,
  path: [],
  children: []
};
var mockLayersWithNoTitleOrName = {
  leaf: false,
  name: null,
  title: null,
  path: [],
  children: []
};
var mockLayersWithSubcategory = {
  leaf: false,
  name: null,
  title: 'Service with subcategory',
  path: [],
  children: [{
    leaf: true,
    name: 'cloud_area_fraction',
    title: 'Cloud cover (flag)',
    path: [],
    children: []
  }, {
    leaf: false,
    name: null,
    title: 'Subcategory',
    path: [],
    children: [{
      leaf: true,
      name: 'baselayer',
      title: 'Baselayer (-)',
      path: ['Subcategory'],
      children: []
    }, {
      leaf: false,
      name: null,
      title: 'Klima',
      path: ['Subcategory'],
      children: [{
        leaf: true,
        name: 'haic_airports',
        title: 'HAIC Airports',
        path: ['SubcategoryKlima'],
        children: []
      }]
    }]
  }]
};
var mockLayersDefault = {
  leaf: false,
  name: null,
  title: 'Default title for default layer',
  path: [],
  children: []
};
var mockLayersDefault2 = {
  leaf: false,
  name: null,
  title: 'Default title for default 2 layer',
  path: [],
  children: []
};
var mockGetLayersFromService = function mockGetLayersFromService(url) {
  switch (url) {
    case MOCK_URL_WITH_CHILDREN:
      return new Promise(function (resolve) {
        resolve(mockLayersWithChildren);
      });
    case MOCK_URL_NO_CHILDREN:
      return new Promise(function (resolve) {
        resolve(mockLayersNoChildren);
      });
    case MOCK_URL_WITH_NO_TITLE:
      return new Promise(function (resolve) {
        resolve(mockLayersWithNoTitle);
      });
    case MOCK_URL_WITH_NO_TITLE_OR_NAME:
      return new Promise(function (resolve) {
        resolve(mockLayersWithNoTitleOrName);
      });
    case MOCK_URL_WITH_SUBCATEGORY:
      return new Promise(function (resolve) {
        resolve(mockLayersWithSubcategory);
      });
    case MOCK_URL_SLOW:
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(mockLayersWithChildren);
        }, 300);
      });
    case MOCK_URL_SLOW_FAILS:
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          return reject(new Error("Mock url '".concat(url, "' service returned an error.")));
        }, 300);
      });
    case MOCK_URL_INVALID:
      return Promise.reject(new Error("Url '".concat(url, "' is not a wms service.")));
    case MOCK_URL_HTTP:
      return Promise.reject(new Error("Url '".concat(url, "' is not https.")));
    case MOCK_URL_DEFAULT:
      return new Promise(function (resolve) {
        resolve(mockLayersDefault);
      });
    case MOCK_URL_DEFAULT2:
      return new Promise(function (resolve) {
        resolve(mockLayersDefault2);
      });
    default:
      {
        var message = "Url '".concat(url, "' is not a mock-url.");
        return Promise.reject(new Error(message));
      }
  }
};
var mockGetLayersFlattenedFromService = function mockGetLayersFlattenedFromService(url) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var layers, serviceLayers, _iterator, _step, object;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return mockGetLayersFromService(url);
        case 2:
          layers = _context.sent;
          serviceLayers = []; // TODO: Maarten Plieger, 2022-11-02:  Harmonize types and use correct types: https://gitlab.com/opengeoweb/opengeoweb/-/issues/2817
          _iterator = _createForOfIteratorHelper(layers.children);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              object = _step.value;
              serviceLayers.push({
                name: object.name,
                title: object.title,
                leaf: object.leaf,
                path: object.path,
                keywords: object.keywords ? object.keywords : [],
                "abstract": object["abstract"] ? object["abstract"] : '',
                styles: object.styles ? object.styles : [],
                dimensions: object.dimensions || [],
                geographicBoundingBox: object.geographicBoundingBox || undefined
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context.abrupt("return", serviceLayers);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};

var getCapabilities$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MOCK_URL_WITH_CHILDREN: MOCK_URL_WITH_CHILDREN,
  MOCK_URL_NO_CHILDREN: MOCK_URL_NO_CHILDREN,
  MOCK_URL_WITH_NO_TITLE: MOCK_URL_WITH_NO_TITLE,
  MOCK_URL_WITH_NO_TITLE_OR_NAME: MOCK_URL_WITH_NO_TITLE_OR_NAME,
  MOCK_URL_WITH_SUBCATEGORY: MOCK_URL_WITH_SUBCATEGORY,
  MOCK_URL_INVALID: MOCK_URL_INVALID,
  MOCK_URL_SLOW: MOCK_URL_SLOW,
  MOCK_URL_SLOW_FAILS: MOCK_URL_SLOW_FAILS,
  MOCK_URL_DEFAULT: MOCK_URL_DEFAULT,
  MOCK_URL_DEFAULT2: MOCK_URL_DEFAULT2,
  MOCK_URL_HTTP: MOCK_URL_HTTP,
  mockLayersNoChildren: mockLayersNoChildren,
  mockLayersWithChildren: mockLayersWithChildren,
  mockLayersWithNoTitle: mockLayersWithNoTitle,
  mockLayersWithNoTitleOrName: mockLayersWithNoTitleOrName,
  mockLayersWithSubcategory: mockLayersWithSubcategory,
  mockLayersDefault: mockLayersDefault,
  mockLayersDefault2: mockLayersDefault2,
  mockGetLayersFromService: mockGetLayersFromService,
  mockGetLayersFlattenedFromService: mockGetLayersFlattenedFromService
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * */
var mockGetCapabilities = Object.assign(Object.assign({}, getCapabilities$1), {
  WMS111GetCapabilitiesGeoServicesRADAR: WMS111GetCapabilitiesGeoServicesRADAR
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * */
/**
 * Converts webmapjs node structure to LayerTree
 * @param nodesToRecur THe WebMapJS node structure from service.getNodes();
 */
var recurseNodes = function recurseNodes(nodesToRecur) {
  var newLayerTreeObj = {
    leaf: nodesToRecur.leaf,
    name: nodesToRecur.name,
    title: nodesToRecur.title,
    path: nodesToRecur.path || [],
    children: [],
    keywords: nodesToRecur.keywords || [],
    "abstract": nodesToRecur["abstract"] || '',
    styles: nodesToRecur.styles || [],
    dimensions: nodesToRecur.dimensions || [],
    geographicBoundingBox: nodesToRecur.geographicBoundingBox || null
  };
  if (nodesToRecur.children) {
    for (var j = 0; j < nodesToRecur.children.length; j += 1) {
      newLayerTreeObj.children.push(recurseNodes(nodesToRecur.children[j]));
    }
  }
  return newLayerTreeObj;
};
/**
 * Returns a promise with a hierarchical tree of layers from the WMS GetCapabilities document.
 * @param serviceUrl The URL of the WMS service
 * @param {boolean} forceReload **optional** forceReload: boolean, true will force the layers to be reloaded from the service, defaults to false
 */
var getLayersFromService = function getLayersFromService(serviceUrl) {
  var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    var serviceObject = WMGetServiceFromStore(serviceUrl);
    serviceObject.getNodes(function (nodes) {
      // TODO: Maarten Plieger, 2022-11-02:  Harmonize types and use correct types: https://gitlab.com/opengeoweb/opengeoweb/-/issues/2817
      var layerTree = recurseNodes(nodes);
      resolve(layerTree);
    }, function (error) {
      reject(new Error(error));
    }, forceReload);
  });
};
/**
 * Returns a promise with an array of flattened layerobjects from the WMS GetCapabilities document.
 * @param serviceUrl The URL of the WMS service
 * @param {boolean} forceReload **optional** forceReload: boolean, true will force the layers to be reloaded from the service, defaults to false
 */
var getLayersFlattenedFromService = function getLayersFlattenedFromService(serviceUrl) {
  var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    var serviceObject = WMGetServiceFromStore(serviceUrl);
    serviceObject.getLayerObjectsFlat(function (layers) {
      resolve(layers);
    }, function (error) {
      reject(new Error(error));
    }, forceReload);
  });
};

var getCapabilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  recurseNodes: recurseNodes,
  getLayersFromService: getLayersFromService,
  getLayersFlattenedFromService: getLayersFlattenedFromService
});

export { DateInterval, DebugType, EPSGCode, I18n, LayerType, ParseISOTimeRangeDuration, URLDecode, URLEncode, WMBBOX, WMDateOutSideRange, WMDateTooEarlyString, WMDateTooLateString, WMEmptyLayerName, WMEmptyLayerTitle, WMGetServiceFromStore, WMImage, WMImageEventType, WMJSDimension, WMJSMap, WMJSService, WMJScheckURL, WMLayer, WMProj4Defs, WMSVersion, bgImageStoreLength, buildWMSGetMapRequest, clearImageCache, debugLogger, epsgDescriptionLookup, generateLayerId, generateMapId, generateTimesliderId, getBBOXandProjString, getCapabilities, getLegendGraphicURLForLayer, getMapImageStore, getUriWithParam, getWMJSDimensionForLayerAndDimension, getWMJSMapById, getWMJSMapIds, getWMJSTimeDimensionForLayerId, getWMLayerById, handleMomentISOString, isDefined, isProjectionSupported, legendImageStore, legendImageStoreLength, mapImageStoreLength, mockGetCapabilities, parseISO8601DateToDate, parseISO8601IntervalToDateInterval, registerWMJSMap, registerWMLayer, tilesettings, toArray, unRegisterAllWMJSLayersAndMaps, unRegisterWMJSLayer, unRegisterWMJSMap, testSettings as webmapTestSettings, utils as webmapUtils };
